/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as PolitiqueConfidentialiteRouteImport } from './routes/politique-confidentialite'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as AppdashboardRouteRouteImport } from './routes/_app/(dashboard)/route'
import { Route as AppAchatsRouteRouteImport } from './routes/_app/achats/route'
import { Route as AppAdminRouteRouteImport } from './routes/_app/admin/route'
import { Route as AppComptabiliteRouteRouteImport } from './routes/_app/comptabilite/route'
import { Route as AppCreationRouteRouteImport } from './routes/_app/creation/route'
import { Route as AppParametresRouteRouteImport } from './routes/_app/parametres/route'
import { Route as AppProductionRouteRouteImport } from './routes/_app/production/route'
import { Route as AppRhRouteRouteImport } from './routes/_app/rh/route'
import { Route as AppStockRouteRouteImport } from './routes/_app/stock/route'
import { Route as AppTicketsRouteRouteImport } from './routes/_app/tickets/route'
import { Route as AppVentesRouteRouteImport } from './routes/_app/ventes/route'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthSetupPasswordRouteImport } from './routes/auth/setup-password'
import { Route as AppdashboardIndexRouteImport } from './routes/_app/(dashboard)/index'
import { Route as AppAchatsIndexRouteImport } from './routes/_app/achats/index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppComptabiliteIndexRouteImport } from './routes/_app/comptabilite/index'
import { Route as AppCreationIndexRouteImport } from './routes/_app/creation/index'
import { Route as AppCreationArticlesRouteRouteImport } from './routes/_app/creation/articles/route'
import { Route as AppCreationAteliersRouteRouteImport } from './routes/_app/creation/ateliers/route'
import { Route as AppCreationDossierTechniquesRouteRouteImport } from './routes/_app/creation/dossier-techniques/route'
import { Route as AppCreationFamilleArticlesRouteRouteImport } from './routes/_app/creation/familleArticles/route'
import { Route as AppCreationLdfRouteRouteImport } from './routes/_app/creation/ldf/route'
import { Route as AppCreationPostesRouteRouteImport } from './routes/_app/creation/postes/route'
import { Route as AppCreationPrestationsRouteRouteImport } from './routes/_app/creation/prestations/route'
import { Route as AppCreationUniversCommerciauxRouteRouteImport } from './routes/_app/creation/univers-commerciaux/route'
import { Route as AppDesignSystemShowcaseRouteImport } from './routes/_app/design-system/showcase'
import { Route as AppProductionIndexRouteImport } from './routes/_app/production/index'
import { Route as AppProductionCalculBesoinsRouteRouteImport } from './routes/_app/production/calcul-besoins/route'
import { Route as AppProductionClotureRouteRouteImport } from './routes/_app/production/cloture/route'
import { Route as AppProductionDeclarationsRouteRouteImport } from './routes/_app/production/declarations/route'
import { Route as AppProductionLancementsRouteRouteImport } from './routes/_app/production/lancements/route'
import { Route as AppProductionOrdresFabricationRouteRouteImport } from './routes/_app/production/ordres-fabrication/route'
import { Route as AppRhIndexRouteImport } from './routes/_app/rh/index'
import { Route as AppRhCollaborateursRouteRouteImport } from './routes/_app/rh/collaborateurs/route'
import { Route as AppRhCompetencesRouteRouteImport } from './routes/_app/rh/competences/route'
import { Route as AppRhCongesRouteRouteImport } from './routes/_app/rh/conges/route'
import { Route as AppRhContratsRouteRouteImport } from './routes/_app/rh/contrats/route'
import { Route as AppRhDocumentsRouteRouteImport } from './routes/_app/rh/documents/route'
import { Route as AppRhFeuillesDeTempsRouteRouteImport } from './routes/_app/rh/feuilles-de-temps/route'
import { Route as AppRhHorairesDeTravailRouteRouteImport } from './routes/_app/rh/horaires-de-travail/route'
import { Route as AppRhPlanningRouteRouteImport } from './routes/_app/rh/planning/route'
import { Route as AppStockIndexRouteImport } from './routes/_app/stock/index'
import { Route as AppStockConsultationRouteRouteImport } from './routes/_app/stock/consultation/route'
import { Route as AppStockDepotsRouteRouteImport } from './routes/_app/stock/depots/route'
import { Route as AppStockEmplacementsRouteRouteImport } from './routes/_app/stock/emplacements/route'
import { Route as AppStockInventairesRouteRouteImport } from './routes/_app/stock/inventaires/route'
import { Route as AppStockMouvementsRouteRouteImport } from './routes/_app/stock/mouvements/route'
import { Route as AppStockZonesRouteRouteImport } from './routes/_app/stock/zones/route'
import { Route as AppTicketsIndexRouteImport } from './routes/_app/tickets/index'
import { Route as AppTicketsCreateRouteImport } from './routes/_app/tickets/create'
import { Route as AppVentesIndexRouteImport } from './routes/_app/ventes/index'
import { Route as AuthPointageHashRouteImport } from './routes/auth/pointage/$hash'
import { Route as AuthPointageQrCodeRouteImport } from './routes/auth/pointage/qr-code'
import { Route as AuthSignatureContratTokenRouteImport } from './routes/auth/signature-contrat/$token'
import { Route as AppdashboardCongesNouvelleDemandeRouteImport } from './routes/_app/(dashboard)/conges/nouvelle-demande'
import { Route as AppdashboardFraisIndexRouteImport } from './routes/_app/(dashboard)/frais/index'
import { Route as AppdashboardFraisCreateRouteImport } from './routes/_app/(dashboard)/frais/create'
import { Route as AppdashboardMesCongesIndexRouteImport } from './routes/_app/(dashboard)/mes-conges/index'
import { Route as AppdashboardProfileIndexRouteImport } from './routes/_app/(dashboard)/profile/index'
import { Route as AppAchatsCommandesIndexRouteImport } from './routes/_app/achats/commandes/index'
import { Route as AppAchatsCommandesCreateRouteImport } from './routes/_app/achats/commandes/create'
import { Route as AppAchatsFacturesIndexRouteImport } from './routes/_app/achats/factures/index'
import { Route as AppAchatsFacturesCreateRouteImport } from './routes/_app/achats/factures/create'
import { Route as AppAchatsFournisseursIndexRouteImport } from './routes/_app/achats/fournisseurs/index'
import { Route as AppAchatsFournisseursCreateRouteImport } from './routes/_app/achats/fournisseurs/create'
import { Route as AppAchatsFournituresIndexRouteImport } from './routes/_app/achats/fournitures/index'
import { Route as AppAchatsFournituresCreateRouteImport } from './routes/_app/achats/fournitures/create'
import { Route as AppAchatsPrestationsIndexRouteImport } from './routes/_app/achats/prestations/index'
import { Route as AppAchatsPrestationsCreateRouteImport } from './routes/_app/achats/prestations/create'
import { Route as AppAchatsReceptionsIndexRouteImport } from './routes/_app/achats/receptions/index'
import { Route as AppAchatsReceptionsCreateRouteImport } from './routes/_app/achats/receptions/create'
import { Route as AppAdminPermissionsIndexRouteImport } from './routes/_app/admin/permissions/index'
import { Route as AppAdminProfilesIndexRouteImport } from './routes/_app/admin/profiles/index'
import { Route as AppAdminProfilesCreateRouteImport } from './routes/_app/admin/profiles/create'
import { Route as AppAdminReferenceDataIndexRouteImport } from './routes/_app/admin/reference-data/index'
import { Route as AppComptabiliteEcheancesIndexRouteImport } from './routes/_app/comptabilite/echeances/index'
import { Route as AppComptabiliteEcotaxesIndexRouteImport } from './routes/_app/comptabilite/ecotaxes/index'
import { Route as AppComptabiliteFacturesFournisseursIndexRouteImport } from './routes/_app/comptabilite/factures-fournisseurs/index'
import { Route as AppComptabiliteFacturesVentesIndexRouteImport } from './routes/_app/comptabilite/factures-ventes/index'
import { Route as AppComptabiliteRelancesIndexRouteImport } from './routes/_app/comptabilite/relances/index'
import { Route as AppComptabiliteSimplifieeIndexRouteImport } from './routes/_app/comptabilite/simplifiee/index'
import { Route as AppCreationArticlesIndexRouteImport } from './routes/_app/creation/articles/index'
import { Route as AppCreationArticlesCreateRouteImport } from './routes/_app/creation/articles/create'
import { Route as AppCreationAteliersIndexRouteImport } from './routes/_app/creation/ateliers/index'
import { Route as AppCreationAteliersCreateRouteImport } from './routes/_app/creation/ateliers/create'
import { Route as AppCreationDossierTechniquesIndexRouteImport } from './routes/_app/creation/dossier-techniques/index'
import { Route as AppCreationDossierTechniquesCreateRouteImport } from './routes/_app/creation/dossier-techniques/create'
import { Route as AppCreationFamilleArticlesIndexRouteImport } from './routes/_app/creation/familleArticles/index'
import { Route as AppCreationFamilleArticlesCreateRouteImport } from './routes/_app/creation/familleArticles/create'
import { Route as AppCreationLdfIndexRouteImport } from './routes/_app/creation/ldf/index'
import { Route as AppCreationLdfCreateRouteImport } from './routes/_app/creation/ldf/create'
import { Route as AppCreationPostesIndexRouteImport } from './routes/_app/creation/postes/index'
import { Route as AppCreationPostesCreateRouteImport } from './routes/_app/creation/postes/create'
import { Route as AppCreationPrestationsIndexRouteImport } from './routes/_app/creation/prestations/index'
import { Route as AppCreationPrestationsCreateRouteImport } from './routes/_app/creation/prestations/create'
import { Route as AppCreationUniversCommerciauxIndexRouteImport } from './routes/_app/creation/univers-commerciaux/index'
import { Route as AppCreationUniversCommerciauxCreateRouteImport } from './routes/_app/creation/univers-commerciaux/create'
import { Route as AppProductionCalculBesoinsIndexRouteImport } from './routes/_app/production/calcul-besoins/index'
import { Route as AppProductionClotureIndexRouteImport } from './routes/_app/production/cloture/index'
import { Route as AppProductionDeclarationsIndexRouteImport } from './routes/_app/production/declarations/index'
import { Route as AppProductionLancementsIndexRouteImport } from './routes/_app/production/lancements/index'
import { Route as AppProductionLancementsCreateRouteImport } from './routes/_app/production/lancements/create'
import { Route as AppProductionOrdresFabricationIndexRouteImport } from './routes/_app/production/ordres-fabrication/index'
import { Route as AppProductionOrdresFabricationCreateRouteImport } from './routes/_app/production/ordres-fabrication/create'
import { Route as AppRhCollaborateursIndexRouteImport } from './routes/_app/rh/collaborateurs/index'
import { Route as AppRhCollaborateursCreateRouteImport } from './routes/_app/rh/collaborateurs/create'
import { Route as AppRhCompetencesIndexRouteImport } from './routes/_app/rh/competences/index'
import { Route as AppRhCompetencesCreateRouteImport } from './routes/_app/rh/competences/create'
import { Route as AppRhCongesIndexRouteImport } from './routes/_app/rh/conges/index'
import { Route as AppRhCongesCreateRouteImport } from './routes/_app/rh/conges/create'
import { Route as AppRhContratsIndexRouteImport } from './routes/_app/rh/contrats/index'
import { Route as AppRhContratsCreateRouteImport } from './routes/_app/rh/contrats/create'
import { Route as AppRhDocumentsIndexRouteImport } from './routes/_app/rh/documents/index'
import { Route as AppRhFeuillesDeTempsIndexRouteImport } from './routes/_app/rh/feuilles-de-temps/index'
import { Route as AppRhHorairesDeTravailIndexRouteImport } from './routes/_app/rh/horaires-de-travail/index'
import { Route as AppRhHorairesDeTravailCreateRouteImport } from './routes/_app/rh/horaires-de-travail/create'
import { Route as AppRhNotesDeFraisIndexRouteImport } from './routes/_app/rh/notes-de-frais/index'
import { Route as AppRhNotesDeFraisCreateRouteImport } from './routes/_app/rh/notes-de-frais/create'
import { Route as AppRhPlanningIndexRouteImport } from './routes/_app/rh/planning/index'
import { Route as AppRhPlanningCreateRouteImport } from './routes/_app/rh/planning/create'
import { Route as AppStockConsultationIndexRouteImport } from './routes/_app/stock/consultation/index'
import { Route as AppStockDepotsCreateRouteImport } from './routes/_app/stock/depots/create'
import { Route as AppStockEmplacementsIndexRouteImport } from './routes/_app/stock/emplacements/index'
import { Route as AppStockEmplacementsCreateRouteImport } from './routes/_app/stock/emplacements/create'
import { Route as AppStockInventairesIndexRouteImport } from './routes/_app/stock/inventaires/index'
import { Route as AppStockInventairesCreateRouteImport } from './routes/_app/stock/inventaires/create'
import { Route as AppStockMouvementsIndexRouteImport } from './routes/_app/stock/mouvements/index'
import { Route as AppStockMouvementsCreateRouteImport } from './routes/_app/stock/mouvements/create'
import { Route as AppStockZonesIndexRouteImport } from './routes/_app/stock/zones/index'
import { Route as AppStockZonesCreateRouteImport } from './routes/_app/stock/zones/create'
import { Route as AppTicketsIdEditRouteImport } from './routes/_app/tickets/$id/edit'
import { Route as AppTicketsIdViewRouteImport } from './routes/_app/tickets/$id/view'
import { Route as AppVentesCategoriesIndexRouteImport } from './routes/_app/ventes/categories/index'
import { Route as AppVentesCategoriesCreateRouteImport } from './routes/_app/ventes/categories/create'
import { Route as AppVentesClientsIndexRouteImport } from './routes/_app/ventes/clients/index'
import { Route as AppVentesClientsCreateRouteImport } from './routes/_app/ventes/clients/create'
import { Route as AppVentesCommandesIndexRouteImport } from './routes/_app/ventes/commandes/index'
import { Route as AppVentesCommandesCreateRouteImport } from './routes/_app/ventes/commandes/create'
import { Route as AppVentesCrmIndexRouteImport } from './routes/_app/ventes/crm/index'
import { Route as AppVentesCrmCreateRouteImport } from './routes/_app/ventes/crm/create'
import { Route as AppVentesExpeditionsIndexRouteImport } from './routes/_app/ventes/expeditions/index'
import { Route as AppVentesExpeditionsCreateRouteImport } from './routes/_app/ventes/expeditions/create'
import { Route as AppVentesFacturationIndexRouteImport } from './routes/_app/ventes/facturation/index'
import { Route as AppVentesFacturationCreateRouteImport } from './routes/_app/ventes/facturation/create'
import { Route as AppVentesTarifsIndexRouteImport } from './routes/_app/ventes/tarifs/index'
import { Route as AppVentesTarifsCreateRouteImport } from './routes/_app/ventes/tarifs/create'
import { Route as AppdashboardCongesMeIndexRouteImport } from './routes/_app/(dashboard)/conges/me/index'
import { Route as AppdashboardContratsMeIndexRouteImport } from './routes/_app/(dashboard)/contrats/me/index'
import { Route as AppdashboardDocumentsMeIndexRouteImport } from './routes/_app/(dashboard)/documents/me/index'
import { Route as AppdashboardFraisIdEditRouteImport } from './routes/_app/(dashboard)/frais/$id/edit'
import { Route as AppdashboardFraisIdViewRouteImport } from './routes/_app/(dashboard)/frais/$id/view'
import { Route as AppdashboardFraisMeIndexRouteImport } from './routes/_app/(dashboard)/frais/me/index'
import { Route as AppdashboardPlanningMeIndexRouteImport } from './routes/_app/(dashboard)/planning/me/index'
import { Route as AppdashboardPointageMeIndexRouteImport } from './routes/_app/(dashboard)/pointage/me/index'
import { Route as AppAchatsCommandesIdEditRouteImport } from './routes/_app/achats/commandes/$id/edit'
import { Route as AppAchatsCommandesIdViewRouteImport } from './routes/_app/achats/commandes/$id/view'
import { Route as AppAchatsFacturesIdEditRouteImport } from './routes/_app/achats/factures/$id/edit'
import { Route as AppAchatsFacturesIdViewRouteImport } from './routes/_app/achats/factures/$id/view'
import { Route as AppAchatsFournisseursIdEditRouteImport } from './routes/_app/achats/fournisseurs/$id/edit'
import { Route as AppAchatsFournisseursIdViewRouteImport } from './routes/_app/achats/fournisseurs/$id/view'
import { Route as AppAchatsFournituresIdEditRouteImport } from './routes/_app/achats/fournitures/$id/edit'
import { Route as AppAchatsFournituresIdViewRouteImport } from './routes/_app/achats/fournitures/$id/view'
import { Route as AppAchatsPrestationsIdEditRouteImport } from './routes/_app/achats/prestations/$id/edit'
import { Route as AppAchatsPrestationsIdViewRouteImport } from './routes/_app/achats/prestations/$id/view'
import { Route as AppAchatsReceptionsIdEditRouteImport } from './routes/_app/achats/receptions/$id/edit'
import { Route as AppAchatsReceptionsIdViewRouteImport } from './routes/_app/achats/receptions/$id/view'
import { Route as AppAdminProfilesIdEditRouteImport } from './routes/_app/admin/profiles/$id/edit'
import { Route as AppComptabiliteFacturesFournisseursIdViewRouteImport } from './routes/_app/comptabilite/factures-fournisseurs/$id/view'
import { Route as AppComptabiliteFacturesVentesIdViewRouteImport } from './routes/_app/comptabilite/factures-ventes/$id/view'
import { Route as AppComptabiliteRelancesIdViewRouteImport } from './routes/_app/comptabilite/relances/$id/view'
import { Route as AppCreationArticlesIdEditRouteImport } from './routes/_app/creation/articles/$id/edit'
import { Route as AppCreationArticlesIdViewRouteImport } from './routes/_app/creation/articles/$id/view'
import { Route as AppCreationAteliersIdEditRouteImport } from './routes/_app/creation/ateliers/$id/edit'
import { Route as AppCreationAteliersIdViewRouteImport } from './routes/_app/creation/ateliers/$id/view'
import { Route as AppCreationDossierTechniquesIdEditRouteImport } from './routes/_app/creation/dossier-techniques/$id/edit'
import { Route as AppCreationDossierTechniquesIdViewRouteImport } from './routes/_app/creation/dossier-techniques/$id/view'
import { Route as AppCreationFamilleArticlesIdEditRouteImport } from './routes/_app/creation/familleArticles/$id/edit'
import { Route as AppCreationFamilleArticlesIdViewRouteImport } from './routes/_app/creation/familleArticles/$id/view'
import { Route as AppCreationLdfIdEditRouteImport } from './routes/_app/creation/ldf/$id/edit'
import { Route as AppCreationLdfIdViewRouteImport } from './routes/_app/creation/ldf/$id/view'
import { Route as AppCreationPostesIdEditRouteImport } from './routes/_app/creation/postes/$id/edit'
import { Route as AppCreationPostesIdViewRouteImport } from './routes/_app/creation/postes/$id/view'
import { Route as AppCreationPrestationsIdEditRouteImport } from './routes/_app/creation/prestations/$id/edit'
import { Route as AppCreationPrestationsIdViewRouteImport } from './routes/_app/creation/prestations/$id/view'
import { Route as AppCreationUniversCommerciauxIdEditRouteImport } from './routes/_app/creation/univers-commerciaux/$id/edit'
import { Route as AppCreationUniversCommerciauxIdViewRouteImport } from './routes/_app/creation/univers-commerciaux/$id/view'
import { Route as AppProductionLancementsIdIndexRouteImport } from './routes/_app/production/lancements/$id/index'
import { Route as AppProductionLancementsIdEditRouteImport } from './routes/_app/production/lancements/$id/edit'
import { Route as AppProductionOrdresFabricationIdIndexRouteImport } from './routes/_app/production/ordres-fabrication/$id/index'
import { Route as AppProductionOrdresFabricationIdEditRouteImport } from './routes/_app/production/ordres-fabrication/$id/edit'
import { Route as AppRhCollaborateursIdIndexRouteImport } from './routes/_app/rh/collaborateurs/$id/index'
import { Route as AppRhCollaborateursIdEditRouteImport } from './routes/_app/rh/collaborateurs/$id/edit'
import { Route as AppRhCollaborateursIdViewRouteRouteImport } from './routes/_app/rh/collaborateurs/$id/view/route'
import { Route as AppRhCompetencesIdEditRouteImport } from './routes/_app/rh/competences/$id/edit'
import { Route as AppRhCompetencesIdViewRouteImport } from './routes/_app/rh/competences/$id/view'
import { Route as AppRhCongesIdViewRouteImport } from './routes/_app/rh/conges/$id/view'
import { Route as AppRhCongesDemandesNewRouteImport } from './routes/_app/rh/conges/demandes/new'
import { Route as AppRhContratsIdEditRouteImport } from './routes/_app/rh/contrats/$id/edit'
import { Route as AppRhContratsIdViewRouteImport } from './routes/_app/rh/contrats/$id/view'
import { Route as AppRhHorairesDeTravailIdEditRouteImport } from './routes/_app/rh/horaires-de-travail/$id/edit'
import { Route as AppRhHorairesDeTravailIdViewRouteImport } from './routes/_app/rh/horaires-de-travail/$id/view'
import { Route as AppRhNotesDeFraisIdEditRouteImport } from './routes/_app/rh/notes-de-frais/$id/edit'
import { Route as AppRhNotesDeFraisIdViewRouteImport } from './routes/_app/rh/notes-de-frais/$id/view'
import { Route as AppRhPlanningIdEditRouteImport } from './routes/_app/rh/planning/$id/edit'
import { Route as AppRhPlanningIdViewRouteImport } from './routes/_app/rh/planning/$id/view'
import { Route as AppStockDepotsIdEditRouteImport } from './routes/_app/stock/depots/$id/edit'
import { Route as AppStockDepotsIdViewRouteImport } from './routes/_app/stock/depots/$id/view'
import { Route as AppStockEmplacementsIdEditRouteImport } from './routes/_app/stock/emplacements/$id/edit'
import { Route as AppStockEmplacementsIdViewRouteImport } from './routes/_app/stock/emplacements/$id/view'
import { Route as AppStockInventairesIdEditRouteImport } from './routes/_app/stock/inventaires/$id/edit'
import { Route as AppStockInventairesIdViewRouteImport } from './routes/_app/stock/inventaires/$id/view'
import { Route as AppStockMouvementsIdEditRouteImport } from './routes/_app/stock/mouvements/$id/edit'
import { Route as AppStockMouvementsIdViewRouteImport } from './routes/_app/stock/mouvements/$id/view'
import { Route as AppStockZonesIdEditRouteImport } from './routes/_app/stock/zones/$id/edit'
import { Route as AppStockZonesIdViewRouteImport } from './routes/_app/stock/zones/$id/view'
import { Route as AppVentesCategoriesIdEditRouteImport } from './routes/_app/ventes/categories/$id/edit'
import { Route as AppVentesCategoriesIdViewRouteImport } from './routes/_app/ventes/categories/$id/view'
import { Route as AppVentesClientsIdEditRouteImport } from './routes/_app/ventes/clients/$id/edit'
import { Route as AppVentesClientsIdViewRouteImport } from './routes/_app/ventes/clients/$id/view'
import { Route as AppVentesCommandesIdEditRouteImport } from './routes/_app/ventes/commandes/$id/edit'
import { Route as AppVentesCommandesIdViewRouteImport } from './routes/_app/ventes/commandes/$id/view'
import { Route as AppVentesCrmIdEditRouteImport } from './routes/_app/ventes/crm/$id/edit'
import { Route as AppVentesCrmIdViewRouteImport } from './routes/_app/ventes/crm/$id/view'
import { Route as AppVentesExpeditionsIdEditRouteImport } from './routes/_app/ventes/expeditions/$id/edit'
import { Route as AppVentesExpeditionsIdViewRouteImport } from './routes/_app/ventes/expeditions/$id/view'
import { Route as AppVentesFacturationIdEditRouteImport } from './routes/_app/ventes/facturation/$id/edit'
import { Route as AppVentesFacturationIdViewRouteImport } from './routes/_app/ventes/facturation/$id/view'
import { Route as AppVentesTarifsIdEditRouteImport } from './routes/_app/ventes/tarifs/$id/edit'
import { Route as AppVentesTarifsIdViewRouteImport } from './routes/_app/ventes/tarifs/$id/view'
import { Route as AppVentesTarifsPromotionsCreateRouteImport } from './routes/_app/ventes/tarifs/promotions/create'
import { Route as AppVentesTarifsRemisesCreateRouteImport } from './routes/_app/ventes/tarifs/remises/create'
import { Route as AppVentesTarifsTaxesCreateRouteImport } from './routes/_app/ventes/tarifs/taxes/create'
import { Route as AppRhContratsIdAvenantsCreateRouteImport } from './routes/_app/rh/contrats/$id/avenants/create'
import { Route as AppVentesTarifsPromotionsIdEditRouteImport } from './routes/_app/ventes/tarifs/promotions/$id/edit'
import { Route as AppVentesTarifsPromotionsIdViewRouteImport } from './routes/_app/ventes/tarifs/promotions/$id/view'
import { Route as AppVentesTarifsRemisesIdEditRouteImport } from './routes/_app/ventes/tarifs/remises/$id/edit'
import { Route as AppVentesTarifsRemisesIdViewRouteImport } from './routes/_app/ventes/tarifs/remises/$id/view'
import { Route as AppVentesTarifsTaxesIdEditRouteImport } from './routes/_app/ventes/tarifs/taxes/$id/edit'
import { Route as AppVentesTarifsTaxesIdViewRouteImport } from './routes/_app/ventes/tarifs/taxes/$id/view'
import { Route as AppRhContratsIdAvenantsAvenantIdEditRouteImport } from './routes/_app/rh/contrats/$id/avenants/$avenantId/edit'
import { Route as AppRhContratsIdAvenantsAvenantIdViewRouteImport } from './routes/_app/rh/contrats/$id/avenants/$avenantId/view'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
  id: '/mentions-legales',
  path: '/mentions-legales',
  getParentRoute: () => rootRouteImport,
} as any)
const PolitiqueConfidentialiteRoute =
  PolitiqueConfidentialiteRouteImport.update({
    id: '/politique-confidentialite',
    path: '/politique-confidentialite',
    getParentRoute: () => rootRouteImport,
  } as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const AppdashboardRouteRoute = AppdashboardRouteRouteImport.update({
  id: '/(dashboard)',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAchatsRouteRoute = AppAchatsRouteRouteImport.update({
  id: '/achats',
  path: '/achats',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppComptabiliteRouteRoute = AppComptabiliteRouteRouteImport.update({
  id: '/comptabilite',
  path: '/comptabilite',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCreationRouteRoute = AppCreationRouteRouteImport.update({
  id: '/creation',
  path: '/creation',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppParametresRouteRoute = AppParametresRouteRouteImport.update({
  id: '/parametres',
  path: '/parametres',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProductionRouteRoute = AppProductionRouteRouteImport.update({
  id: '/production',
  path: '/production',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRhRouteRoute = AppRhRouteRouteImport.update({
  id: '/rh',
  path: '/rh',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppStockRouteRoute = AppStockRouteRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTicketsRouteRoute = AppTicketsRouteRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppVentesRouteRoute = AppVentesRouteRouteImport.update({
  id: '/ventes',
  path: '/ventes',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSetupPasswordRoute = AuthSetupPasswordRouteImport.update({
  id: '/setup-password',
  path: '/setup-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppdashboardIndexRoute = AppdashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppdashboardRouteRoute,
} as any)
const AppAchatsIndexRoute = AppAchatsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAchatsRouteRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppComptabiliteIndexRoute = AppComptabiliteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppComptabiliteRouteRoute,
} as any)
const AppCreationIndexRoute = AppCreationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCreationRouteRoute,
} as any)
const AppCreationArticlesRouteRoute =
  AppCreationArticlesRouteRouteImport.update({
    id: '/articles',
    path: '/articles',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppCreationAteliersRouteRoute =
  AppCreationAteliersRouteRouteImport.update({
    id: '/ateliers',
    path: '/ateliers',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppCreationDossierTechniquesRouteRoute =
  AppCreationDossierTechniquesRouteRouteImport.update({
    id: '/dossier-techniques',
    path: '/dossier-techniques',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppCreationFamilleArticlesRouteRoute =
  AppCreationFamilleArticlesRouteRouteImport.update({
    id: '/familleArticles',
    path: '/familleArticles',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppCreationLdfRouteRoute = AppCreationLdfRouteRouteImport.update({
  id: '/ldf',
  path: '/ldf',
  getParentRoute: () => AppCreationRouteRoute,
} as any)
const AppCreationPostesRouteRoute = AppCreationPostesRouteRouteImport.update({
  id: '/postes',
  path: '/postes',
  getParentRoute: () => AppCreationRouteRoute,
} as any)
const AppCreationPrestationsRouteRoute =
  AppCreationPrestationsRouteRouteImport.update({
    id: '/prestations',
    path: '/prestations',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppCreationUniversCommerciauxRouteRoute =
  AppCreationUniversCommerciauxRouteRouteImport.update({
    id: '/univers-commerciaux',
    path: '/univers-commerciaux',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppDesignSystemShowcaseRoute = AppDesignSystemShowcaseRouteImport.update({
  id: '/design-system/showcase',
  path: '/design-system/showcase',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProductionIndexRoute = AppProductionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProductionRouteRoute,
} as any)
const AppProductionCalculBesoinsRouteRoute =
  AppProductionCalculBesoinsRouteRouteImport.update({
    id: '/calcul-besoins',
    path: '/calcul-besoins',
    getParentRoute: () => AppProductionRouteRoute,
  } as any)
const AppProductionClotureRouteRoute =
  AppProductionClotureRouteRouteImport.update({
    id: '/cloture',
    path: '/cloture',
    getParentRoute: () => AppProductionRouteRoute,
  } as any)
const AppProductionDeclarationsRouteRoute =
  AppProductionDeclarationsRouteRouteImport.update({
    id: '/declarations',
    path: '/declarations',
    getParentRoute: () => AppProductionRouteRoute,
  } as any)
const AppProductionLancementsRouteRoute =
  AppProductionLancementsRouteRouteImport.update({
    id: '/lancements',
    path: '/lancements',
    getParentRoute: () => AppProductionRouteRoute,
  } as any)
const AppProductionOrdresFabricationRouteRoute =
  AppProductionOrdresFabricationRouteRouteImport.update({
    id: '/ordres-fabrication',
    path: '/ordres-fabrication',
    getParentRoute: () => AppProductionRouteRoute,
  } as any)
const AppRhIndexRoute = AppRhIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhCollaborateursRouteRoute =
  AppRhCollaborateursRouteRouteImport.update({
    id: '/collaborateurs',
    path: '/collaborateurs',
    getParentRoute: () => AppRhRouteRoute,
  } as any)
const AppRhCompetencesRouteRoute = AppRhCompetencesRouteRouteImport.update({
  id: '/competences',
  path: '/competences',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhCongesRouteRoute = AppRhCongesRouteRouteImport.update({
  id: '/conges',
  path: '/conges',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhContratsRouteRoute = AppRhContratsRouteRouteImport.update({
  id: '/contrats',
  path: '/contrats',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhDocumentsRouteRoute = AppRhDocumentsRouteRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhFeuillesDeTempsRouteRoute =
  AppRhFeuillesDeTempsRouteRouteImport.update({
    id: '/feuilles-de-temps',
    path: '/feuilles-de-temps',
    getParentRoute: () => AppRhRouteRoute,
  } as any)
const AppRhHorairesDeTravailRouteRoute =
  AppRhHorairesDeTravailRouteRouteImport.update({
    id: '/horaires-de-travail',
    path: '/horaires-de-travail',
    getParentRoute: () => AppRhRouteRoute,
  } as any)
const AppRhPlanningRouteRoute = AppRhPlanningRouteRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppStockIndexRoute = AppStockIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStockRouteRoute,
} as any)
const AppStockConsultationRouteRoute =
  AppStockConsultationRouteRouteImport.update({
    id: '/consultation',
    path: '/consultation',
    getParentRoute: () => AppStockRouteRoute,
  } as any)
const AppStockDepotsRouteRoute = AppStockDepotsRouteRouteImport.update({
  id: '/depots',
  path: '/depots',
  getParentRoute: () => AppStockRouteRoute,
} as any)
const AppStockEmplacementsRouteRoute =
  AppStockEmplacementsRouteRouteImport.update({
    id: '/emplacements',
    path: '/emplacements',
    getParentRoute: () => AppStockRouteRoute,
  } as any)
const AppStockInventairesRouteRoute =
  AppStockInventairesRouteRouteImport.update({
    id: '/inventaires',
    path: '/inventaires',
    getParentRoute: () => AppStockRouteRoute,
  } as any)
const AppStockMouvementsRouteRoute = AppStockMouvementsRouteRouteImport.update({
  id: '/mouvements',
  path: '/mouvements',
  getParentRoute: () => AppStockRouteRoute,
} as any)
const AppStockZonesRouteRoute = AppStockZonesRouteRouteImport.update({
  id: '/zones',
  path: '/zones',
  getParentRoute: () => AppStockRouteRoute,
} as any)
const AppTicketsIndexRoute = AppTicketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTicketsRouteRoute,
} as any)
const AppTicketsCreateRoute = AppTicketsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppTicketsRouteRoute,
} as any)
const AppVentesIndexRoute = AppVentesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AuthPointageHashRoute = AuthPointageHashRouteImport.update({
  id: '/pointage/$hash',
  path: '/pointage/$hash',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthPointageQrCodeRoute = AuthPointageQrCodeRouteImport.update({
  id: '/pointage/qr-code',
  path: '/pointage/qr-code',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignatureContratTokenRoute =
  AuthSignatureContratTokenRouteImport.update({
    id: '/signature-contrat/$token',
    path: '/signature-contrat/$token',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AppdashboardCongesNouvelleDemandeRoute =
  AppdashboardCongesNouvelleDemandeRouteImport.update({
    id: '/conges/nouvelle-demande',
    path: '/conges/nouvelle-demande',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardFraisIndexRoute = AppdashboardFraisIndexRouteImport.update({
  id: '/frais/',
  path: '/frais/',
  getParentRoute: () => AppdashboardRouteRoute,
} as any)
const AppdashboardFraisCreateRoute = AppdashboardFraisCreateRouteImport.update({
  id: '/frais/create',
  path: '/frais/create',
  getParentRoute: () => AppdashboardRouteRoute,
} as any)
const AppdashboardMesCongesIndexRoute =
  AppdashboardMesCongesIndexRouteImport.update({
    id: '/mes-conges/',
    path: '/mes-conges/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardProfileIndexRoute =
  AppdashboardProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppAchatsCommandesIndexRoute = AppAchatsCommandesIndexRouteImport.update({
  id: '/commandes/',
  path: '/commandes/',
  getParentRoute: () => AppAchatsRouteRoute,
} as any)
const AppAchatsCommandesCreateRoute =
  AppAchatsCommandesCreateRouteImport.update({
    id: '/commandes/create',
    path: '/commandes/create',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFacturesIndexRoute = AppAchatsFacturesIndexRouteImport.update({
  id: '/factures/',
  path: '/factures/',
  getParentRoute: () => AppAchatsRouteRoute,
} as any)
const AppAchatsFacturesCreateRoute = AppAchatsFacturesCreateRouteImport.update({
  id: '/factures/create',
  path: '/factures/create',
  getParentRoute: () => AppAchatsRouteRoute,
} as any)
const AppAchatsFournisseursIndexRoute =
  AppAchatsFournisseursIndexRouteImport.update({
    id: '/fournisseurs/',
    path: '/fournisseurs/',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFournisseursCreateRoute =
  AppAchatsFournisseursCreateRouteImport.update({
    id: '/fournisseurs/create',
    path: '/fournisseurs/create',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFournituresIndexRoute =
  AppAchatsFournituresIndexRouteImport.update({
    id: '/fournitures/',
    path: '/fournitures/',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFournituresCreateRoute =
  AppAchatsFournituresCreateRouteImport.update({
    id: '/fournitures/create',
    path: '/fournitures/create',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsPrestationsIndexRoute =
  AppAchatsPrestationsIndexRouteImport.update({
    id: '/prestations/',
    path: '/prestations/',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsPrestationsCreateRoute =
  AppAchatsPrestationsCreateRouteImport.update({
    id: '/prestations/create',
    path: '/prestations/create',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsReceptionsIndexRoute =
  AppAchatsReceptionsIndexRouteImport.update({
    id: '/receptions/',
    path: '/receptions/',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsReceptionsCreateRoute =
  AppAchatsReceptionsCreateRouteImport.update({
    id: '/receptions/create',
    path: '/receptions/create',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAdminPermissionsIndexRoute =
  AppAdminPermissionsIndexRouteImport.update({
    id: '/permissions/',
    path: '/permissions/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminProfilesIndexRoute = AppAdminProfilesIndexRouteImport.update({
  id: '/profiles/',
  path: '/profiles/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminProfilesCreateRoute = AppAdminProfilesCreateRouteImport.update({
  id: '/profiles/create',
  path: '/profiles/create',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminReferenceDataIndexRoute =
  AppAdminReferenceDataIndexRouteImport.update({
    id: '/reference-data/',
    path: '/reference-data/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppComptabiliteEcheancesIndexRoute =
  AppComptabiliteEcheancesIndexRouteImport.update({
    id: '/echeances/',
    path: '/echeances/',
    getParentRoute: () => AppComptabiliteRouteRoute,
  } as any)
const AppComptabiliteEcotaxesIndexRoute =
  AppComptabiliteEcotaxesIndexRouteImport.update({
    id: '/ecotaxes/',
    path: '/ecotaxes/',
    getParentRoute: () => AppComptabiliteRouteRoute,
  } as any)
const AppComptabiliteFacturesFournisseursIndexRoute =
  AppComptabiliteFacturesFournisseursIndexRouteImport.update({
    id: '/factures-fournisseurs/',
    path: '/factures-fournisseurs/',
    getParentRoute: () => AppComptabiliteRouteRoute,
  } as any)
const AppComptabiliteFacturesVentesIndexRoute =
  AppComptabiliteFacturesVentesIndexRouteImport.update({
    id: '/factures-ventes/',
    path: '/factures-ventes/',
    getParentRoute: () => AppComptabiliteRouteRoute,
  } as any)
const AppComptabiliteRelancesIndexRoute =
  AppComptabiliteRelancesIndexRouteImport.update({
    id: '/relances/',
    path: '/relances/',
    getParentRoute: () => AppComptabiliteRouteRoute,
  } as any)
const AppComptabiliteSimplifieeIndexRoute =
  AppComptabiliteSimplifieeIndexRouteImport.update({
    id: '/simplifiee/',
    path: '/simplifiee/',
    getParentRoute: () => AppComptabiliteRouteRoute,
  } as any)
const AppCreationArticlesIndexRoute =
  AppCreationArticlesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationArticlesRouteRoute,
  } as any)
const AppCreationArticlesCreateRoute =
  AppCreationArticlesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationArticlesRouteRoute,
  } as any)
const AppCreationAteliersIndexRoute =
  AppCreationAteliersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationAteliersRouteRoute,
  } as any)
const AppCreationAteliersCreateRoute =
  AppCreationAteliersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationAteliersRouteRoute,
  } as any)
const AppCreationDossierTechniquesIndexRoute =
  AppCreationDossierTechniquesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationDossierTechniquesRouteRoute,
  } as any)
const AppCreationDossierTechniquesCreateRoute =
  AppCreationDossierTechniquesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationDossierTechniquesRouteRoute,
  } as any)
const AppCreationFamilleArticlesIndexRoute =
  AppCreationFamilleArticlesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationFamilleArticlesRouteRoute,
  } as any)
const AppCreationFamilleArticlesCreateRoute =
  AppCreationFamilleArticlesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationFamilleArticlesRouteRoute,
  } as any)
const AppCreationLdfIndexRoute = AppCreationLdfIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCreationLdfRouteRoute,
} as any)
const AppCreationLdfCreateRoute = AppCreationLdfCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppCreationLdfRouteRoute,
} as any)
const AppCreationPostesIndexRoute = AppCreationPostesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCreationPostesRouteRoute,
} as any)
const AppCreationPostesCreateRoute = AppCreationPostesCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppCreationPostesRouteRoute,
} as any)
const AppCreationPrestationsIndexRoute =
  AppCreationPrestationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationPrestationsRouteRoute,
  } as any)
const AppCreationPrestationsCreateRoute =
  AppCreationPrestationsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationPrestationsRouteRoute,
  } as any)
const AppCreationUniversCommerciauxIndexRoute =
  AppCreationUniversCommerciauxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationUniversCommerciauxRouteRoute,
  } as any)
const AppCreationUniversCommerciauxCreateRoute =
  AppCreationUniversCommerciauxCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationUniversCommerciauxRouteRoute,
  } as any)
const AppProductionCalculBesoinsIndexRoute =
  AppProductionCalculBesoinsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProductionCalculBesoinsRouteRoute,
  } as any)
const AppProductionClotureIndexRoute =
  AppProductionClotureIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProductionClotureRouteRoute,
  } as any)
const AppProductionDeclarationsIndexRoute =
  AppProductionDeclarationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProductionDeclarationsRouteRoute,
  } as any)
const AppProductionLancementsIndexRoute =
  AppProductionLancementsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProductionLancementsRouteRoute,
  } as any)
const AppProductionLancementsCreateRoute =
  AppProductionLancementsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppProductionLancementsRouteRoute,
  } as any)
const AppProductionOrdresFabricationIndexRoute =
  AppProductionOrdresFabricationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProductionOrdresFabricationRouteRoute,
  } as any)
const AppProductionOrdresFabricationCreateRoute =
  AppProductionOrdresFabricationCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppProductionOrdresFabricationRouteRoute,
  } as any)
const AppRhCollaborateursIndexRoute =
  AppRhCollaborateursIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppRhCollaborateursRouteRoute,
  } as any)
const AppRhCollaborateursCreateRoute =
  AppRhCollaborateursCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppRhCollaborateursRouteRoute,
  } as any)
const AppRhCompetencesIndexRoute = AppRhCompetencesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhCompetencesRouteRoute,
} as any)
const AppRhCompetencesCreateRoute = AppRhCompetencesCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppRhCompetencesRouteRoute,
} as any)
const AppRhCongesIndexRoute = AppRhCongesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhCongesRouteRoute,
} as any)
const AppRhCongesCreateRoute = AppRhCongesCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppRhCongesRouteRoute,
} as any)
const AppRhContratsIndexRoute = AppRhContratsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhContratsRouteRoute,
} as any)
const AppRhContratsCreateRoute = AppRhContratsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppRhContratsRouteRoute,
} as any)
const AppRhDocumentsIndexRoute = AppRhDocumentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhDocumentsRouteRoute,
} as any)
const AppRhFeuillesDeTempsIndexRoute =
  AppRhFeuillesDeTempsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppRhFeuillesDeTempsRouteRoute,
  } as any)
const AppRhHorairesDeTravailIndexRoute =
  AppRhHorairesDeTravailIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppRhHorairesDeTravailRouteRoute,
  } as any)
const AppRhHorairesDeTravailCreateRoute =
  AppRhHorairesDeTravailCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppRhHorairesDeTravailRouteRoute,
  } as any)
const AppRhNotesDeFraisIndexRoute = AppRhNotesDeFraisIndexRouteImport.update({
  id: '/notes-de-frais/',
  path: '/notes-de-frais/',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhNotesDeFraisCreateRoute = AppRhNotesDeFraisCreateRouteImport.update({
  id: '/notes-de-frais/create',
  path: '/notes-de-frais/create',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhPlanningIndexRoute = AppRhPlanningIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhPlanningRouteRoute,
} as any)
const AppRhPlanningCreateRoute = AppRhPlanningCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppRhPlanningRouteRoute,
} as any)
const AppStockConsultationIndexRoute =
  AppStockConsultationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStockConsultationRouteRoute,
  } as any)
const AppStockDepotsCreateRoute = AppStockDepotsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppStockDepotsRouteRoute,
} as any)
const AppStockEmplacementsIndexRoute =
  AppStockEmplacementsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStockEmplacementsRouteRoute,
  } as any)
const AppStockEmplacementsCreateRoute =
  AppStockEmplacementsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppStockEmplacementsRouteRoute,
  } as any)
const AppStockInventairesIndexRoute =
  AppStockInventairesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStockInventairesRouteRoute,
  } as any)
const AppStockInventairesCreateRoute =
  AppStockInventairesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppStockInventairesRouteRoute,
  } as any)
const AppStockMouvementsIndexRoute = AppStockMouvementsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStockMouvementsRouteRoute,
} as any)
const AppStockMouvementsCreateRoute =
  AppStockMouvementsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppStockMouvementsRouteRoute,
  } as any)
const AppStockZonesIndexRoute = AppStockZonesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStockZonesRouteRoute,
} as any)
const AppStockZonesCreateRoute = AppStockZonesCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppStockZonesRouteRoute,
} as any)
const AppTicketsIdEditRoute = AppTicketsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppTicketsRouteRoute,
} as any)
const AppTicketsIdViewRoute = AppTicketsIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppTicketsRouteRoute,
} as any)
const AppVentesCategoriesIndexRoute =
  AppVentesCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesCategoriesCreateRoute =
  AppVentesCategoriesCreateRouteImport.update({
    id: '/categories/create',
    path: '/categories/create',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesClientsIndexRoute = AppVentesClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesClientsCreateRoute = AppVentesClientsCreateRouteImport.update({
  id: '/clients/create',
  path: '/clients/create',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesCommandesIndexRoute = AppVentesCommandesIndexRouteImport.update({
  id: '/commandes/',
  path: '/commandes/',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesCommandesCreateRoute =
  AppVentesCommandesCreateRouteImport.update({
    id: '/commandes/create',
    path: '/commandes/create',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesCrmIndexRoute = AppVentesCrmIndexRouteImport.update({
  id: '/crm/',
  path: '/crm/',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesCrmCreateRoute = AppVentesCrmCreateRouteImport.update({
  id: '/crm/create',
  path: '/crm/create',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesExpeditionsIndexRoute =
  AppVentesExpeditionsIndexRouteImport.update({
    id: '/expeditions/',
    path: '/expeditions/',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesExpeditionsCreateRoute =
  AppVentesExpeditionsCreateRouteImport.update({
    id: '/expeditions/create',
    path: '/expeditions/create',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesFacturationIndexRoute =
  AppVentesFacturationIndexRouteImport.update({
    id: '/facturation/',
    path: '/facturation/',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesFacturationCreateRoute =
  AppVentesFacturationCreateRouteImport.update({
    id: '/facturation/create',
    path: '/facturation/create',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesTarifsIndexRoute = AppVentesTarifsIndexRouteImport.update({
  id: '/tarifs/',
  path: '/tarifs/',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesTarifsCreateRoute = AppVentesTarifsCreateRouteImport.update({
  id: '/tarifs/create',
  path: '/tarifs/create',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppdashboardCongesMeIndexRoute =
  AppdashboardCongesMeIndexRouteImport.update({
    id: '/conges/me/',
    path: '/conges/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardContratsMeIndexRoute =
  AppdashboardContratsMeIndexRouteImport.update({
    id: '/contrats/me/',
    path: '/contrats/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardDocumentsMeIndexRoute =
  AppdashboardDocumentsMeIndexRouteImport.update({
    id: '/documents/me/',
    path: '/documents/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardFraisIdEditRoute = AppdashboardFraisIdEditRouteImport.update({
  id: '/frais/$id/edit',
  path: '/frais/$id/edit',
  getParentRoute: () => AppdashboardRouteRoute,
} as any)
const AppdashboardFraisIdViewRoute = AppdashboardFraisIdViewRouteImport.update({
  id: '/frais/$id/view',
  path: '/frais/$id/view',
  getParentRoute: () => AppdashboardRouteRoute,
} as any)
const AppdashboardFraisMeIndexRoute =
  AppdashboardFraisMeIndexRouteImport.update({
    id: '/frais/me/',
    path: '/frais/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardPlanningMeIndexRoute =
  AppdashboardPlanningMeIndexRouteImport.update({
    id: '/planning/me/',
    path: '/planning/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardPointageMeIndexRoute =
  AppdashboardPointageMeIndexRouteImport.update({
    id: '/pointage/me/',
    path: '/pointage/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppAchatsCommandesIdEditRoute =
  AppAchatsCommandesIdEditRouteImport.update({
    id: '/commandes/$id/edit',
    path: '/commandes/$id/edit',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsCommandesIdViewRoute =
  AppAchatsCommandesIdViewRouteImport.update({
    id: '/commandes/$id/view',
    path: '/commandes/$id/view',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFacturesIdEditRoute = AppAchatsFacturesIdEditRouteImport.update({
  id: '/factures/$id/edit',
  path: '/factures/$id/edit',
  getParentRoute: () => AppAchatsRouteRoute,
} as any)
const AppAchatsFacturesIdViewRoute = AppAchatsFacturesIdViewRouteImport.update({
  id: '/factures/$id/view',
  path: '/factures/$id/view',
  getParentRoute: () => AppAchatsRouteRoute,
} as any)
const AppAchatsFournisseursIdEditRoute =
  AppAchatsFournisseursIdEditRouteImport.update({
    id: '/fournisseurs/$id/edit',
    path: '/fournisseurs/$id/edit',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFournisseursIdViewRoute =
  AppAchatsFournisseursIdViewRouteImport.update({
    id: '/fournisseurs/$id/view',
    path: '/fournisseurs/$id/view',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFournituresIdEditRoute =
  AppAchatsFournituresIdEditRouteImport.update({
    id: '/fournitures/$id/edit',
    path: '/fournitures/$id/edit',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFournituresIdViewRoute =
  AppAchatsFournituresIdViewRouteImport.update({
    id: '/fournitures/$id/view',
    path: '/fournitures/$id/view',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsPrestationsIdEditRoute =
  AppAchatsPrestationsIdEditRouteImport.update({
    id: '/prestations/$id/edit',
    path: '/prestations/$id/edit',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsPrestationsIdViewRoute =
  AppAchatsPrestationsIdViewRouteImport.update({
    id: '/prestations/$id/view',
    path: '/prestations/$id/view',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsReceptionsIdEditRoute =
  AppAchatsReceptionsIdEditRouteImport.update({
    id: '/receptions/$id/edit',
    path: '/receptions/$id/edit',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsReceptionsIdViewRoute =
  AppAchatsReceptionsIdViewRouteImport.update({
    id: '/receptions/$id/view',
    path: '/receptions/$id/view',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAdminProfilesIdEditRoute = AppAdminProfilesIdEditRouteImport.update({
  id: '/profiles/$id/edit',
  path: '/profiles/$id/edit',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppComptabiliteFacturesFournisseursIdViewRoute =
  AppComptabiliteFacturesFournisseursIdViewRouteImport.update({
    id: '/factures-fournisseurs/$id/view',
    path: '/factures-fournisseurs/$id/view',
    getParentRoute: () => AppComptabiliteRouteRoute,
  } as any)
const AppComptabiliteFacturesVentesIdViewRoute =
  AppComptabiliteFacturesVentesIdViewRouteImport.update({
    id: '/factures-ventes/$id/view',
    path: '/factures-ventes/$id/view',
    getParentRoute: () => AppComptabiliteRouteRoute,
  } as any)
const AppComptabiliteRelancesIdViewRoute =
  AppComptabiliteRelancesIdViewRouteImport.update({
    id: '/relances/$id/view',
    path: '/relances/$id/view',
    getParentRoute: () => AppComptabiliteRouteRoute,
  } as any)
const AppCreationArticlesIdEditRoute =
  AppCreationArticlesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationArticlesRouteRoute,
  } as any)
const AppCreationArticlesIdViewRoute =
  AppCreationArticlesIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationArticlesRouteRoute,
  } as any)
const AppCreationAteliersIdEditRoute =
  AppCreationAteliersIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationAteliersRouteRoute,
  } as any)
const AppCreationAteliersIdViewRoute =
  AppCreationAteliersIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationAteliersRouteRoute,
  } as any)
const AppCreationDossierTechniquesIdEditRoute =
  AppCreationDossierTechniquesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationDossierTechniquesRouteRoute,
  } as any)
const AppCreationDossierTechniquesIdViewRoute =
  AppCreationDossierTechniquesIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationDossierTechniquesRouteRoute,
  } as any)
const AppCreationFamilleArticlesIdEditRoute =
  AppCreationFamilleArticlesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationFamilleArticlesRouteRoute,
  } as any)
const AppCreationFamilleArticlesIdViewRoute =
  AppCreationFamilleArticlesIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationFamilleArticlesRouteRoute,
  } as any)
const AppCreationLdfIdEditRoute = AppCreationLdfIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppCreationLdfRouteRoute,
} as any)
const AppCreationLdfIdViewRoute = AppCreationLdfIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppCreationLdfRouteRoute,
} as any)
const AppCreationPostesIdEditRoute = AppCreationPostesIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppCreationPostesRouteRoute,
} as any)
const AppCreationPostesIdViewRoute = AppCreationPostesIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppCreationPostesRouteRoute,
} as any)
const AppCreationPrestationsIdEditRoute =
  AppCreationPrestationsIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationPrestationsRouteRoute,
  } as any)
const AppCreationPrestationsIdViewRoute =
  AppCreationPrestationsIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationPrestationsRouteRoute,
  } as any)
const AppCreationUniversCommerciauxIdEditRoute =
  AppCreationUniversCommerciauxIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationUniversCommerciauxRouteRoute,
  } as any)
const AppCreationUniversCommerciauxIdViewRoute =
  AppCreationUniversCommerciauxIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationUniversCommerciauxRouteRoute,
  } as any)
const AppProductionLancementsIdIndexRoute =
  AppProductionLancementsIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AppProductionLancementsRouteRoute,
  } as any)
const AppProductionLancementsIdEditRoute =
  AppProductionLancementsIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppProductionLancementsRouteRoute,
  } as any)
const AppProductionOrdresFabricationIdIndexRoute =
  AppProductionOrdresFabricationIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AppProductionOrdresFabricationRouteRoute,
  } as any)
const AppProductionOrdresFabricationIdEditRoute =
  AppProductionOrdresFabricationIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppProductionOrdresFabricationRouteRoute,
  } as any)
const AppRhCollaborateursIdIndexRoute =
  AppRhCollaborateursIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AppRhCollaborateursRouteRoute,
  } as any)
const AppRhCollaborateursIdEditRoute =
  AppRhCollaborateursIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppRhCollaborateursRouteRoute,
  } as any)
const AppRhCollaborateursIdViewRouteRoute =
  AppRhCollaborateursIdViewRouteRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppRhCollaborateursRouteRoute,
  } as any)
const AppRhCompetencesIdEditRoute = AppRhCompetencesIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppRhCompetencesRouteRoute,
} as any)
const AppRhCompetencesIdViewRoute = AppRhCompetencesIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppRhCompetencesRouteRoute,
} as any)
const AppRhCongesIdViewRoute = AppRhCongesIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppRhCongesRouteRoute,
} as any)
const AppRhCongesDemandesNewRoute = AppRhCongesDemandesNewRouteImport.update({
  id: '/demandes/new',
  path: '/demandes/new',
  getParentRoute: () => AppRhCongesRouteRoute,
} as any)
const AppRhContratsIdEditRoute = AppRhContratsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppRhContratsRouteRoute,
} as any)
const AppRhContratsIdViewRoute = AppRhContratsIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppRhContratsRouteRoute,
} as any)
const AppRhHorairesDeTravailIdEditRoute =
  AppRhHorairesDeTravailIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppRhHorairesDeTravailRouteRoute,
  } as any)
const AppRhHorairesDeTravailIdViewRoute =
  AppRhHorairesDeTravailIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppRhHorairesDeTravailRouteRoute,
  } as any)
const AppRhNotesDeFraisIdEditRoute = AppRhNotesDeFraisIdEditRouteImport.update({
  id: '/notes-de-frais/$id/edit',
  path: '/notes-de-frais/$id/edit',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhNotesDeFraisIdViewRoute = AppRhNotesDeFraisIdViewRouteImport.update({
  id: '/notes-de-frais/$id/view',
  path: '/notes-de-frais/$id/view',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhPlanningIdEditRoute = AppRhPlanningIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppRhPlanningRouteRoute,
} as any)
const AppRhPlanningIdViewRoute = AppRhPlanningIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppRhPlanningRouteRoute,
} as any)
const AppStockDepotsIdEditRoute = AppStockDepotsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppStockDepotsRouteRoute,
} as any)
const AppStockDepotsIdViewRoute = AppStockDepotsIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppStockDepotsRouteRoute,
} as any)
const AppStockEmplacementsIdEditRoute =
  AppStockEmplacementsIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppStockEmplacementsRouteRoute,
  } as any)
const AppStockEmplacementsIdViewRoute =
  AppStockEmplacementsIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppStockEmplacementsRouteRoute,
  } as any)
const AppStockInventairesIdEditRoute =
  AppStockInventairesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppStockInventairesRouteRoute,
  } as any)
const AppStockInventairesIdViewRoute =
  AppStockInventairesIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppStockInventairesRouteRoute,
  } as any)
const AppStockMouvementsIdEditRoute =
  AppStockMouvementsIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppStockMouvementsRouteRoute,
  } as any)
const AppStockMouvementsIdViewRoute =
  AppStockMouvementsIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppStockMouvementsRouteRoute,
  } as any)
const AppStockZonesIdEditRoute = AppStockZonesIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppStockZonesRouteRoute,
} as any)
const AppStockZonesIdViewRoute = AppStockZonesIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppStockZonesRouteRoute,
} as any)
const AppVentesCategoriesIdEditRoute =
  AppVentesCategoriesIdEditRouteImport.update({
    id: '/categories/$id/edit',
    path: '/categories/$id/edit',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesCategoriesIdViewRoute =
  AppVentesCategoriesIdViewRouteImport.update({
    id: '/categories/$id/view',
    path: '/categories/$id/view',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesClientsIdEditRoute = AppVentesClientsIdEditRouteImport.update({
  id: '/clients/$id/edit',
  path: '/clients/$id/edit',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesClientsIdViewRoute = AppVentesClientsIdViewRouteImport.update({
  id: '/clients/$id/view',
  path: '/clients/$id/view',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesCommandesIdEditRoute =
  AppVentesCommandesIdEditRouteImport.update({
    id: '/commandes/$id/edit',
    path: '/commandes/$id/edit',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesCommandesIdViewRoute =
  AppVentesCommandesIdViewRouteImport.update({
    id: '/commandes/$id/view',
    path: '/commandes/$id/view',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesCrmIdEditRoute = AppVentesCrmIdEditRouteImport.update({
  id: '/crm/$id/edit',
  path: '/crm/$id/edit',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesCrmIdViewRoute = AppVentesCrmIdViewRouteImport.update({
  id: '/crm/$id/view',
  path: '/crm/$id/view',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesExpeditionsIdEditRoute =
  AppVentesExpeditionsIdEditRouteImport.update({
    id: '/expeditions/$id/edit',
    path: '/expeditions/$id/edit',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesExpeditionsIdViewRoute =
  AppVentesExpeditionsIdViewRouteImport.update({
    id: '/expeditions/$id/view',
    path: '/expeditions/$id/view',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesFacturationIdEditRoute =
  AppVentesFacturationIdEditRouteImport.update({
    id: '/facturation/$id/edit',
    path: '/facturation/$id/edit',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesFacturationIdViewRoute =
  AppVentesFacturationIdViewRouteImport.update({
    id: '/facturation/$id/view',
    path: '/facturation/$id/view',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesTarifsIdEditRoute = AppVentesTarifsIdEditRouteImport.update({
  id: '/tarifs/$id/edit',
  path: '/tarifs/$id/edit',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesTarifsIdViewRoute = AppVentesTarifsIdViewRouteImport.update({
  id: '/tarifs/$id/view',
  path: '/tarifs/$id/view',
  getParentRoute: () => AppVentesRouteRoute,
} as any)
const AppVentesTarifsPromotionsCreateRoute =
  AppVentesTarifsPromotionsCreateRouteImport.update({
    id: '/tarifs/promotions/create',
    path: '/tarifs/promotions/create',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesTarifsRemisesCreateRoute =
  AppVentesTarifsRemisesCreateRouteImport.update({
    id: '/tarifs/remises/create',
    path: '/tarifs/remises/create',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesTarifsTaxesCreateRoute =
  AppVentesTarifsTaxesCreateRouteImport.update({
    id: '/tarifs/taxes/create',
    path: '/tarifs/taxes/create',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppRhContratsIdAvenantsCreateRoute =
  AppRhContratsIdAvenantsCreateRouteImport.update({
    id: '/$id/avenants/create',
    path: '/$id/avenants/create',
    getParentRoute: () => AppRhContratsRouteRoute,
  } as any)
const AppVentesTarifsPromotionsIdEditRoute =
  AppVentesTarifsPromotionsIdEditRouteImport.update({
    id: '/tarifs/promotions/$id/edit',
    path: '/tarifs/promotions/$id/edit',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesTarifsPromotionsIdViewRoute =
  AppVentesTarifsPromotionsIdViewRouteImport.update({
    id: '/tarifs/promotions/$id/view',
    path: '/tarifs/promotions/$id/view',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesTarifsRemisesIdEditRoute =
  AppVentesTarifsRemisesIdEditRouteImport.update({
    id: '/tarifs/remises/$id/edit',
    path: '/tarifs/remises/$id/edit',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesTarifsRemisesIdViewRoute =
  AppVentesTarifsRemisesIdViewRouteImport.update({
    id: '/tarifs/remises/$id/view',
    path: '/tarifs/remises/$id/view',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesTarifsTaxesIdEditRoute =
  AppVentesTarifsTaxesIdEditRouteImport.update({
    id: '/tarifs/taxes/$id/edit',
    path: '/tarifs/taxes/$id/edit',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppVentesTarifsTaxesIdViewRoute =
  AppVentesTarifsTaxesIdViewRouteImport.update({
    id: '/tarifs/taxes/$id/view',
    path: '/tarifs/taxes/$id/view',
    getParentRoute: () => AppVentesRouteRoute,
  } as any)
const AppRhContratsIdAvenantsAvenantIdEditRoute =
  AppRhContratsIdAvenantsAvenantIdEditRouteImport.update({
    id: '/$id/avenants/$avenantId/edit',
    path: '/$id/avenants/$avenantId/edit',
    getParentRoute: () => AppRhContratsRouteRoute,
  } as any)
const AppRhContratsIdAvenantsAvenantIdViewRoute =
  AppRhContratsIdAvenantsAvenantIdViewRouteImport.update({
    id: '/$id/avenants/$avenantId/view',
    path: '/$id/avenants/$avenantId/view',
    getParentRoute: () => AppRhContratsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppdashboardIndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/mentions-legales': typeof MentionsLegalesRoute
  '/politique-confidentialite': typeof PolitiqueConfidentialiteRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/achats': typeof AppAchatsRouteRouteWithChildren
  '/admin': typeof AppAdminRouteRouteWithChildren
  '/comptabilite': typeof AppComptabiliteRouteRouteWithChildren
  '/creation': typeof AppCreationRouteRouteWithChildren
  '/parametres': typeof AppParametresRouteRoute
  '/production': typeof AppProductionRouteRouteWithChildren
  '/rh': typeof AppRhRouteRouteWithChildren
  '/stock': typeof AppStockRouteRouteWithChildren
  '/tickets': typeof AppTicketsRouteRouteWithChildren
  '/ventes': typeof AppVentesRouteRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/setup-password': typeof AuthSetupPasswordRoute
  '/creation/articles': typeof AppCreationArticlesRouteRouteWithChildren
  '/creation/ateliers': typeof AppCreationAteliersRouteRouteWithChildren
  '/creation/dossier-techniques': typeof AppCreationDossierTechniquesRouteRouteWithChildren
  '/creation/familleArticles': typeof AppCreationFamilleArticlesRouteRouteWithChildren
  '/creation/ldf': typeof AppCreationLdfRouteRouteWithChildren
  '/creation/postes': typeof AppCreationPostesRouteRouteWithChildren
  '/creation/prestations': typeof AppCreationPrestationsRouteRouteWithChildren
  '/creation/univers-commerciaux': typeof AppCreationUniversCommerciauxRouteRouteWithChildren
  '/production/calcul-besoins': typeof AppProductionCalculBesoinsRouteRouteWithChildren
  '/production/cloture': typeof AppProductionClotureRouteRouteWithChildren
  '/production/declarations': typeof AppProductionDeclarationsRouteRouteWithChildren
  '/production/lancements': typeof AppProductionLancementsRouteRouteWithChildren
  '/production/ordres-fabrication': typeof AppProductionOrdresFabricationRouteRouteWithChildren
  '/rh/collaborateurs': typeof AppRhCollaborateursRouteRouteWithChildren
  '/rh/competences': typeof AppRhCompetencesRouteRouteWithChildren
  '/rh/conges': typeof AppRhCongesRouteRouteWithChildren
  '/rh/contrats': typeof AppRhContratsRouteRouteWithChildren
  '/rh/documents': typeof AppRhDocumentsRouteRouteWithChildren
  '/rh/feuilles-de-temps': typeof AppRhFeuillesDeTempsRouteRouteWithChildren
  '/rh/horaires-de-travail': typeof AppRhHorairesDeTravailRouteRouteWithChildren
  '/rh/planning': typeof AppRhPlanningRouteRouteWithChildren
  '/stock/consultation': typeof AppStockConsultationRouteRouteWithChildren
  '/stock/depots': typeof AppStockDepotsRouteRouteWithChildren
  '/stock/emplacements': typeof AppStockEmplacementsRouteRouteWithChildren
  '/stock/inventaires': typeof AppStockInventairesRouteRouteWithChildren
  '/stock/mouvements': typeof AppStockMouvementsRouteRouteWithChildren
  '/stock/zones': typeof AppStockZonesRouteRouteWithChildren
  '/design-system/showcase': typeof AppDesignSystemShowcaseRoute
  '/tickets/create': typeof AppTicketsCreateRoute
  '/auth/pointage/$hash': typeof AuthPointageHashRoute
  '/auth/pointage/qr-code': typeof AuthPointageQrCodeRoute
  '/auth/signature-contrat/$token': typeof AuthSignatureContratTokenRoute
  '/achats/': typeof AppAchatsIndexRoute
  '/admin/': typeof AppAdminIndexRoute
  '/comptabilite/': typeof AppComptabiliteIndexRoute
  '/creation/': typeof AppCreationIndexRoute
  '/production/': typeof AppProductionIndexRoute
  '/rh/': typeof AppRhIndexRoute
  '/stock/': typeof AppStockIndexRoute
  '/tickets/': typeof AppTicketsIndexRoute
  '/ventes/': typeof AppVentesIndexRoute
  '/conges/nouvelle-demande': typeof AppdashboardCongesNouvelleDemandeRoute
  '/frais/create': typeof AppdashboardFraisCreateRoute
  '/achats/commandes/create': typeof AppAchatsCommandesCreateRoute
  '/achats/factures/create': typeof AppAchatsFacturesCreateRoute
  '/achats/fournisseurs/create': typeof AppAchatsFournisseursCreateRoute
  '/achats/fournitures/create': typeof AppAchatsFournituresCreateRoute
  '/achats/prestations/create': typeof AppAchatsPrestationsCreateRoute
  '/achats/receptions/create': typeof AppAchatsReceptionsCreateRoute
  '/admin/profiles/create': typeof AppAdminProfilesCreateRoute
  '/creation/articles/create': typeof AppCreationArticlesCreateRoute
  '/creation/ateliers/create': typeof AppCreationAteliersCreateRoute
  '/creation/dossier-techniques/create': typeof AppCreationDossierTechniquesCreateRoute
  '/creation/familleArticles/create': typeof AppCreationFamilleArticlesCreateRoute
  '/creation/ldf/create': typeof AppCreationLdfCreateRoute
  '/creation/postes/create': typeof AppCreationPostesCreateRoute
  '/creation/prestations/create': typeof AppCreationPrestationsCreateRoute
  '/creation/univers-commerciaux/create': typeof AppCreationUniversCommerciauxCreateRoute
  '/production/lancements/create': typeof AppProductionLancementsCreateRoute
  '/production/ordres-fabrication/create': typeof AppProductionOrdresFabricationCreateRoute
  '/rh/collaborateurs/create': typeof AppRhCollaborateursCreateRoute
  '/rh/competences/create': typeof AppRhCompetencesCreateRoute
  '/rh/conges/create': typeof AppRhCongesCreateRoute
  '/rh/contrats/create': typeof AppRhContratsCreateRoute
  '/rh/horaires-de-travail/create': typeof AppRhHorairesDeTravailCreateRoute
  '/rh/notes-de-frais/create': typeof AppRhNotesDeFraisCreateRoute
  '/rh/planning/create': typeof AppRhPlanningCreateRoute
  '/stock/depots/create': typeof AppStockDepotsCreateRoute
  '/stock/emplacements/create': typeof AppStockEmplacementsCreateRoute
  '/stock/inventaires/create': typeof AppStockInventairesCreateRoute
  '/stock/mouvements/create': typeof AppStockMouvementsCreateRoute
  '/stock/zones/create': typeof AppStockZonesCreateRoute
  '/tickets/$id/edit': typeof AppTicketsIdEditRoute
  '/tickets/$id/view': typeof AppTicketsIdViewRoute
  '/ventes/categories/create': typeof AppVentesCategoriesCreateRoute
  '/ventes/clients/create': typeof AppVentesClientsCreateRoute
  '/ventes/commandes/create': typeof AppVentesCommandesCreateRoute
  '/ventes/crm/create': typeof AppVentesCrmCreateRoute
  '/ventes/expeditions/create': typeof AppVentesExpeditionsCreateRoute
  '/ventes/facturation/create': typeof AppVentesFacturationCreateRoute
  '/ventes/tarifs/create': typeof AppVentesTarifsCreateRoute
  '/frais/': typeof AppdashboardFraisIndexRoute
  '/mes-conges/': typeof AppdashboardMesCongesIndexRoute
  '/profile/': typeof AppdashboardProfileIndexRoute
  '/achats/commandes/': typeof AppAchatsCommandesIndexRoute
  '/achats/factures/': typeof AppAchatsFacturesIndexRoute
  '/achats/fournisseurs/': typeof AppAchatsFournisseursIndexRoute
  '/achats/fournitures/': typeof AppAchatsFournituresIndexRoute
  '/achats/prestations/': typeof AppAchatsPrestationsIndexRoute
  '/achats/receptions/': typeof AppAchatsReceptionsIndexRoute
  '/admin/permissions/': typeof AppAdminPermissionsIndexRoute
  '/admin/profiles/': typeof AppAdminProfilesIndexRoute
  '/admin/reference-data/': typeof AppAdminReferenceDataIndexRoute
  '/comptabilite/echeances/': typeof AppComptabiliteEcheancesIndexRoute
  '/comptabilite/ecotaxes/': typeof AppComptabiliteEcotaxesIndexRoute
  '/comptabilite/factures-fournisseurs/': typeof AppComptabiliteFacturesFournisseursIndexRoute
  '/comptabilite/factures-ventes/': typeof AppComptabiliteFacturesVentesIndexRoute
  '/comptabilite/relances/': typeof AppComptabiliteRelancesIndexRoute
  '/comptabilite/simplifiee/': typeof AppComptabiliteSimplifieeIndexRoute
  '/creation/articles/': typeof AppCreationArticlesIndexRoute
  '/creation/ateliers/': typeof AppCreationAteliersIndexRoute
  '/creation/dossier-techniques/': typeof AppCreationDossierTechniquesIndexRoute
  '/creation/familleArticles/': typeof AppCreationFamilleArticlesIndexRoute
  '/creation/ldf/': typeof AppCreationLdfIndexRoute
  '/creation/postes/': typeof AppCreationPostesIndexRoute
  '/creation/prestations/': typeof AppCreationPrestationsIndexRoute
  '/creation/univers-commerciaux/': typeof AppCreationUniversCommerciauxIndexRoute
  '/production/calcul-besoins/': typeof AppProductionCalculBesoinsIndexRoute
  '/production/cloture/': typeof AppProductionClotureIndexRoute
  '/production/declarations/': typeof AppProductionDeclarationsIndexRoute
  '/production/lancements/': typeof AppProductionLancementsIndexRoute
  '/production/ordres-fabrication/': typeof AppProductionOrdresFabricationIndexRoute
  '/rh/collaborateurs/': typeof AppRhCollaborateursIndexRoute
  '/rh/competences/': typeof AppRhCompetencesIndexRoute
  '/rh/conges/': typeof AppRhCongesIndexRoute
  '/rh/contrats/': typeof AppRhContratsIndexRoute
  '/rh/documents/': typeof AppRhDocumentsIndexRoute
  '/rh/feuilles-de-temps/': typeof AppRhFeuillesDeTempsIndexRoute
  '/rh/horaires-de-travail/': typeof AppRhHorairesDeTravailIndexRoute
  '/rh/notes-de-frais/': typeof AppRhNotesDeFraisIndexRoute
  '/rh/planning/': typeof AppRhPlanningIndexRoute
  '/stock/consultation/': typeof AppStockConsultationIndexRoute
  '/stock/emplacements/': typeof AppStockEmplacementsIndexRoute
  '/stock/inventaires/': typeof AppStockInventairesIndexRoute
  '/stock/mouvements/': typeof AppStockMouvementsIndexRoute
  '/stock/zones/': typeof AppStockZonesIndexRoute
  '/ventes/categories/': typeof AppVentesCategoriesIndexRoute
  '/ventes/clients/': typeof AppVentesClientsIndexRoute
  '/ventes/commandes/': typeof AppVentesCommandesIndexRoute
  '/ventes/crm/': typeof AppVentesCrmIndexRoute
  '/ventes/expeditions/': typeof AppVentesExpeditionsIndexRoute
  '/ventes/facturation/': typeof AppVentesFacturationIndexRoute
  '/ventes/tarifs/': typeof AppVentesTarifsIndexRoute
  '/rh/collaborateurs/$id/view': typeof AppRhCollaborateursIdViewRouteRoute
  '/frais/$id/edit': typeof AppdashboardFraisIdEditRoute
  '/frais/$id/view': typeof AppdashboardFraisIdViewRoute
  '/achats/commandes/$id/edit': typeof AppAchatsCommandesIdEditRoute
  '/achats/commandes/$id/view': typeof AppAchatsCommandesIdViewRoute
  '/achats/factures/$id/edit': typeof AppAchatsFacturesIdEditRoute
  '/achats/factures/$id/view': typeof AppAchatsFacturesIdViewRoute
  '/achats/fournisseurs/$id/edit': typeof AppAchatsFournisseursIdEditRoute
  '/achats/fournisseurs/$id/view': typeof AppAchatsFournisseursIdViewRoute
  '/achats/fournitures/$id/edit': typeof AppAchatsFournituresIdEditRoute
  '/achats/fournitures/$id/view': typeof AppAchatsFournituresIdViewRoute
  '/achats/prestations/$id/edit': typeof AppAchatsPrestationsIdEditRoute
  '/achats/prestations/$id/view': typeof AppAchatsPrestationsIdViewRoute
  '/achats/receptions/$id/edit': typeof AppAchatsReceptionsIdEditRoute
  '/achats/receptions/$id/view': typeof AppAchatsReceptionsIdViewRoute
  '/admin/profiles/$id/edit': typeof AppAdminProfilesIdEditRoute
  '/comptabilite/factures-fournisseurs/$id/view': typeof AppComptabiliteFacturesFournisseursIdViewRoute
  '/comptabilite/factures-ventes/$id/view': typeof AppComptabiliteFacturesVentesIdViewRoute
  '/comptabilite/relances/$id/view': typeof AppComptabiliteRelancesIdViewRoute
  '/creation/articles/$id/edit': typeof AppCreationArticlesIdEditRoute
  '/creation/articles/$id/view': typeof AppCreationArticlesIdViewRoute
  '/creation/ateliers/$id/edit': typeof AppCreationAteliersIdEditRoute
  '/creation/ateliers/$id/view': typeof AppCreationAteliersIdViewRoute
  '/creation/dossier-techniques/$id/edit': typeof AppCreationDossierTechniquesIdEditRoute
  '/creation/dossier-techniques/$id/view': typeof AppCreationDossierTechniquesIdViewRoute
  '/creation/familleArticles/$id/edit': typeof AppCreationFamilleArticlesIdEditRoute
  '/creation/familleArticles/$id/view': typeof AppCreationFamilleArticlesIdViewRoute
  '/creation/ldf/$id/edit': typeof AppCreationLdfIdEditRoute
  '/creation/ldf/$id/view': typeof AppCreationLdfIdViewRoute
  '/creation/postes/$id/edit': typeof AppCreationPostesIdEditRoute
  '/creation/postes/$id/view': typeof AppCreationPostesIdViewRoute
  '/creation/prestations/$id/edit': typeof AppCreationPrestationsIdEditRoute
  '/creation/prestations/$id/view': typeof AppCreationPrestationsIdViewRoute
  '/creation/univers-commerciaux/$id/edit': typeof AppCreationUniversCommerciauxIdEditRoute
  '/creation/univers-commerciaux/$id/view': typeof AppCreationUniversCommerciauxIdViewRoute
  '/production/lancements/$id/edit': typeof AppProductionLancementsIdEditRoute
  '/production/ordres-fabrication/$id/edit': typeof AppProductionOrdresFabricationIdEditRoute
  '/rh/collaborateurs/$id/edit': typeof AppRhCollaborateursIdEditRoute
  '/rh/competences/$id/edit': typeof AppRhCompetencesIdEditRoute
  '/rh/competences/$id/view': typeof AppRhCompetencesIdViewRoute
  '/rh/conges/$id/view': typeof AppRhCongesIdViewRoute
  '/rh/conges/demandes/new': typeof AppRhCongesDemandesNewRoute
  '/rh/contrats/$id/edit': typeof AppRhContratsIdEditRoute
  '/rh/contrats/$id/view': typeof AppRhContratsIdViewRoute
  '/rh/horaires-de-travail/$id/edit': typeof AppRhHorairesDeTravailIdEditRoute
  '/rh/horaires-de-travail/$id/view': typeof AppRhHorairesDeTravailIdViewRoute
  '/rh/notes-de-frais/$id/edit': typeof AppRhNotesDeFraisIdEditRoute
  '/rh/notes-de-frais/$id/view': typeof AppRhNotesDeFraisIdViewRoute
  '/rh/planning/$id/edit': typeof AppRhPlanningIdEditRoute
  '/rh/planning/$id/view': typeof AppRhPlanningIdViewRoute
  '/stock/depots/$id/edit': typeof AppStockDepotsIdEditRoute
  '/stock/depots/$id/view': typeof AppStockDepotsIdViewRoute
  '/stock/emplacements/$id/edit': typeof AppStockEmplacementsIdEditRoute
  '/stock/emplacements/$id/view': typeof AppStockEmplacementsIdViewRoute
  '/stock/inventaires/$id/edit': typeof AppStockInventairesIdEditRoute
  '/stock/inventaires/$id/view': typeof AppStockInventairesIdViewRoute
  '/stock/mouvements/$id/edit': typeof AppStockMouvementsIdEditRoute
  '/stock/mouvements/$id/view': typeof AppStockMouvementsIdViewRoute
  '/stock/zones/$id/edit': typeof AppStockZonesIdEditRoute
  '/stock/zones/$id/view': typeof AppStockZonesIdViewRoute
  '/ventes/categories/$id/edit': typeof AppVentesCategoriesIdEditRoute
  '/ventes/categories/$id/view': typeof AppVentesCategoriesIdViewRoute
  '/ventes/clients/$id/edit': typeof AppVentesClientsIdEditRoute
  '/ventes/clients/$id/view': typeof AppVentesClientsIdViewRoute
  '/ventes/commandes/$id/edit': typeof AppVentesCommandesIdEditRoute
  '/ventes/commandes/$id/view': typeof AppVentesCommandesIdViewRoute
  '/ventes/crm/$id/edit': typeof AppVentesCrmIdEditRoute
  '/ventes/crm/$id/view': typeof AppVentesCrmIdViewRoute
  '/ventes/expeditions/$id/edit': typeof AppVentesExpeditionsIdEditRoute
  '/ventes/expeditions/$id/view': typeof AppVentesExpeditionsIdViewRoute
  '/ventes/facturation/$id/edit': typeof AppVentesFacturationIdEditRoute
  '/ventes/facturation/$id/view': typeof AppVentesFacturationIdViewRoute
  '/ventes/tarifs/$id/edit': typeof AppVentesTarifsIdEditRoute
  '/ventes/tarifs/$id/view': typeof AppVentesTarifsIdViewRoute
  '/ventes/tarifs/promotions/create': typeof AppVentesTarifsPromotionsCreateRoute
  '/ventes/tarifs/remises/create': typeof AppVentesTarifsRemisesCreateRoute
  '/ventes/tarifs/taxes/create': typeof AppVentesTarifsTaxesCreateRoute
  '/conges/me/': typeof AppdashboardCongesMeIndexRoute
  '/contrats/me/': typeof AppdashboardContratsMeIndexRoute
  '/documents/me/': typeof AppdashboardDocumentsMeIndexRoute
  '/frais/me/': typeof AppdashboardFraisMeIndexRoute
  '/planning/me/': typeof AppdashboardPlanningMeIndexRoute
  '/pointage/me/': typeof AppdashboardPointageMeIndexRoute
  '/production/lancements/$id/': typeof AppProductionLancementsIdIndexRoute
  '/production/ordres-fabrication/$id/': typeof AppProductionOrdresFabricationIdIndexRoute
  '/rh/collaborateurs/$id/': typeof AppRhCollaborateursIdIndexRoute
  '/rh/contrats/$id/avenants/create': typeof AppRhContratsIdAvenantsCreateRoute
  '/ventes/tarifs/promotions/$id/edit': typeof AppVentesTarifsPromotionsIdEditRoute
  '/ventes/tarifs/promotions/$id/view': typeof AppVentesTarifsPromotionsIdViewRoute
  '/ventes/tarifs/remises/$id/edit': typeof AppVentesTarifsRemisesIdEditRoute
  '/ventes/tarifs/remises/$id/view': typeof AppVentesTarifsRemisesIdViewRoute
  '/ventes/tarifs/taxes/$id/edit': typeof AppVentesTarifsTaxesIdEditRoute
  '/ventes/tarifs/taxes/$id/view': typeof AppVentesTarifsTaxesIdViewRoute
  '/rh/contrats/$id/avenants/$avenantId/edit': typeof AppRhContratsIdAvenantsAvenantIdEditRoute
  '/rh/contrats/$id/avenants/$avenantId/view': typeof AppRhContratsIdAvenantsAvenantIdViewRoute
}
export interface FileRoutesByTo {
  '/': typeof AppdashboardIndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/mentions-legales': typeof MentionsLegalesRoute
  '/politique-confidentialite': typeof PolitiqueConfidentialiteRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/parametres': typeof AppParametresRouteRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/setup-password': typeof AuthSetupPasswordRoute
  '/stock/depots': typeof AppStockDepotsRouteRouteWithChildren
  '/design-system/showcase': typeof AppDesignSystemShowcaseRoute
  '/tickets/create': typeof AppTicketsCreateRoute
  '/auth/pointage/$hash': typeof AuthPointageHashRoute
  '/auth/pointage/qr-code': typeof AuthPointageQrCodeRoute
  '/auth/signature-contrat/$token': typeof AuthSignatureContratTokenRoute
  '/achats': typeof AppAchatsIndexRoute
  '/admin': typeof AppAdminIndexRoute
  '/comptabilite': typeof AppComptabiliteIndexRoute
  '/creation': typeof AppCreationIndexRoute
  '/production': typeof AppProductionIndexRoute
  '/rh': typeof AppRhIndexRoute
  '/stock': typeof AppStockIndexRoute
  '/tickets': typeof AppTicketsIndexRoute
  '/ventes': typeof AppVentesIndexRoute
  '/conges/nouvelle-demande': typeof AppdashboardCongesNouvelleDemandeRoute
  '/frais/create': typeof AppdashboardFraisCreateRoute
  '/achats/commandes/create': typeof AppAchatsCommandesCreateRoute
  '/achats/factures/create': typeof AppAchatsFacturesCreateRoute
  '/achats/fournisseurs/create': typeof AppAchatsFournisseursCreateRoute
  '/achats/fournitures/create': typeof AppAchatsFournituresCreateRoute
  '/achats/prestations/create': typeof AppAchatsPrestationsCreateRoute
  '/achats/receptions/create': typeof AppAchatsReceptionsCreateRoute
  '/admin/profiles/create': typeof AppAdminProfilesCreateRoute
  '/creation/articles/create': typeof AppCreationArticlesCreateRoute
  '/creation/ateliers/create': typeof AppCreationAteliersCreateRoute
  '/creation/dossier-techniques/create': typeof AppCreationDossierTechniquesCreateRoute
  '/creation/familleArticles/create': typeof AppCreationFamilleArticlesCreateRoute
  '/creation/ldf/create': typeof AppCreationLdfCreateRoute
  '/creation/postes/create': typeof AppCreationPostesCreateRoute
  '/creation/prestations/create': typeof AppCreationPrestationsCreateRoute
  '/creation/univers-commerciaux/create': typeof AppCreationUniversCommerciauxCreateRoute
  '/production/lancements/create': typeof AppProductionLancementsCreateRoute
  '/production/ordres-fabrication/create': typeof AppProductionOrdresFabricationCreateRoute
  '/rh/collaborateurs/create': typeof AppRhCollaborateursCreateRoute
  '/rh/competences/create': typeof AppRhCompetencesCreateRoute
  '/rh/conges/create': typeof AppRhCongesCreateRoute
  '/rh/contrats/create': typeof AppRhContratsCreateRoute
  '/rh/horaires-de-travail/create': typeof AppRhHorairesDeTravailCreateRoute
  '/rh/notes-de-frais/create': typeof AppRhNotesDeFraisCreateRoute
  '/rh/planning/create': typeof AppRhPlanningCreateRoute
  '/stock/depots/create': typeof AppStockDepotsCreateRoute
  '/stock/emplacements/create': typeof AppStockEmplacementsCreateRoute
  '/stock/inventaires/create': typeof AppStockInventairesCreateRoute
  '/stock/mouvements/create': typeof AppStockMouvementsCreateRoute
  '/stock/zones/create': typeof AppStockZonesCreateRoute
  '/tickets/$id/edit': typeof AppTicketsIdEditRoute
  '/tickets/$id/view': typeof AppTicketsIdViewRoute
  '/ventes/categories/create': typeof AppVentesCategoriesCreateRoute
  '/ventes/clients/create': typeof AppVentesClientsCreateRoute
  '/ventes/commandes/create': typeof AppVentesCommandesCreateRoute
  '/ventes/crm/create': typeof AppVentesCrmCreateRoute
  '/ventes/expeditions/create': typeof AppVentesExpeditionsCreateRoute
  '/ventes/facturation/create': typeof AppVentesFacturationCreateRoute
  '/ventes/tarifs/create': typeof AppVentesTarifsCreateRoute
  '/frais': typeof AppdashboardFraisIndexRoute
  '/mes-conges': typeof AppdashboardMesCongesIndexRoute
  '/profile': typeof AppdashboardProfileIndexRoute
  '/achats/commandes': typeof AppAchatsCommandesIndexRoute
  '/achats/factures': typeof AppAchatsFacturesIndexRoute
  '/achats/fournisseurs': typeof AppAchatsFournisseursIndexRoute
  '/achats/fournitures': typeof AppAchatsFournituresIndexRoute
  '/achats/prestations': typeof AppAchatsPrestationsIndexRoute
  '/achats/receptions': typeof AppAchatsReceptionsIndexRoute
  '/admin/permissions': typeof AppAdminPermissionsIndexRoute
  '/admin/profiles': typeof AppAdminProfilesIndexRoute
  '/admin/reference-data': typeof AppAdminReferenceDataIndexRoute
  '/comptabilite/echeances': typeof AppComptabiliteEcheancesIndexRoute
  '/comptabilite/ecotaxes': typeof AppComptabiliteEcotaxesIndexRoute
  '/comptabilite/factures-fournisseurs': typeof AppComptabiliteFacturesFournisseursIndexRoute
  '/comptabilite/factures-ventes': typeof AppComptabiliteFacturesVentesIndexRoute
  '/comptabilite/relances': typeof AppComptabiliteRelancesIndexRoute
  '/comptabilite/simplifiee': typeof AppComptabiliteSimplifieeIndexRoute
  '/creation/articles': typeof AppCreationArticlesIndexRoute
  '/creation/ateliers': typeof AppCreationAteliersIndexRoute
  '/creation/dossier-techniques': typeof AppCreationDossierTechniquesIndexRoute
  '/creation/familleArticles': typeof AppCreationFamilleArticlesIndexRoute
  '/creation/ldf': typeof AppCreationLdfIndexRoute
  '/creation/postes': typeof AppCreationPostesIndexRoute
  '/creation/prestations': typeof AppCreationPrestationsIndexRoute
  '/creation/univers-commerciaux': typeof AppCreationUniversCommerciauxIndexRoute
  '/production/calcul-besoins': typeof AppProductionCalculBesoinsIndexRoute
  '/production/cloture': typeof AppProductionClotureIndexRoute
  '/production/declarations': typeof AppProductionDeclarationsIndexRoute
  '/production/lancements': typeof AppProductionLancementsIndexRoute
  '/production/ordres-fabrication': typeof AppProductionOrdresFabricationIndexRoute
  '/rh/collaborateurs': typeof AppRhCollaborateursIndexRoute
  '/rh/competences': typeof AppRhCompetencesIndexRoute
  '/rh/conges': typeof AppRhCongesIndexRoute
  '/rh/contrats': typeof AppRhContratsIndexRoute
  '/rh/documents': typeof AppRhDocumentsIndexRoute
  '/rh/feuilles-de-temps': typeof AppRhFeuillesDeTempsIndexRoute
  '/rh/horaires-de-travail': typeof AppRhHorairesDeTravailIndexRoute
  '/rh/notes-de-frais': typeof AppRhNotesDeFraisIndexRoute
  '/rh/planning': typeof AppRhPlanningIndexRoute
  '/stock/consultation': typeof AppStockConsultationIndexRoute
  '/stock/emplacements': typeof AppStockEmplacementsIndexRoute
  '/stock/inventaires': typeof AppStockInventairesIndexRoute
  '/stock/mouvements': typeof AppStockMouvementsIndexRoute
  '/stock/zones': typeof AppStockZonesIndexRoute
  '/ventes/categories': typeof AppVentesCategoriesIndexRoute
  '/ventes/clients': typeof AppVentesClientsIndexRoute
  '/ventes/commandes': typeof AppVentesCommandesIndexRoute
  '/ventes/crm': typeof AppVentesCrmIndexRoute
  '/ventes/expeditions': typeof AppVentesExpeditionsIndexRoute
  '/ventes/facturation': typeof AppVentesFacturationIndexRoute
  '/ventes/tarifs': typeof AppVentesTarifsIndexRoute
  '/rh/collaborateurs/$id/view': typeof AppRhCollaborateursIdViewRouteRoute
  '/frais/$id/edit': typeof AppdashboardFraisIdEditRoute
  '/frais/$id/view': typeof AppdashboardFraisIdViewRoute
  '/achats/commandes/$id/edit': typeof AppAchatsCommandesIdEditRoute
  '/achats/commandes/$id/view': typeof AppAchatsCommandesIdViewRoute
  '/achats/factures/$id/edit': typeof AppAchatsFacturesIdEditRoute
  '/achats/factures/$id/view': typeof AppAchatsFacturesIdViewRoute
  '/achats/fournisseurs/$id/edit': typeof AppAchatsFournisseursIdEditRoute
  '/achats/fournisseurs/$id/view': typeof AppAchatsFournisseursIdViewRoute
  '/achats/fournitures/$id/edit': typeof AppAchatsFournituresIdEditRoute
  '/achats/fournitures/$id/view': typeof AppAchatsFournituresIdViewRoute
  '/achats/prestations/$id/edit': typeof AppAchatsPrestationsIdEditRoute
  '/achats/prestations/$id/view': typeof AppAchatsPrestationsIdViewRoute
  '/achats/receptions/$id/edit': typeof AppAchatsReceptionsIdEditRoute
  '/achats/receptions/$id/view': typeof AppAchatsReceptionsIdViewRoute
  '/admin/profiles/$id/edit': typeof AppAdminProfilesIdEditRoute
  '/comptabilite/factures-fournisseurs/$id/view': typeof AppComptabiliteFacturesFournisseursIdViewRoute
  '/comptabilite/factures-ventes/$id/view': typeof AppComptabiliteFacturesVentesIdViewRoute
  '/comptabilite/relances/$id/view': typeof AppComptabiliteRelancesIdViewRoute
  '/creation/articles/$id/edit': typeof AppCreationArticlesIdEditRoute
  '/creation/articles/$id/view': typeof AppCreationArticlesIdViewRoute
  '/creation/ateliers/$id/edit': typeof AppCreationAteliersIdEditRoute
  '/creation/ateliers/$id/view': typeof AppCreationAteliersIdViewRoute
  '/creation/dossier-techniques/$id/edit': typeof AppCreationDossierTechniquesIdEditRoute
  '/creation/dossier-techniques/$id/view': typeof AppCreationDossierTechniquesIdViewRoute
  '/creation/familleArticles/$id/edit': typeof AppCreationFamilleArticlesIdEditRoute
  '/creation/familleArticles/$id/view': typeof AppCreationFamilleArticlesIdViewRoute
  '/creation/ldf/$id/edit': typeof AppCreationLdfIdEditRoute
  '/creation/ldf/$id/view': typeof AppCreationLdfIdViewRoute
  '/creation/postes/$id/edit': typeof AppCreationPostesIdEditRoute
  '/creation/postes/$id/view': typeof AppCreationPostesIdViewRoute
  '/creation/prestations/$id/edit': typeof AppCreationPrestationsIdEditRoute
  '/creation/prestations/$id/view': typeof AppCreationPrestationsIdViewRoute
  '/creation/univers-commerciaux/$id/edit': typeof AppCreationUniversCommerciauxIdEditRoute
  '/creation/univers-commerciaux/$id/view': typeof AppCreationUniversCommerciauxIdViewRoute
  '/production/lancements/$id/edit': typeof AppProductionLancementsIdEditRoute
  '/production/ordres-fabrication/$id/edit': typeof AppProductionOrdresFabricationIdEditRoute
  '/rh/collaborateurs/$id/edit': typeof AppRhCollaborateursIdEditRoute
  '/rh/competences/$id/edit': typeof AppRhCompetencesIdEditRoute
  '/rh/competences/$id/view': typeof AppRhCompetencesIdViewRoute
  '/rh/conges/$id/view': typeof AppRhCongesIdViewRoute
  '/rh/conges/demandes/new': typeof AppRhCongesDemandesNewRoute
  '/rh/contrats/$id/edit': typeof AppRhContratsIdEditRoute
  '/rh/contrats/$id/view': typeof AppRhContratsIdViewRoute
  '/rh/horaires-de-travail/$id/edit': typeof AppRhHorairesDeTravailIdEditRoute
  '/rh/horaires-de-travail/$id/view': typeof AppRhHorairesDeTravailIdViewRoute
  '/rh/notes-de-frais/$id/edit': typeof AppRhNotesDeFraisIdEditRoute
  '/rh/notes-de-frais/$id/view': typeof AppRhNotesDeFraisIdViewRoute
  '/rh/planning/$id/edit': typeof AppRhPlanningIdEditRoute
  '/rh/planning/$id/view': typeof AppRhPlanningIdViewRoute
  '/stock/depots/$id/edit': typeof AppStockDepotsIdEditRoute
  '/stock/depots/$id/view': typeof AppStockDepotsIdViewRoute
  '/stock/emplacements/$id/edit': typeof AppStockEmplacementsIdEditRoute
  '/stock/emplacements/$id/view': typeof AppStockEmplacementsIdViewRoute
  '/stock/inventaires/$id/edit': typeof AppStockInventairesIdEditRoute
  '/stock/inventaires/$id/view': typeof AppStockInventairesIdViewRoute
  '/stock/mouvements/$id/edit': typeof AppStockMouvementsIdEditRoute
  '/stock/mouvements/$id/view': typeof AppStockMouvementsIdViewRoute
  '/stock/zones/$id/edit': typeof AppStockZonesIdEditRoute
  '/stock/zones/$id/view': typeof AppStockZonesIdViewRoute
  '/ventes/categories/$id/edit': typeof AppVentesCategoriesIdEditRoute
  '/ventes/categories/$id/view': typeof AppVentesCategoriesIdViewRoute
  '/ventes/clients/$id/edit': typeof AppVentesClientsIdEditRoute
  '/ventes/clients/$id/view': typeof AppVentesClientsIdViewRoute
  '/ventes/commandes/$id/edit': typeof AppVentesCommandesIdEditRoute
  '/ventes/commandes/$id/view': typeof AppVentesCommandesIdViewRoute
  '/ventes/crm/$id/edit': typeof AppVentesCrmIdEditRoute
  '/ventes/crm/$id/view': typeof AppVentesCrmIdViewRoute
  '/ventes/expeditions/$id/edit': typeof AppVentesExpeditionsIdEditRoute
  '/ventes/expeditions/$id/view': typeof AppVentesExpeditionsIdViewRoute
  '/ventes/facturation/$id/edit': typeof AppVentesFacturationIdEditRoute
  '/ventes/facturation/$id/view': typeof AppVentesFacturationIdViewRoute
  '/ventes/tarifs/$id/edit': typeof AppVentesTarifsIdEditRoute
  '/ventes/tarifs/$id/view': typeof AppVentesTarifsIdViewRoute
  '/ventes/tarifs/promotions/create': typeof AppVentesTarifsPromotionsCreateRoute
  '/ventes/tarifs/remises/create': typeof AppVentesTarifsRemisesCreateRoute
  '/ventes/tarifs/taxes/create': typeof AppVentesTarifsTaxesCreateRoute
  '/conges/me': typeof AppdashboardCongesMeIndexRoute
  '/contrats/me': typeof AppdashboardContratsMeIndexRoute
  '/documents/me': typeof AppdashboardDocumentsMeIndexRoute
  '/frais/me': typeof AppdashboardFraisMeIndexRoute
  '/planning/me': typeof AppdashboardPlanningMeIndexRoute
  '/pointage/me': typeof AppdashboardPointageMeIndexRoute
  '/production/lancements/$id': typeof AppProductionLancementsIdIndexRoute
  '/production/ordres-fabrication/$id': typeof AppProductionOrdresFabricationIdIndexRoute
  '/rh/collaborateurs/$id': typeof AppRhCollaborateursIdIndexRoute
  '/rh/contrats/$id/avenants/create': typeof AppRhContratsIdAvenantsCreateRoute
  '/ventes/tarifs/promotions/$id/edit': typeof AppVentesTarifsPromotionsIdEditRoute
  '/ventes/tarifs/promotions/$id/view': typeof AppVentesTarifsPromotionsIdViewRoute
  '/ventes/tarifs/remises/$id/edit': typeof AppVentesTarifsRemisesIdEditRoute
  '/ventes/tarifs/remises/$id/view': typeof AppVentesTarifsRemisesIdViewRoute
  '/ventes/tarifs/taxes/$id/edit': typeof AppVentesTarifsTaxesIdEditRoute
  '/ventes/tarifs/taxes/$id/view': typeof AppVentesTarifsTaxesIdViewRoute
  '/rh/contrats/$id/avenants/$avenantId/edit': typeof AppRhContratsIdAvenantsAvenantIdEditRoute
  '/rh/contrats/$id/avenants/$avenantId/view': typeof AppRhContratsIdAvenantsAvenantIdViewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/mentions-legales': typeof MentionsLegalesRoute
  '/politique-confidentialite': typeof PolitiqueConfidentialiteRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_app/(dashboard)': typeof AppdashboardRouteRouteWithChildren
  '/_app/achats': typeof AppAchatsRouteRouteWithChildren
  '/_app/admin': typeof AppAdminRouteRouteWithChildren
  '/_app/comptabilite': typeof AppComptabiliteRouteRouteWithChildren
  '/_app/creation': typeof AppCreationRouteRouteWithChildren
  '/_app/parametres': typeof AppParametresRouteRoute
  '/_app/production': typeof AppProductionRouteRouteWithChildren
  '/_app/rh': typeof AppRhRouteRouteWithChildren
  '/_app/stock': typeof AppStockRouteRouteWithChildren
  '/_app/tickets': typeof AppTicketsRouteRouteWithChildren
  '/_app/ventes': typeof AppVentesRouteRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/setup-password': typeof AuthSetupPasswordRoute
  '/_app/creation/articles': typeof AppCreationArticlesRouteRouteWithChildren
  '/_app/creation/ateliers': typeof AppCreationAteliersRouteRouteWithChildren
  '/_app/creation/dossier-techniques': typeof AppCreationDossierTechniquesRouteRouteWithChildren
  '/_app/creation/familleArticles': typeof AppCreationFamilleArticlesRouteRouteWithChildren
  '/_app/creation/ldf': typeof AppCreationLdfRouteRouteWithChildren
  '/_app/creation/postes': typeof AppCreationPostesRouteRouteWithChildren
  '/_app/creation/prestations': typeof AppCreationPrestationsRouteRouteWithChildren
  '/_app/creation/univers-commerciaux': typeof AppCreationUniversCommerciauxRouteRouteWithChildren
  '/_app/production/calcul-besoins': typeof AppProductionCalculBesoinsRouteRouteWithChildren
  '/_app/production/cloture': typeof AppProductionClotureRouteRouteWithChildren
  '/_app/production/declarations': typeof AppProductionDeclarationsRouteRouteWithChildren
  '/_app/production/lancements': typeof AppProductionLancementsRouteRouteWithChildren
  '/_app/production/ordres-fabrication': typeof AppProductionOrdresFabricationRouteRouteWithChildren
  '/_app/rh/collaborateurs': typeof AppRhCollaborateursRouteRouteWithChildren
  '/_app/rh/competences': typeof AppRhCompetencesRouteRouteWithChildren
  '/_app/rh/conges': typeof AppRhCongesRouteRouteWithChildren
  '/_app/rh/contrats': typeof AppRhContratsRouteRouteWithChildren
  '/_app/rh/documents': typeof AppRhDocumentsRouteRouteWithChildren
  '/_app/rh/feuilles-de-temps': typeof AppRhFeuillesDeTempsRouteRouteWithChildren
  '/_app/rh/horaires-de-travail': typeof AppRhHorairesDeTravailRouteRouteWithChildren
  '/_app/rh/planning': typeof AppRhPlanningRouteRouteWithChildren
  '/_app/stock/consultation': typeof AppStockConsultationRouteRouteWithChildren
  '/_app/stock/depots': typeof AppStockDepotsRouteRouteWithChildren
  '/_app/stock/emplacements': typeof AppStockEmplacementsRouteRouteWithChildren
  '/_app/stock/inventaires': typeof AppStockInventairesRouteRouteWithChildren
  '/_app/stock/mouvements': typeof AppStockMouvementsRouteRouteWithChildren
  '/_app/stock/zones': typeof AppStockZonesRouteRouteWithChildren
  '/_app/design-system/showcase': typeof AppDesignSystemShowcaseRoute
  '/_app/tickets/create': typeof AppTicketsCreateRoute
  '/auth/pointage/$hash': typeof AuthPointageHashRoute
  '/auth/pointage/qr-code': typeof AuthPointageQrCodeRoute
  '/auth/signature-contrat/$token': typeof AuthSignatureContratTokenRoute
  '/_app/(dashboard)/': typeof AppdashboardIndexRoute
  '/_app/achats/': typeof AppAchatsIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/comptabilite/': typeof AppComptabiliteIndexRoute
  '/_app/creation/': typeof AppCreationIndexRoute
  '/_app/production/': typeof AppProductionIndexRoute
  '/_app/rh/': typeof AppRhIndexRoute
  '/_app/stock/': typeof AppStockIndexRoute
  '/_app/tickets/': typeof AppTicketsIndexRoute
  '/_app/ventes/': typeof AppVentesIndexRoute
  '/_app/(dashboard)/conges/nouvelle-demande': typeof AppdashboardCongesNouvelleDemandeRoute
  '/_app/(dashboard)/frais/create': typeof AppdashboardFraisCreateRoute
  '/_app/achats/commandes/create': typeof AppAchatsCommandesCreateRoute
  '/_app/achats/factures/create': typeof AppAchatsFacturesCreateRoute
  '/_app/achats/fournisseurs/create': typeof AppAchatsFournisseursCreateRoute
  '/_app/achats/fournitures/create': typeof AppAchatsFournituresCreateRoute
  '/_app/achats/prestations/create': typeof AppAchatsPrestationsCreateRoute
  '/_app/achats/receptions/create': typeof AppAchatsReceptionsCreateRoute
  '/_app/admin/profiles/create': typeof AppAdminProfilesCreateRoute
  '/_app/creation/articles/create': typeof AppCreationArticlesCreateRoute
  '/_app/creation/ateliers/create': typeof AppCreationAteliersCreateRoute
  '/_app/creation/dossier-techniques/create': typeof AppCreationDossierTechniquesCreateRoute
  '/_app/creation/familleArticles/create': typeof AppCreationFamilleArticlesCreateRoute
  '/_app/creation/ldf/create': typeof AppCreationLdfCreateRoute
  '/_app/creation/postes/create': typeof AppCreationPostesCreateRoute
  '/_app/creation/prestations/create': typeof AppCreationPrestationsCreateRoute
  '/_app/creation/univers-commerciaux/create': typeof AppCreationUniversCommerciauxCreateRoute
  '/_app/production/lancements/create': typeof AppProductionLancementsCreateRoute
  '/_app/production/ordres-fabrication/create': typeof AppProductionOrdresFabricationCreateRoute
  '/_app/rh/collaborateurs/create': typeof AppRhCollaborateursCreateRoute
  '/_app/rh/competences/create': typeof AppRhCompetencesCreateRoute
  '/_app/rh/conges/create': typeof AppRhCongesCreateRoute
  '/_app/rh/contrats/create': typeof AppRhContratsCreateRoute
  '/_app/rh/horaires-de-travail/create': typeof AppRhHorairesDeTravailCreateRoute
  '/_app/rh/notes-de-frais/create': typeof AppRhNotesDeFraisCreateRoute
  '/_app/rh/planning/create': typeof AppRhPlanningCreateRoute
  '/_app/stock/depots/create': typeof AppStockDepotsCreateRoute
  '/_app/stock/emplacements/create': typeof AppStockEmplacementsCreateRoute
  '/_app/stock/inventaires/create': typeof AppStockInventairesCreateRoute
  '/_app/stock/mouvements/create': typeof AppStockMouvementsCreateRoute
  '/_app/stock/zones/create': typeof AppStockZonesCreateRoute
  '/_app/tickets/$id/edit': typeof AppTicketsIdEditRoute
  '/_app/tickets/$id/view': typeof AppTicketsIdViewRoute
  '/_app/ventes/categories/create': typeof AppVentesCategoriesCreateRoute
  '/_app/ventes/clients/create': typeof AppVentesClientsCreateRoute
  '/_app/ventes/commandes/create': typeof AppVentesCommandesCreateRoute
  '/_app/ventes/crm/create': typeof AppVentesCrmCreateRoute
  '/_app/ventes/expeditions/create': typeof AppVentesExpeditionsCreateRoute
  '/_app/ventes/facturation/create': typeof AppVentesFacturationCreateRoute
  '/_app/ventes/tarifs/create': typeof AppVentesTarifsCreateRoute
  '/_app/(dashboard)/frais/': typeof AppdashboardFraisIndexRoute
  '/_app/(dashboard)/mes-conges/': typeof AppdashboardMesCongesIndexRoute
  '/_app/(dashboard)/profile/': typeof AppdashboardProfileIndexRoute
  '/_app/achats/commandes/': typeof AppAchatsCommandesIndexRoute
  '/_app/achats/factures/': typeof AppAchatsFacturesIndexRoute
  '/_app/achats/fournisseurs/': typeof AppAchatsFournisseursIndexRoute
  '/_app/achats/fournitures/': typeof AppAchatsFournituresIndexRoute
  '/_app/achats/prestations/': typeof AppAchatsPrestationsIndexRoute
  '/_app/achats/receptions/': typeof AppAchatsReceptionsIndexRoute
  '/_app/admin/permissions/': typeof AppAdminPermissionsIndexRoute
  '/_app/admin/profiles/': typeof AppAdminProfilesIndexRoute
  '/_app/admin/reference-data/': typeof AppAdminReferenceDataIndexRoute
  '/_app/comptabilite/echeances/': typeof AppComptabiliteEcheancesIndexRoute
  '/_app/comptabilite/ecotaxes/': typeof AppComptabiliteEcotaxesIndexRoute
  '/_app/comptabilite/factures-fournisseurs/': typeof AppComptabiliteFacturesFournisseursIndexRoute
  '/_app/comptabilite/factures-ventes/': typeof AppComptabiliteFacturesVentesIndexRoute
  '/_app/comptabilite/relances/': typeof AppComptabiliteRelancesIndexRoute
  '/_app/comptabilite/simplifiee/': typeof AppComptabiliteSimplifieeIndexRoute
  '/_app/creation/articles/': typeof AppCreationArticlesIndexRoute
  '/_app/creation/ateliers/': typeof AppCreationAteliersIndexRoute
  '/_app/creation/dossier-techniques/': typeof AppCreationDossierTechniquesIndexRoute
  '/_app/creation/familleArticles/': typeof AppCreationFamilleArticlesIndexRoute
  '/_app/creation/ldf/': typeof AppCreationLdfIndexRoute
  '/_app/creation/postes/': typeof AppCreationPostesIndexRoute
  '/_app/creation/prestations/': typeof AppCreationPrestationsIndexRoute
  '/_app/creation/univers-commerciaux/': typeof AppCreationUniversCommerciauxIndexRoute
  '/_app/production/calcul-besoins/': typeof AppProductionCalculBesoinsIndexRoute
  '/_app/production/cloture/': typeof AppProductionClotureIndexRoute
  '/_app/production/declarations/': typeof AppProductionDeclarationsIndexRoute
  '/_app/production/lancements/': typeof AppProductionLancementsIndexRoute
  '/_app/production/ordres-fabrication/': typeof AppProductionOrdresFabricationIndexRoute
  '/_app/rh/collaborateurs/': typeof AppRhCollaborateursIndexRoute
  '/_app/rh/competences/': typeof AppRhCompetencesIndexRoute
  '/_app/rh/conges/': typeof AppRhCongesIndexRoute
  '/_app/rh/contrats/': typeof AppRhContratsIndexRoute
  '/_app/rh/documents/': typeof AppRhDocumentsIndexRoute
  '/_app/rh/feuilles-de-temps/': typeof AppRhFeuillesDeTempsIndexRoute
  '/_app/rh/horaires-de-travail/': typeof AppRhHorairesDeTravailIndexRoute
  '/_app/rh/notes-de-frais/': typeof AppRhNotesDeFraisIndexRoute
  '/_app/rh/planning/': typeof AppRhPlanningIndexRoute
  '/_app/stock/consultation/': typeof AppStockConsultationIndexRoute
  '/_app/stock/emplacements/': typeof AppStockEmplacementsIndexRoute
  '/_app/stock/inventaires/': typeof AppStockInventairesIndexRoute
  '/_app/stock/mouvements/': typeof AppStockMouvementsIndexRoute
  '/_app/stock/zones/': typeof AppStockZonesIndexRoute
  '/_app/ventes/categories/': typeof AppVentesCategoriesIndexRoute
  '/_app/ventes/clients/': typeof AppVentesClientsIndexRoute
  '/_app/ventes/commandes/': typeof AppVentesCommandesIndexRoute
  '/_app/ventes/crm/': typeof AppVentesCrmIndexRoute
  '/_app/ventes/expeditions/': typeof AppVentesExpeditionsIndexRoute
  '/_app/ventes/facturation/': typeof AppVentesFacturationIndexRoute
  '/_app/ventes/tarifs/': typeof AppVentesTarifsIndexRoute
  '/_app/rh/collaborateurs/$id/view': typeof AppRhCollaborateursIdViewRouteRoute
  '/_app/(dashboard)/frais/$id/edit': typeof AppdashboardFraisIdEditRoute
  '/_app/(dashboard)/frais/$id/view': typeof AppdashboardFraisIdViewRoute
  '/_app/achats/commandes/$id/edit': typeof AppAchatsCommandesIdEditRoute
  '/_app/achats/commandes/$id/view': typeof AppAchatsCommandesIdViewRoute
  '/_app/achats/factures/$id/edit': typeof AppAchatsFacturesIdEditRoute
  '/_app/achats/factures/$id/view': typeof AppAchatsFacturesIdViewRoute
  '/_app/achats/fournisseurs/$id/edit': typeof AppAchatsFournisseursIdEditRoute
  '/_app/achats/fournisseurs/$id/view': typeof AppAchatsFournisseursIdViewRoute
  '/_app/achats/fournitures/$id/edit': typeof AppAchatsFournituresIdEditRoute
  '/_app/achats/fournitures/$id/view': typeof AppAchatsFournituresIdViewRoute
  '/_app/achats/prestations/$id/edit': typeof AppAchatsPrestationsIdEditRoute
  '/_app/achats/prestations/$id/view': typeof AppAchatsPrestationsIdViewRoute
  '/_app/achats/receptions/$id/edit': typeof AppAchatsReceptionsIdEditRoute
  '/_app/achats/receptions/$id/view': typeof AppAchatsReceptionsIdViewRoute
  '/_app/admin/profiles/$id/edit': typeof AppAdminProfilesIdEditRoute
  '/_app/comptabilite/factures-fournisseurs/$id/view': typeof AppComptabiliteFacturesFournisseursIdViewRoute
  '/_app/comptabilite/factures-ventes/$id/view': typeof AppComptabiliteFacturesVentesIdViewRoute
  '/_app/comptabilite/relances/$id/view': typeof AppComptabiliteRelancesIdViewRoute
  '/_app/creation/articles/$id/edit': typeof AppCreationArticlesIdEditRoute
  '/_app/creation/articles/$id/view': typeof AppCreationArticlesIdViewRoute
  '/_app/creation/ateliers/$id/edit': typeof AppCreationAteliersIdEditRoute
  '/_app/creation/ateliers/$id/view': typeof AppCreationAteliersIdViewRoute
  '/_app/creation/dossier-techniques/$id/edit': typeof AppCreationDossierTechniquesIdEditRoute
  '/_app/creation/dossier-techniques/$id/view': typeof AppCreationDossierTechniquesIdViewRoute
  '/_app/creation/familleArticles/$id/edit': typeof AppCreationFamilleArticlesIdEditRoute
  '/_app/creation/familleArticles/$id/view': typeof AppCreationFamilleArticlesIdViewRoute
  '/_app/creation/ldf/$id/edit': typeof AppCreationLdfIdEditRoute
  '/_app/creation/ldf/$id/view': typeof AppCreationLdfIdViewRoute
  '/_app/creation/postes/$id/edit': typeof AppCreationPostesIdEditRoute
  '/_app/creation/postes/$id/view': typeof AppCreationPostesIdViewRoute
  '/_app/creation/prestations/$id/edit': typeof AppCreationPrestationsIdEditRoute
  '/_app/creation/prestations/$id/view': typeof AppCreationPrestationsIdViewRoute
  '/_app/creation/univers-commerciaux/$id/edit': typeof AppCreationUniversCommerciauxIdEditRoute
  '/_app/creation/univers-commerciaux/$id/view': typeof AppCreationUniversCommerciauxIdViewRoute
  '/_app/production/lancements/$id/edit': typeof AppProductionLancementsIdEditRoute
  '/_app/production/ordres-fabrication/$id/edit': typeof AppProductionOrdresFabricationIdEditRoute
  '/_app/rh/collaborateurs/$id/edit': typeof AppRhCollaborateursIdEditRoute
  '/_app/rh/competences/$id/edit': typeof AppRhCompetencesIdEditRoute
  '/_app/rh/competences/$id/view': typeof AppRhCompetencesIdViewRoute
  '/_app/rh/conges/$id/view': typeof AppRhCongesIdViewRoute
  '/_app/rh/conges/demandes/new': typeof AppRhCongesDemandesNewRoute
  '/_app/rh/contrats/$id/edit': typeof AppRhContratsIdEditRoute
  '/_app/rh/contrats/$id/view': typeof AppRhContratsIdViewRoute
  '/_app/rh/horaires-de-travail/$id/edit': typeof AppRhHorairesDeTravailIdEditRoute
  '/_app/rh/horaires-de-travail/$id/view': typeof AppRhHorairesDeTravailIdViewRoute
  '/_app/rh/notes-de-frais/$id/edit': typeof AppRhNotesDeFraisIdEditRoute
  '/_app/rh/notes-de-frais/$id/view': typeof AppRhNotesDeFraisIdViewRoute
  '/_app/rh/planning/$id/edit': typeof AppRhPlanningIdEditRoute
  '/_app/rh/planning/$id/view': typeof AppRhPlanningIdViewRoute
  '/_app/stock/depots/$id/edit': typeof AppStockDepotsIdEditRoute
  '/_app/stock/depots/$id/view': typeof AppStockDepotsIdViewRoute
  '/_app/stock/emplacements/$id/edit': typeof AppStockEmplacementsIdEditRoute
  '/_app/stock/emplacements/$id/view': typeof AppStockEmplacementsIdViewRoute
  '/_app/stock/inventaires/$id/edit': typeof AppStockInventairesIdEditRoute
  '/_app/stock/inventaires/$id/view': typeof AppStockInventairesIdViewRoute
  '/_app/stock/mouvements/$id/edit': typeof AppStockMouvementsIdEditRoute
  '/_app/stock/mouvements/$id/view': typeof AppStockMouvementsIdViewRoute
  '/_app/stock/zones/$id/edit': typeof AppStockZonesIdEditRoute
  '/_app/stock/zones/$id/view': typeof AppStockZonesIdViewRoute
  '/_app/ventes/categories/$id/edit': typeof AppVentesCategoriesIdEditRoute
  '/_app/ventes/categories/$id/view': typeof AppVentesCategoriesIdViewRoute
  '/_app/ventes/clients/$id/edit': typeof AppVentesClientsIdEditRoute
  '/_app/ventes/clients/$id/view': typeof AppVentesClientsIdViewRoute
  '/_app/ventes/commandes/$id/edit': typeof AppVentesCommandesIdEditRoute
  '/_app/ventes/commandes/$id/view': typeof AppVentesCommandesIdViewRoute
  '/_app/ventes/crm/$id/edit': typeof AppVentesCrmIdEditRoute
  '/_app/ventes/crm/$id/view': typeof AppVentesCrmIdViewRoute
  '/_app/ventes/expeditions/$id/edit': typeof AppVentesExpeditionsIdEditRoute
  '/_app/ventes/expeditions/$id/view': typeof AppVentesExpeditionsIdViewRoute
  '/_app/ventes/facturation/$id/edit': typeof AppVentesFacturationIdEditRoute
  '/_app/ventes/facturation/$id/view': typeof AppVentesFacturationIdViewRoute
  '/_app/ventes/tarifs/$id/edit': typeof AppVentesTarifsIdEditRoute
  '/_app/ventes/tarifs/$id/view': typeof AppVentesTarifsIdViewRoute
  '/_app/ventes/tarifs/promotions/create': typeof AppVentesTarifsPromotionsCreateRoute
  '/_app/ventes/tarifs/remises/create': typeof AppVentesTarifsRemisesCreateRoute
  '/_app/ventes/tarifs/taxes/create': typeof AppVentesTarifsTaxesCreateRoute
  '/_app/(dashboard)/conges/me/': typeof AppdashboardCongesMeIndexRoute
  '/_app/(dashboard)/contrats/me/': typeof AppdashboardContratsMeIndexRoute
  '/_app/(dashboard)/documents/me/': typeof AppdashboardDocumentsMeIndexRoute
  '/_app/(dashboard)/frais/me/': typeof AppdashboardFraisMeIndexRoute
  '/_app/(dashboard)/planning/me/': typeof AppdashboardPlanningMeIndexRoute
  '/_app/(dashboard)/pointage/me/': typeof AppdashboardPointageMeIndexRoute
  '/_app/production/lancements/$id/': typeof AppProductionLancementsIdIndexRoute
  '/_app/production/ordres-fabrication/$id/': typeof AppProductionOrdresFabricationIdIndexRoute
  '/_app/rh/collaborateurs/$id/': typeof AppRhCollaborateursIdIndexRoute
  '/_app/rh/contrats/$id/avenants/create': typeof AppRhContratsIdAvenantsCreateRoute
  '/_app/ventes/tarifs/promotions/$id/edit': typeof AppVentesTarifsPromotionsIdEditRoute
  '/_app/ventes/tarifs/promotions/$id/view': typeof AppVentesTarifsPromotionsIdViewRoute
  '/_app/ventes/tarifs/remises/$id/edit': typeof AppVentesTarifsRemisesIdEditRoute
  '/_app/ventes/tarifs/remises/$id/view': typeof AppVentesTarifsRemisesIdViewRoute
  '/_app/ventes/tarifs/taxes/$id/edit': typeof AppVentesTarifsTaxesIdEditRoute
  '/_app/ventes/tarifs/taxes/$id/view': typeof AppVentesTarifsTaxesIdViewRoute
  '/_app/rh/contrats/$id/avenants/$avenantId/edit': typeof AppRhContratsIdAvenantsAvenantIdEditRoute
  '/_app/rh/contrats/$id/avenants/$avenantId/view': typeof AppRhContratsIdAvenantsAvenantIdViewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/mentions-legales'
    | '/politique-confidentialite'
    | '/unauthorized'
    | '/achats'
    | '/admin'
    | '/comptabilite'
    | '/creation'
    | '/parametres'
    | '/production'
    | '/rh'
    | '/stock'
    | '/tickets'
    | '/ventes'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/setup-password'
    | '/creation/articles'
    | '/creation/ateliers'
    | '/creation/dossier-techniques'
    | '/creation/familleArticles'
    | '/creation/ldf'
    | '/creation/postes'
    | '/creation/prestations'
    | '/creation/univers-commerciaux'
    | '/production/calcul-besoins'
    | '/production/cloture'
    | '/production/declarations'
    | '/production/lancements'
    | '/production/ordres-fabrication'
    | '/rh/collaborateurs'
    | '/rh/competences'
    | '/rh/conges'
    | '/rh/contrats'
    | '/rh/documents'
    | '/rh/feuilles-de-temps'
    | '/rh/horaires-de-travail'
    | '/rh/planning'
    | '/stock/consultation'
    | '/stock/depots'
    | '/stock/emplacements'
    | '/stock/inventaires'
    | '/stock/mouvements'
    | '/stock/zones'
    | '/design-system/showcase'
    | '/tickets/create'
    | '/auth/pointage/$hash'
    | '/auth/pointage/qr-code'
    | '/auth/signature-contrat/$token'
    | '/achats/'
    | '/admin/'
    | '/comptabilite/'
    | '/creation/'
    | '/production/'
    | '/rh/'
    | '/stock/'
    | '/tickets/'
    | '/ventes/'
    | '/conges/nouvelle-demande'
    | '/frais/create'
    | '/achats/commandes/create'
    | '/achats/factures/create'
    | '/achats/fournisseurs/create'
    | '/achats/fournitures/create'
    | '/achats/prestations/create'
    | '/achats/receptions/create'
    | '/admin/profiles/create'
    | '/creation/articles/create'
    | '/creation/ateliers/create'
    | '/creation/dossier-techniques/create'
    | '/creation/familleArticles/create'
    | '/creation/ldf/create'
    | '/creation/postes/create'
    | '/creation/prestations/create'
    | '/creation/univers-commerciaux/create'
    | '/production/lancements/create'
    | '/production/ordres-fabrication/create'
    | '/rh/collaborateurs/create'
    | '/rh/competences/create'
    | '/rh/conges/create'
    | '/rh/contrats/create'
    | '/rh/horaires-de-travail/create'
    | '/rh/notes-de-frais/create'
    | '/rh/planning/create'
    | '/stock/depots/create'
    | '/stock/emplacements/create'
    | '/stock/inventaires/create'
    | '/stock/mouvements/create'
    | '/stock/zones/create'
    | '/tickets/$id/edit'
    | '/tickets/$id/view'
    | '/ventes/categories/create'
    | '/ventes/clients/create'
    | '/ventes/commandes/create'
    | '/ventes/crm/create'
    | '/ventes/expeditions/create'
    | '/ventes/facturation/create'
    | '/ventes/tarifs/create'
    | '/frais/'
    | '/mes-conges/'
    | '/profile/'
    | '/achats/commandes/'
    | '/achats/factures/'
    | '/achats/fournisseurs/'
    | '/achats/fournitures/'
    | '/achats/prestations/'
    | '/achats/receptions/'
    | '/admin/permissions/'
    | '/admin/profiles/'
    | '/admin/reference-data/'
    | '/comptabilite/echeances/'
    | '/comptabilite/ecotaxes/'
    | '/comptabilite/factures-fournisseurs/'
    | '/comptabilite/factures-ventes/'
    | '/comptabilite/relances/'
    | '/comptabilite/simplifiee/'
    | '/creation/articles/'
    | '/creation/ateliers/'
    | '/creation/dossier-techniques/'
    | '/creation/familleArticles/'
    | '/creation/ldf/'
    | '/creation/postes/'
    | '/creation/prestations/'
    | '/creation/univers-commerciaux/'
    | '/production/calcul-besoins/'
    | '/production/cloture/'
    | '/production/declarations/'
    | '/production/lancements/'
    | '/production/ordres-fabrication/'
    | '/rh/collaborateurs/'
    | '/rh/competences/'
    | '/rh/conges/'
    | '/rh/contrats/'
    | '/rh/documents/'
    | '/rh/feuilles-de-temps/'
    | '/rh/horaires-de-travail/'
    | '/rh/notes-de-frais/'
    | '/rh/planning/'
    | '/stock/consultation/'
    | '/stock/emplacements/'
    | '/stock/inventaires/'
    | '/stock/mouvements/'
    | '/stock/zones/'
    | '/ventes/categories/'
    | '/ventes/clients/'
    | '/ventes/commandes/'
    | '/ventes/crm/'
    | '/ventes/expeditions/'
    | '/ventes/facturation/'
    | '/ventes/tarifs/'
    | '/rh/collaborateurs/$id/view'
    | '/frais/$id/edit'
    | '/frais/$id/view'
    | '/achats/commandes/$id/edit'
    | '/achats/commandes/$id/view'
    | '/achats/factures/$id/edit'
    | '/achats/factures/$id/view'
    | '/achats/fournisseurs/$id/edit'
    | '/achats/fournisseurs/$id/view'
    | '/achats/fournitures/$id/edit'
    | '/achats/fournitures/$id/view'
    | '/achats/prestations/$id/edit'
    | '/achats/prestations/$id/view'
    | '/achats/receptions/$id/edit'
    | '/achats/receptions/$id/view'
    | '/admin/profiles/$id/edit'
    | '/comptabilite/factures-fournisseurs/$id/view'
    | '/comptabilite/factures-ventes/$id/view'
    | '/comptabilite/relances/$id/view'
    | '/creation/articles/$id/edit'
    | '/creation/articles/$id/view'
    | '/creation/ateliers/$id/edit'
    | '/creation/ateliers/$id/view'
    | '/creation/dossier-techniques/$id/edit'
    | '/creation/dossier-techniques/$id/view'
    | '/creation/familleArticles/$id/edit'
    | '/creation/familleArticles/$id/view'
    | '/creation/ldf/$id/edit'
    | '/creation/ldf/$id/view'
    | '/creation/postes/$id/edit'
    | '/creation/postes/$id/view'
    | '/creation/prestations/$id/edit'
    | '/creation/prestations/$id/view'
    | '/creation/univers-commerciaux/$id/edit'
    | '/creation/univers-commerciaux/$id/view'
    | '/production/lancements/$id/edit'
    | '/production/ordres-fabrication/$id/edit'
    | '/rh/collaborateurs/$id/edit'
    | '/rh/competences/$id/edit'
    | '/rh/competences/$id/view'
    | '/rh/conges/$id/view'
    | '/rh/conges/demandes/new'
    | '/rh/contrats/$id/edit'
    | '/rh/contrats/$id/view'
    | '/rh/horaires-de-travail/$id/edit'
    | '/rh/horaires-de-travail/$id/view'
    | '/rh/notes-de-frais/$id/edit'
    | '/rh/notes-de-frais/$id/view'
    | '/rh/planning/$id/edit'
    | '/rh/planning/$id/view'
    | '/stock/depots/$id/edit'
    | '/stock/depots/$id/view'
    | '/stock/emplacements/$id/edit'
    | '/stock/emplacements/$id/view'
    | '/stock/inventaires/$id/edit'
    | '/stock/inventaires/$id/view'
    | '/stock/mouvements/$id/edit'
    | '/stock/mouvements/$id/view'
    | '/stock/zones/$id/edit'
    | '/stock/zones/$id/view'
    | '/ventes/categories/$id/edit'
    | '/ventes/categories/$id/view'
    | '/ventes/clients/$id/edit'
    | '/ventes/clients/$id/view'
    | '/ventes/commandes/$id/edit'
    | '/ventes/commandes/$id/view'
    | '/ventes/crm/$id/edit'
    | '/ventes/crm/$id/view'
    | '/ventes/expeditions/$id/edit'
    | '/ventes/expeditions/$id/view'
    | '/ventes/facturation/$id/edit'
    | '/ventes/facturation/$id/view'
    | '/ventes/tarifs/$id/edit'
    | '/ventes/tarifs/$id/view'
    | '/ventes/tarifs/promotions/create'
    | '/ventes/tarifs/remises/create'
    | '/ventes/tarifs/taxes/create'
    | '/conges/me/'
    | '/contrats/me/'
    | '/documents/me/'
    | '/frais/me/'
    | '/planning/me/'
    | '/pointage/me/'
    | '/production/lancements/$id/'
    | '/production/ordres-fabrication/$id/'
    | '/rh/collaborateurs/$id/'
    | '/rh/contrats/$id/avenants/create'
    | '/ventes/tarifs/promotions/$id/edit'
    | '/ventes/tarifs/promotions/$id/view'
    | '/ventes/tarifs/remises/$id/edit'
    | '/ventes/tarifs/remises/$id/view'
    | '/ventes/tarifs/taxes/$id/edit'
    | '/ventes/tarifs/taxes/$id/view'
    | '/rh/contrats/$id/avenants/$avenantId/edit'
    | '/rh/contrats/$id/avenants/$avenantId/view'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/mentions-legales'
    | '/politique-confidentialite'
    | '/unauthorized'
    | '/parametres'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/setup-password'
    | '/stock/depots'
    | '/design-system/showcase'
    | '/tickets/create'
    | '/auth/pointage/$hash'
    | '/auth/pointage/qr-code'
    | '/auth/signature-contrat/$token'
    | '/achats'
    | '/admin'
    | '/comptabilite'
    | '/creation'
    | '/production'
    | '/rh'
    | '/stock'
    | '/tickets'
    | '/ventes'
    | '/conges/nouvelle-demande'
    | '/frais/create'
    | '/achats/commandes/create'
    | '/achats/factures/create'
    | '/achats/fournisseurs/create'
    | '/achats/fournitures/create'
    | '/achats/prestations/create'
    | '/achats/receptions/create'
    | '/admin/profiles/create'
    | '/creation/articles/create'
    | '/creation/ateliers/create'
    | '/creation/dossier-techniques/create'
    | '/creation/familleArticles/create'
    | '/creation/ldf/create'
    | '/creation/postes/create'
    | '/creation/prestations/create'
    | '/creation/univers-commerciaux/create'
    | '/production/lancements/create'
    | '/production/ordres-fabrication/create'
    | '/rh/collaborateurs/create'
    | '/rh/competences/create'
    | '/rh/conges/create'
    | '/rh/contrats/create'
    | '/rh/horaires-de-travail/create'
    | '/rh/notes-de-frais/create'
    | '/rh/planning/create'
    | '/stock/depots/create'
    | '/stock/emplacements/create'
    | '/stock/inventaires/create'
    | '/stock/mouvements/create'
    | '/stock/zones/create'
    | '/tickets/$id/edit'
    | '/tickets/$id/view'
    | '/ventes/categories/create'
    | '/ventes/clients/create'
    | '/ventes/commandes/create'
    | '/ventes/crm/create'
    | '/ventes/expeditions/create'
    | '/ventes/facturation/create'
    | '/ventes/tarifs/create'
    | '/frais'
    | '/mes-conges'
    | '/profile'
    | '/achats/commandes'
    | '/achats/factures'
    | '/achats/fournisseurs'
    | '/achats/fournitures'
    | '/achats/prestations'
    | '/achats/receptions'
    | '/admin/permissions'
    | '/admin/profiles'
    | '/admin/reference-data'
    | '/comptabilite/echeances'
    | '/comptabilite/ecotaxes'
    | '/comptabilite/factures-fournisseurs'
    | '/comptabilite/factures-ventes'
    | '/comptabilite/relances'
    | '/comptabilite/simplifiee'
    | '/creation/articles'
    | '/creation/ateliers'
    | '/creation/dossier-techniques'
    | '/creation/familleArticles'
    | '/creation/ldf'
    | '/creation/postes'
    | '/creation/prestations'
    | '/creation/univers-commerciaux'
    | '/production/calcul-besoins'
    | '/production/cloture'
    | '/production/declarations'
    | '/production/lancements'
    | '/production/ordres-fabrication'
    | '/rh/collaborateurs'
    | '/rh/competences'
    | '/rh/conges'
    | '/rh/contrats'
    | '/rh/documents'
    | '/rh/feuilles-de-temps'
    | '/rh/horaires-de-travail'
    | '/rh/notes-de-frais'
    | '/rh/planning'
    | '/stock/consultation'
    | '/stock/emplacements'
    | '/stock/inventaires'
    | '/stock/mouvements'
    | '/stock/zones'
    | '/ventes/categories'
    | '/ventes/clients'
    | '/ventes/commandes'
    | '/ventes/crm'
    | '/ventes/expeditions'
    | '/ventes/facturation'
    | '/ventes/tarifs'
    | '/rh/collaborateurs/$id/view'
    | '/frais/$id/edit'
    | '/frais/$id/view'
    | '/achats/commandes/$id/edit'
    | '/achats/commandes/$id/view'
    | '/achats/factures/$id/edit'
    | '/achats/factures/$id/view'
    | '/achats/fournisseurs/$id/edit'
    | '/achats/fournisseurs/$id/view'
    | '/achats/fournitures/$id/edit'
    | '/achats/fournitures/$id/view'
    | '/achats/prestations/$id/edit'
    | '/achats/prestations/$id/view'
    | '/achats/receptions/$id/edit'
    | '/achats/receptions/$id/view'
    | '/admin/profiles/$id/edit'
    | '/comptabilite/factures-fournisseurs/$id/view'
    | '/comptabilite/factures-ventes/$id/view'
    | '/comptabilite/relances/$id/view'
    | '/creation/articles/$id/edit'
    | '/creation/articles/$id/view'
    | '/creation/ateliers/$id/edit'
    | '/creation/ateliers/$id/view'
    | '/creation/dossier-techniques/$id/edit'
    | '/creation/dossier-techniques/$id/view'
    | '/creation/familleArticles/$id/edit'
    | '/creation/familleArticles/$id/view'
    | '/creation/ldf/$id/edit'
    | '/creation/ldf/$id/view'
    | '/creation/postes/$id/edit'
    | '/creation/postes/$id/view'
    | '/creation/prestations/$id/edit'
    | '/creation/prestations/$id/view'
    | '/creation/univers-commerciaux/$id/edit'
    | '/creation/univers-commerciaux/$id/view'
    | '/production/lancements/$id/edit'
    | '/production/ordres-fabrication/$id/edit'
    | '/rh/collaborateurs/$id/edit'
    | '/rh/competences/$id/edit'
    | '/rh/competences/$id/view'
    | '/rh/conges/$id/view'
    | '/rh/conges/demandes/new'
    | '/rh/contrats/$id/edit'
    | '/rh/contrats/$id/view'
    | '/rh/horaires-de-travail/$id/edit'
    | '/rh/horaires-de-travail/$id/view'
    | '/rh/notes-de-frais/$id/edit'
    | '/rh/notes-de-frais/$id/view'
    | '/rh/planning/$id/edit'
    | '/rh/planning/$id/view'
    | '/stock/depots/$id/edit'
    | '/stock/depots/$id/view'
    | '/stock/emplacements/$id/edit'
    | '/stock/emplacements/$id/view'
    | '/stock/inventaires/$id/edit'
    | '/stock/inventaires/$id/view'
    | '/stock/mouvements/$id/edit'
    | '/stock/mouvements/$id/view'
    | '/stock/zones/$id/edit'
    | '/stock/zones/$id/view'
    | '/ventes/categories/$id/edit'
    | '/ventes/categories/$id/view'
    | '/ventes/clients/$id/edit'
    | '/ventes/clients/$id/view'
    | '/ventes/commandes/$id/edit'
    | '/ventes/commandes/$id/view'
    | '/ventes/crm/$id/edit'
    | '/ventes/crm/$id/view'
    | '/ventes/expeditions/$id/edit'
    | '/ventes/expeditions/$id/view'
    | '/ventes/facturation/$id/edit'
    | '/ventes/facturation/$id/view'
    | '/ventes/tarifs/$id/edit'
    | '/ventes/tarifs/$id/view'
    | '/ventes/tarifs/promotions/create'
    | '/ventes/tarifs/remises/create'
    | '/ventes/tarifs/taxes/create'
    | '/conges/me'
    | '/contrats/me'
    | '/documents/me'
    | '/frais/me'
    | '/planning/me'
    | '/pointage/me'
    | '/production/lancements/$id'
    | '/production/ordres-fabrication/$id'
    | '/rh/collaborateurs/$id'
    | '/rh/contrats/$id/avenants/create'
    | '/ventes/tarifs/promotions/$id/edit'
    | '/ventes/tarifs/promotions/$id/view'
    | '/ventes/tarifs/remises/$id/edit'
    | '/ventes/tarifs/remises/$id/view'
    | '/ventes/tarifs/taxes/$id/edit'
    | '/ventes/tarifs/taxes/$id/view'
    | '/rh/contrats/$id/avenants/$avenantId/edit'
    | '/rh/contrats/$id/avenants/$avenantId/view'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/mentions-legales'
    | '/politique-confidentialite'
    | '/unauthorized'
    | '/_app/(dashboard)'
    | '/_app/achats'
    | '/_app/admin'
    | '/_app/comptabilite'
    | '/_app/creation'
    | '/_app/parametres'
    | '/_app/production'
    | '/_app/rh'
    | '/_app/stock'
    | '/_app/tickets'
    | '/_app/ventes'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/setup-password'
    | '/_app/creation/articles'
    | '/_app/creation/ateliers'
    | '/_app/creation/dossier-techniques'
    | '/_app/creation/familleArticles'
    | '/_app/creation/ldf'
    | '/_app/creation/postes'
    | '/_app/creation/prestations'
    | '/_app/creation/univers-commerciaux'
    | '/_app/production/calcul-besoins'
    | '/_app/production/cloture'
    | '/_app/production/declarations'
    | '/_app/production/lancements'
    | '/_app/production/ordres-fabrication'
    | '/_app/rh/collaborateurs'
    | '/_app/rh/competences'
    | '/_app/rh/conges'
    | '/_app/rh/contrats'
    | '/_app/rh/documents'
    | '/_app/rh/feuilles-de-temps'
    | '/_app/rh/horaires-de-travail'
    | '/_app/rh/planning'
    | '/_app/stock/consultation'
    | '/_app/stock/depots'
    | '/_app/stock/emplacements'
    | '/_app/stock/inventaires'
    | '/_app/stock/mouvements'
    | '/_app/stock/zones'
    | '/_app/design-system/showcase'
    | '/_app/tickets/create'
    | '/auth/pointage/$hash'
    | '/auth/pointage/qr-code'
    | '/auth/signature-contrat/$token'
    | '/_app/(dashboard)/'
    | '/_app/achats/'
    | '/_app/admin/'
    | '/_app/comptabilite/'
    | '/_app/creation/'
    | '/_app/production/'
    | '/_app/rh/'
    | '/_app/stock/'
    | '/_app/tickets/'
    | '/_app/ventes/'
    | '/_app/(dashboard)/conges/nouvelle-demande'
    | '/_app/(dashboard)/frais/create'
    | '/_app/achats/commandes/create'
    | '/_app/achats/factures/create'
    | '/_app/achats/fournisseurs/create'
    | '/_app/achats/fournitures/create'
    | '/_app/achats/prestations/create'
    | '/_app/achats/receptions/create'
    | '/_app/admin/profiles/create'
    | '/_app/creation/articles/create'
    | '/_app/creation/ateliers/create'
    | '/_app/creation/dossier-techniques/create'
    | '/_app/creation/familleArticles/create'
    | '/_app/creation/ldf/create'
    | '/_app/creation/postes/create'
    | '/_app/creation/prestations/create'
    | '/_app/creation/univers-commerciaux/create'
    | '/_app/production/lancements/create'
    | '/_app/production/ordres-fabrication/create'
    | '/_app/rh/collaborateurs/create'
    | '/_app/rh/competences/create'
    | '/_app/rh/conges/create'
    | '/_app/rh/contrats/create'
    | '/_app/rh/horaires-de-travail/create'
    | '/_app/rh/notes-de-frais/create'
    | '/_app/rh/planning/create'
    | '/_app/stock/depots/create'
    | '/_app/stock/emplacements/create'
    | '/_app/stock/inventaires/create'
    | '/_app/stock/mouvements/create'
    | '/_app/stock/zones/create'
    | '/_app/tickets/$id/edit'
    | '/_app/tickets/$id/view'
    | '/_app/ventes/categories/create'
    | '/_app/ventes/clients/create'
    | '/_app/ventes/commandes/create'
    | '/_app/ventes/crm/create'
    | '/_app/ventes/expeditions/create'
    | '/_app/ventes/facturation/create'
    | '/_app/ventes/tarifs/create'
    | '/_app/(dashboard)/frais/'
    | '/_app/(dashboard)/mes-conges/'
    | '/_app/(dashboard)/profile/'
    | '/_app/achats/commandes/'
    | '/_app/achats/factures/'
    | '/_app/achats/fournisseurs/'
    | '/_app/achats/fournitures/'
    | '/_app/achats/prestations/'
    | '/_app/achats/receptions/'
    | '/_app/admin/permissions/'
    | '/_app/admin/profiles/'
    | '/_app/admin/reference-data/'
    | '/_app/comptabilite/echeances/'
    | '/_app/comptabilite/ecotaxes/'
    | '/_app/comptabilite/factures-fournisseurs/'
    | '/_app/comptabilite/factures-ventes/'
    | '/_app/comptabilite/relances/'
    | '/_app/comptabilite/simplifiee/'
    | '/_app/creation/articles/'
    | '/_app/creation/ateliers/'
    | '/_app/creation/dossier-techniques/'
    | '/_app/creation/familleArticles/'
    | '/_app/creation/ldf/'
    | '/_app/creation/postes/'
    | '/_app/creation/prestations/'
    | '/_app/creation/univers-commerciaux/'
    | '/_app/production/calcul-besoins/'
    | '/_app/production/cloture/'
    | '/_app/production/declarations/'
    | '/_app/production/lancements/'
    | '/_app/production/ordres-fabrication/'
    | '/_app/rh/collaborateurs/'
    | '/_app/rh/competences/'
    | '/_app/rh/conges/'
    | '/_app/rh/contrats/'
    | '/_app/rh/documents/'
    | '/_app/rh/feuilles-de-temps/'
    | '/_app/rh/horaires-de-travail/'
    | '/_app/rh/notes-de-frais/'
    | '/_app/rh/planning/'
    | '/_app/stock/consultation/'
    | '/_app/stock/emplacements/'
    | '/_app/stock/inventaires/'
    | '/_app/stock/mouvements/'
    | '/_app/stock/zones/'
    | '/_app/ventes/categories/'
    | '/_app/ventes/clients/'
    | '/_app/ventes/commandes/'
    | '/_app/ventes/crm/'
    | '/_app/ventes/expeditions/'
    | '/_app/ventes/facturation/'
    | '/_app/ventes/tarifs/'
    | '/_app/rh/collaborateurs/$id/view'
    | '/_app/(dashboard)/frais/$id/edit'
    | '/_app/(dashboard)/frais/$id/view'
    | '/_app/achats/commandes/$id/edit'
    | '/_app/achats/commandes/$id/view'
    | '/_app/achats/factures/$id/edit'
    | '/_app/achats/factures/$id/view'
    | '/_app/achats/fournisseurs/$id/edit'
    | '/_app/achats/fournisseurs/$id/view'
    | '/_app/achats/fournitures/$id/edit'
    | '/_app/achats/fournitures/$id/view'
    | '/_app/achats/prestations/$id/edit'
    | '/_app/achats/prestations/$id/view'
    | '/_app/achats/receptions/$id/edit'
    | '/_app/achats/receptions/$id/view'
    | '/_app/admin/profiles/$id/edit'
    | '/_app/comptabilite/factures-fournisseurs/$id/view'
    | '/_app/comptabilite/factures-ventes/$id/view'
    | '/_app/comptabilite/relances/$id/view'
    | '/_app/creation/articles/$id/edit'
    | '/_app/creation/articles/$id/view'
    | '/_app/creation/ateliers/$id/edit'
    | '/_app/creation/ateliers/$id/view'
    | '/_app/creation/dossier-techniques/$id/edit'
    | '/_app/creation/dossier-techniques/$id/view'
    | '/_app/creation/familleArticles/$id/edit'
    | '/_app/creation/familleArticles/$id/view'
    | '/_app/creation/ldf/$id/edit'
    | '/_app/creation/ldf/$id/view'
    | '/_app/creation/postes/$id/edit'
    | '/_app/creation/postes/$id/view'
    | '/_app/creation/prestations/$id/edit'
    | '/_app/creation/prestations/$id/view'
    | '/_app/creation/univers-commerciaux/$id/edit'
    | '/_app/creation/univers-commerciaux/$id/view'
    | '/_app/production/lancements/$id/edit'
    | '/_app/production/ordres-fabrication/$id/edit'
    | '/_app/rh/collaborateurs/$id/edit'
    | '/_app/rh/competences/$id/edit'
    | '/_app/rh/competences/$id/view'
    | '/_app/rh/conges/$id/view'
    | '/_app/rh/conges/demandes/new'
    | '/_app/rh/contrats/$id/edit'
    | '/_app/rh/contrats/$id/view'
    | '/_app/rh/horaires-de-travail/$id/edit'
    | '/_app/rh/horaires-de-travail/$id/view'
    | '/_app/rh/notes-de-frais/$id/edit'
    | '/_app/rh/notes-de-frais/$id/view'
    | '/_app/rh/planning/$id/edit'
    | '/_app/rh/planning/$id/view'
    | '/_app/stock/depots/$id/edit'
    | '/_app/stock/depots/$id/view'
    | '/_app/stock/emplacements/$id/edit'
    | '/_app/stock/emplacements/$id/view'
    | '/_app/stock/inventaires/$id/edit'
    | '/_app/stock/inventaires/$id/view'
    | '/_app/stock/mouvements/$id/edit'
    | '/_app/stock/mouvements/$id/view'
    | '/_app/stock/zones/$id/edit'
    | '/_app/stock/zones/$id/view'
    | '/_app/ventes/categories/$id/edit'
    | '/_app/ventes/categories/$id/view'
    | '/_app/ventes/clients/$id/edit'
    | '/_app/ventes/clients/$id/view'
    | '/_app/ventes/commandes/$id/edit'
    | '/_app/ventes/commandes/$id/view'
    | '/_app/ventes/crm/$id/edit'
    | '/_app/ventes/crm/$id/view'
    | '/_app/ventes/expeditions/$id/edit'
    | '/_app/ventes/expeditions/$id/view'
    | '/_app/ventes/facturation/$id/edit'
    | '/_app/ventes/facturation/$id/view'
    | '/_app/ventes/tarifs/$id/edit'
    | '/_app/ventes/tarifs/$id/view'
    | '/_app/ventes/tarifs/promotions/create'
    | '/_app/ventes/tarifs/remises/create'
    | '/_app/ventes/tarifs/taxes/create'
    | '/_app/(dashboard)/conges/me/'
    | '/_app/(dashboard)/contrats/me/'
    | '/_app/(dashboard)/documents/me/'
    | '/_app/(dashboard)/frais/me/'
    | '/_app/(dashboard)/planning/me/'
    | '/_app/(dashboard)/pointage/me/'
    | '/_app/production/lancements/$id/'
    | '/_app/production/ordres-fabrication/$id/'
    | '/_app/rh/collaborateurs/$id/'
    | '/_app/rh/contrats/$id/avenants/create'
    | '/_app/ventes/tarifs/promotions/$id/edit'
    | '/_app/ventes/tarifs/promotions/$id/view'
    | '/_app/ventes/tarifs/remises/$id/edit'
    | '/_app/ventes/tarifs/remises/$id/view'
    | '/_app/ventes/tarifs/taxes/$id/edit'
    | '/_app/ventes/tarifs/taxes/$id/view'
    | '/_app/rh/contrats/$id/avenants/$avenantId/edit'
    | '/_app/rh/contrats/$id/avenants/$avenantId/view'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  MentionsLegalesRoute: typeof MentionsLegalesRoute
  PolitiqueConfidentialiteRoute: typeof PolitiqueConfidentialiteRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mentions-legales': {
      id: '/mentions-legales'
      path: '/mentions-legales'
      fullPath: '/mentions-legales'
      preLoaderRoute: typeof MentionsLegalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politique-confidentialite': {
      id: '/politique-confidentialite'
      path: '/politique-confidentialite'
      fullPath: '/politique-confidentialite'
      preLoaderRoute: typeof PolitiqueConfidentialiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/(dashboard)': {
      id: '/_app/(dashboard)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppdashboardRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/achats': {
      id: '/_app/achats'
      path: '/achats'
      fullPath: '/achats'
      preLoaderRoute: typeof AppAchatsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/comptabilite': {
      id: '/_app/comptabilite'
      path: '/comptabilite'
      fullPath: '/comptabilite'
      preLoaderRoute: typeof AppComptabiliteRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/creation': {
      id: '/_app/creation'
      path: '/creation'
      fullPath: '/creation'
      preLoaderRoute: typeof AppCreationRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/parametres': {
      id: '/_app/parametres'
      path: '/parametres'
      fullPath: '/parametres'
      preLoaderRoute: typeof AppParametresRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/production': {
      id: '/_app/production'
      path: '/production'
      fullPath: '/production'
      preLoaderRoute: typeof AppProductionRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/rh': {
      id: '/_app/rh'
      path: '/rh'
      fullPath: '/rh'
      preLoaderRoute: typeof AppRhRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/stock': {
      id: '/_app/stock'
      path: '/stock'
      fullPath: '/stock'
      preLoaderRoute: typeof AppStockRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/tickets': {
      id: '/_app/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AppTicketsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/ventes': {
      id: '/_app/ventes'
      path: '/ventes'
      fullPath: '/ventes'
      preLoaderRoute: typeof AppVentesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/setup-password': {
      id: '/auth/setup-password'
      path: '/setup-password'
      fullPath: '/auth/setup-password'
      preLoaderRoute: typeof AuthSetupPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/(dashboard)/': {
      id: '/_app/(dashboard)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppdashboardIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/achats/': {
      id: '/_app/achats/'
      path: '/'
      fullPath: '/achats/'
      preLoaderRoute: typeof AppAchatsIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/comptabilite/': {
      id: '/_app/comptabilite/'
      path: '/'
      fullPath: '/comptabilite/'
      preLoaderRoute: typeof AppComptabiliteIndexRouteImport
      parentRoute: typeof AppComptabiliteRouteRoute
    }
    '/_app/creation/': {
      id: '/_app/creation/'
      path: '/'
      fullPath: '/creation/'
      preLoaderRoute: typeof AppCreationIndexRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/articles': {
      id: '/_app/creation/articles'
      path: '/articles'
      fullPath: '/creation/articles'
      preLoaderRoute: typeof AppCreationArticlesRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/ateliers': {
      id: '/_app/creation/ateliers'
      path: '/ateliers'
      fullPath: '/creation/ateliers'
      preLoaderRoute: typeof AppCreationAteliersRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/dossier-techniques': {
      id: '/_app/creation/dossier-techniques'
      path: '/dossier-techniques'
      fullPath: '/creation/dossier-techniques'
      preLoaderRoute: typeof AppCreationDossierTechniquesRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/familleArticles': {
      id: '/_app/creation/familleArticles'
      path: '/familleArticles'
      fullPath: '/creation/familleArticles'
      preLoaderRoute: typeof AppCreationFamilleArticlesRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/ldf': {
      id: '/_app/creation/ldf'
      path: '/ldf'
      fullPath: '/creation/ldf'
      preLoaderRoute: typeof AppCreationLdfRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/postes': {
      id: '/_app/creation/postes'
      path: '/postes'
      fullPath: '/creation/postes'
      preLoaderRoute: typeof AppCreationPostesRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/prestations': {
      id: '/_app/creation/prestations'
      path: '/prestations'
      fullPath: '/creation/prestations'
      preLoaderRoute: typeof AppCreationPrestationsRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/univers-commerciaux': {
      id: '/_app/creation/univers-commerciaux'
      path: '/univers-commerciaux'
      fullPath: '/creation/univers-commerciaux'
      preLoaderRoute: typeof AppCreationUniversCommerciauxRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/design-system/showcase': {
      id: '/_app/design-system/showcase'
      path: '/design-system/showcase'
      fullPath: '/design-system/showcase'
      preLoaderRoute: typeof AppDesignSystemShowcaseRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/production/': {
      id: '/_app/production/'
      path: '/'
      fullPath: '/production/'
      preLoaderRoute: typeof AppProductionIndexRouteImport
      parentRoute: typeof AppProductionRouteRoute
    }
    '/_app/production/calcul-besoins': {
      id: '/_app/production/calcul-besoins'
      path: '/calcul-besoins'
      fullPath: '/production/calcul-besoins'
      preLoaderRoute: typeof AppProductionCalculBesoinsRouteRouteImport
      parentRoute: typeof AppProductionRouteRoute
    }
    '/_app/production/cloture': {
      id: '/_app/production/cloture'
      path: '/cloture'
      fullPath: '/production/cloture'
      preLoaderRoute: typeof AppProductionClotureRouteRouteImport
      parentRoute: typeof AppProductionRouteRoute
    }
    '/_app/production/declarations': {
      id: '/_app/production/declarations'
      path: '/declarations'
      fullPath: '/production/declarations'
      preLoaderRoute: typeof AppProductionDeclarationsRouteRouteImport
      parentRoute: typeof AppProductionRouteRoute
    }
    '/_app/production/lancements': {
      id: '/_app/production/lancements'
      path: '/lancements'
      fullPath: '/production/lancements'
      preLoaderRoute: typeof AppProductionLancementsRouteRouteImport
      parentRoute: typeof AppProductionRouteRoute
    }
    '/_app/production/ordres-fabrication': {
      id: '/_app/production/ordres-fabrication'
      path: '/ordres-fabrication'
      fullPath: '/production/ordres-fabrication'
      preLoaderRoute: typeof AppProductionOrdresFabricationRouteRouteImport
      parentRoute: typeof AppProductionRouteRoute
    }
    '/_app/rh/': {
      id: '/_app/rh/'
      path: '/'
      fullPath: '/rh/'
      preLoaderRoute: typeof AppRhIndexRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/collaborateurs': {
      id: '/_app/rh/collaborateurs'
      path: '/collaborateurs'
      fullPath: '/rh/collaborateurs'
      preLoaderRoute: typeof AppRhCollaborateursRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/competences': {
      id: '/_app/rh/competences'
      path: '/competences'
      fullPath: '/rh/competences'
      preLoaderRoute: typeof AppRhCompetencesRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/conges': {
      id: '/_app/rh/conges'
      path: '/conges'
      fullPath: '/rh/conges'
      preLoaderRoute: typeof AppRhCongesRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/contrats': {
      id: '/_app/rh/contrats'
      path: '/contrats'
      fullPath: '/rh/contrats'
      preLoaderRoute: typeof AppRhContratsRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/documents': {
      id: '/_app/rh/documents'
      path: '/documents'
      fullPath: '/rh/documents'
      preLoaderRoute: typeof AppRhDocumentsRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/feuilles-de-temps': {
      id: '/_app/rh/feuilles-de-temps'
      path: '/feuilles-de-temps'
      fullPath: '/rh/feuilles-de-temps'
      preLoaderRoute: typeof AppRhFeuillesDeTempsRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/horaires-de-travail': {
      id: '/_app/rh/horaires-de-travail'
      path: '/horaires-de-travail'
      fullPath: '/rh/horaires-de-travail'
      preLoaderRoute: typeof AppRhHorairesDeTravailRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/planning': {
      id: '/_app/rh/planning'
      path: '/planning'
      fullPath: '/rh/planning'
      preLoaderRoute: typeof AppRhPlanningRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/stock/': {
      id: '/_app/stock/'
      path: '/'
      fullPath: '/stock/'
      preLoaderRoute: typeof AppStockIndexRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/stock/consultation': {
      id: '/_app/stock/consultation'
      path: '/consultation'
      fullPath: '/stock/consultation'
      preLoaderRoute: typeof AppStockConsultationRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/stock/depots': {
      id: '/_app/stock/depots'
      path: '/depots'
      fullPath: '/stock/depots'
      preLoaderRoute: typeof AppStockDepotsRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/stock/emplacements': {
      id: '/_app/stock/emplacements'
      path: '/emplacements'
      fullPath: '/stock/emplacements'
      preLoaderRoute: typeof AppStockEmplacementsRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/stock/inventaires': {
      id: '/_app/stock/inventaires'
      path: '/inventaires'
      fullPath: '/stock/inventaires'
      preLoaderRoute: typeof AppStockInventairesRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/stock/mouvements': {
      id: '/_app/stock/mouvements'
      path: '/mouvements'
      fullPath: '/stock/mouvements'
      preLoaderRoute: typeof AppStockMouvementsRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/stock/zones': {
      id: '/_app/stock/zones'
      path: '/zones'
      fullPath: '/stock/zones'
      preLoaderRoute: typeof AppStockZonesRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/tickets/': {
      id: '/_app/tickets/'
      path: '/'
      fullPath: '/tickets/'
      preLoaderRoute: typeof AppTicketsIndexRouteImport
      parentRoute: typeof AppTicketsRouteRoute
    }
    '/_app/tickets/create': {
      id: '/_app/tickets/create'
      path: '/create'
      fullPath: '/tickets/create'
      preLoaderRoute: typeof AppTicketsCreateRouteImport
      parentRoute: typeof AppTicketsRouteRoute
    }
    '/_app/ventes/': {
      id: '/_app/ventes/'
      path: '/'
      fullPath: '/ventes/'
      preLoaderRoute: typeof AppVentesIndexRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/auth/pointage/$hash': {
      id: '/auth/pointage/$hash'
      path: '/pointage/$hash'
      fullPath: '/auth/pointage/$hash'
      preLoaderRoute: typeof AuthPointageHashRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/pointage/qr-code': {
      id: '/auth/pointage/qr-code'
      path: '/pointage/qr-code'
      fullPath: '/auth/pointage/qr-code'
      preLoaderRoute: typeof AuthPointageQrCodeRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/signature-contrat/$token': {
      id: '/auth/signature-contrat/$token'
      path: '/signature-contrat/$token'
      fullPath: '/auth/signature-contrat/$token'
      preLoaderRoute: typeof AuthSignatureContratTokenRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/(dashboard)/conges/nouvelle-demande': {
      id: '/_app/(dashboard)/conges/nouvelle-demande'
      path: '/conges/nouvelle-demande'
      fullPath: '/conges/nouvelle-demande'
      preLoaderRoute: typeof AppdashboardCongesNouvelleDemandeRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/frais/': {
      id: '/_app/(dashboard)/frais/'
      path: '/frais'
      fullPath: '/frais/'
      preLoaderRoute: typeof AppdashboardFraisIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/frais/create': {
      id: '/_app/(dashboard)/frais/create'
      path: '/frais/create'
      fullPath: '/frais/create'
      preLoaderRoute: typeof AppdashboardFraisCreateRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/mes-conges/': {
      id: '/_app/(dashboard)/mes-conges/'
      path: '/mes-conges'
      fullPath: '/mes-conges/'
      preLoaderRoute: typeof AppdashboardMesCongesIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/profile/': {
      id: '/_app/(dashboard)/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AppdashboardProfileIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/achats/commandes/': {
      id: '/_app/achats/commandes/'
      path: '/commandes'
      fullPath: '/achats/commandes/'
      preLoaderRoute: typeof AppAchatsCommandesIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/commandes/create': {
      id: '/_app/achats/commandes/create'
      path: '/commandes/create'
      fullPath: '/achats/commandes/create'
      preLoaderRoute: typeof AppAchatsCommandesCreateRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/factures/': {
      id: '/_app/achats/factures/'
      path: '/factures'
      fullPath: '/achats/factures/'
      preLoaderRoute: typeof AppAchatsFacturesIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/factures/create': {
      id: '/_app/achats/factures/create'
      path: '/factures/create'
      fullPath: '/achats/factures/create'
      preLoaderRoute: typeof AppAchatsFacturesCreateRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/fournisseurs/': {
      id: '/_app/achats/fournisseurs/'
      path: '/fournisseurs'
      fullPath: '/achats/fournisseurs/'
      preLoaderRoute: typeof AppAchatsFournisseursIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/fournisseurs/create': {
      id: '/_app/achats/fournisseurs/create'
      path: '/fournisseurs/create'
      fullPath: '/achats/fournisseurs/create'
      preLoaderRoute: typeof AppAchatsFournisseursCreateRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/fournitures/': {
      id: '/_app/achats/fournitures/'
      path: '/fournitures'
      fullPath: '/achats/fournitures/'
      preLoaderRoute: typeof AppAchatsFournituresIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/fournitures/create': {
      id: '/_app/achats/fournitures/create'
      path: '/fournitures/create'
      fullPath: '/achats/fournitures/create'
      preLoaderRoute: typeof AppAchatsFournituresCreateRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/prestations/': {
      id: '/_app/achats/prestations/'
      path: '/prestations'
      fullPath: '/achats/prestations/'
      preLoaderRoute: typeof AppAchatsPrestationsIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/prestations/create': {
      id: '/_app/achats/prestations/create'
      path: '/prestations/create'
      fullPath: '/achats/prestations/create'
      preLoaderRoute: typeof AppAchatsPrestationsCreateRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/receptions/': {
      id: '/_app/achats/receptions/'
      path: '/receptions'
      fullPath: '/achats/receptions/'
      preLoaderRoute: typeof AppAchatsReceptionsIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/receptions/create': {
      id: '/_app/achats/receptions/create'
      path: '/receptions/create'
      fullPath: '/achats/receptions/create'
      preLoaderRoute: typeof AppAchatsReceptionsCreateRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/admin/permissions/': {
      id: '/_app/admin/permissions/'
      path: '/permissions'
      fullPath: '/admin/permissions/'
      preLoaderRoute: typeof AppAdminPermissionsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/profiles/': {
      id: '/_app/admin/profiles/'
      path: '/profiles'
      fullPath: '/admin/profiles/'
      preLoaderRoute: typeof AppAdminProfilesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/profiles/create': {
      id: '/_app/admin/profiles/create'
      path: '/profiles/create'
      fullPath: '/admin/profiles/create'
      preLoaderRoute: typeof AppAdminProfilesCreateRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/reference-data/': {
      id: '/_app/admin/reference-data/'
      path: '/reference-data'
      fullPath: '/admin/reference-data/'
      preLoaderRoute: typeof AppAdminReferenceDataIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/comptabilite/echeances/': {
      id: '/_app/comptabilite/echeances/'
      path: '/echeances'
      fullPath: '/comptabilite/echeances/'
      preLoaderRoute: typeof AppComptabiliteEcheancesIndexRouteImport
      parentRoute: typeof AppComptabiliteRouteRoute
    }
    '/_app/comptabilite/ecotaxes/': {
      id: '/_app/comptabilite/ecotaxes/'
      path: '/ecotaxes'
      fullPath: '/comptabilite/ecotaxes/'
      preLoaderRoute: typeof AppComptabiliteEcotaxesIndexRouteImport
      parentRoute: typeof AppComptabiliteRouteRoute
    }
    '/_app/comptabilite/factures-fournisseurs/': {
      id: '/_app/comptabilite/factures-fournisseurs/'
      path: '/factures-fournisseurs'
      fullPath: '/comptabilite/factures-fournisseurs/'
      preLoaderRoute: typeof AppComptabiliteFacturesFournisseursIndexRouteImport
      parentRoute: typeof AppComptabiliteRouteRoute
    }
    '/_app/comptabilite/factures-ventes/': {
      id: '/_app/comptabilite/factures-ventes/'
      path: '/factures-ventes'
      fullPath: '/comptabilite/factures-ventes/'
      preLoaderRoute: typeof AppComptabiliteFacturesVentesIndexRouteImport
      parentRoute: typeof AppComptabiliteRouteRoute
    }
    '/_app/comptabilite/relances/': {
      id: '/_app/comptabilite/relances/'
      path: '/relances'
      fullPath: '/comptabilite/relances/'
      preLoaderRoute: typeof AppComptabiliteRelancesIndexRouteImport
      parentRoute: typeof AppComptabiliteRouteRoute
    }
    '/_app/comptabilite/simplifiee/': {
      id: '/_app/comptabilite/simplifiee/'
      path: '/simplifiee'
      fullPath: '/comptabilite/simplifiee/'
      preLoaderRoute: typeof AppComptabiliteSimplifieeIndexRouteImport
      parentRoute: typeof AppComptabiliteRouteRoute
    }
    '/_app/creation/articles/': {
      id: '/_app/creation/articles/'
      path: '/'
      fullPath: '/creation/articles/'
      preLoaderRoute: typeof AppCreationArticlesIndexRouteImport
      parentRoute: typeof AppCreationArticlesRouteRoute
    }
    '/_app/creation/articles/create': {
      id: '/_app/creation/articles/create'
      path: '/create'
      fullPath: '/creation/articles/create'
      preLoaderRoute: typeof AppCreationArticlesCreateRouteImport
      parentRoute: typeof AppCreationArticlesRouteRoute
    }
    '/_app/creation/ateliers/': {
      id: '/_app/creation/ateliers/'
      path: '/'
      fullPath: '/creation/ateliers/'
      preLoaderRoute: typeof AppCreationAteliersIndexRouteImport
      parentRoute: typeof AppCreationAteliersRouteRoute
    }
    '/_app/creation/ateliers/create': {
      id: '/_app/creation/ateliers/create'
      path: '/create'
      fullPath: '/creation/ateliers/create'
      preLoaderRoute: typeof AppCreationAteliersCreateRouteImport
      parentRoute: typeof AppCreationAteliersRouteRoute
    }
    '/_app/creation/dossier-techniques/': {
      id: '/_app/creation/dossier-techniques/'
      path: '/'
      fullPath: '/creation/dossier-techniques/'
      preLoaderRoute: typeof AppCreationDossierTechniquesIndexRouteImport
      parentRoute: typeof AppCreationDossierTechniquesRouteRoute
    }
    '/_app/creation/dossier-techniques/create': {
      id: '/_app/creation/dossier-techniques/create'
      path: '/create'
      fullPath: '/creation/dossier-techniques/create'
      preLoaderRoute: typeof AppCreationDossierTechniquesCreateRouteImport
      parentRoute: typeof AppCreationDossierTechniquesRouteRoute
    }
    '/_app/creation/familleArticles/': {
      id: '/_app/creation/familleArticles/'
      path: '/'
      fullPath: '/creation/familleArticles/'
      preLoaderRoute: typeof AppCreationFamilleArticlesIndexRouteImport
      parentRoute: typeof AppCreationFamilleArticlesRouteRoute
    }
    '/_app/creation/familleArticles/create': {
      id: '/_app/creation/familleArticles/create'
      path: '/create'
      fullPath: '/creation/familleArticles/create'
      preLoaderRoute: typeof AppCreationFamilleArticlesCreateRouteImport
      parentRoute: typeof AppCreationFamilleArticlesRouteRoute
    }
    '/_app/creation/ldf/': {
      id: '/_app/creation/ldf/'
      path: '/'
      fullPath: '/creation/ldf/'
      preLoaderRoute: typeof AppCreationLdfIndexRouteImport
      parentRoute: typeof AppCreationLdfRouteRoute
    }
    '/_app/creation/ldf/create': {
      id: '/_app/creation/ldf/create'
      path: '/create'
      fullPath: '/creation/ldf/create'
      preLoaderRoute: typeof AppCreationLdfCreateRouteImport
      parentRoute: typeof AppCreationLdfRouteRoute
    }
    '/_app/creation/postes/': {
      id: '/_app/creation/postes/'
      path: '/'
      fullPath: '/creation/postes/'
      preLoaderRoute: typeof AppCreationPostesIndexRouteImport
      parentRoute: typeof AppCreationPostesRouteRoute
    }
    '/_app/creation/postes/create': {
      id: '/_app/creation/postes/create'
      path: '/create'
      fullPath: '/creation/postes/create'
      preLoaderRoute: typeof AppCreationPostesCreateRouteImport
      parentRoute: typeof AppCreationPostesRouteRoute
    }
    '/_app/creation/prestations/': {
      id: '/_app/creation/prestations/'
      path: '/'
      fullPath: '/creation/prestations/'
      preLoaderRoute: typeof AppCreationPrestationsIndexRouteImport
      parentRoute: typeof AppCreationPrestationsRouteRoute
    }
    '/_app/creation/prestations/create': {
      id: '/_app/creation/prestations/create'
      path: '/create'
      fullPath: '/creation/prestations/create'
      preLoaderRoute: typeof AppCreationPrestationsCreateRouteImport
      parentRoute: typeof AppCreationPrestationsRouteRoute
    }
    '/_app/creation/univers-commerciaux/': {
      id: '/_app/creation/univers-commerciaux/'
      path: '/'
      fullPath: '/creation/univers-commerciaux/'
      preLoaderRoute: typeof AppCreationUniversCommerciauxIndexRouteImport
      parentRoute: typeof AppCreationUniversCommerciauxRouteRoute
    }
    '/_app/creation/univers-commerciaux/create': {
      id: '/_app/creation/univers-commerciaux/create'
      path: '/create'
      fullPath: '/creation/univers-commerciaux/create'
      preLoaderRoute: typeof AppCreationUniversCommerciauxCreateRouteImport
      parentRoute: typeof AppCreationUniversCommerciauxRouteRoute
    }
    '/_app/production/calcul-besoins/': {
      id: '/_app/production/calcul-besoins/'
      path: '/'
      fullPath: '/production/calcul-besoins/'
      preLoaderRoute: typeof AppProductionCalculBesoinsIndexRouteImport
      parentRoute: typeof AppProductionCalculBesoinsRouteRoute
    }
    '/_app/production/cloture/': {
      id: '/_app/production/cloture/'
      path: '/'
      fullPath: '/production/cloture/'
      preLoaderRoute: typeof AppProductionClotureIndexRouteImport
      parentRoute: typeof AppProductionClotureRouteRoute
    }
    '/_app/production/declarations/': {
      id: '/_app/production/declarations/'
      path: '/'
      fullPath: '/production/declarations/'
      preLoaderRoute: typeof AppProductionDeclarationsIndexRouteImport
      parentRoute: typeof AppProductionDeclarationsRouteRoute
    }
    '/_app/production/lancements/': {
      id: '/_app/production/lancements/'
      path: '/'
      fullPath: '/production/lancements/'
      preLoaderRoute: typeof AppProductionLancementsIndexRouteImport
      parentRoute: typeof AppProductionLancementsRouteRoute
    }
    '/_app/production/lancements/create': {
      id: '/_app/production/lancements/create'
      path: '/create'
      fullPath: '/production/lancements/create'
      preLoaderRoute: typeof AppProductionLancementsCreateRouteImport
      parentRoute: typeof AppProductionLancementsRouteRoute
    }
    '/_app/production/ordres-fabrication/': {
      id: '/_app/production/ordres-fabrication/'
      path: '/'
      fullPath: '/production/ordres-fabrication/'
      preLoaderRoute: typeof AppProductionOrdresFabricationIndexRouteImport
      parentRoute: typeof AppProductionOrdresFabricationRouteRoute
    }
    '/_app/production/ordres-fabrication/create': {
      id: '/_app/production/ordres-fabrication/create'
      path: '/create'
      fullPath: '/production/ordres-fabrication/create'
      preLoaderRoute: typeof AppProductionOrdresFabricationCreateRouteImport
      parentRoute: typeof AppProductionOrdresFabricationRouteRoute
    }
    '/_app/rh/collaborateurs/': {
      id: '/_app/rh/collaborateurs/'
      path: '/'
      fullPath: '/rh/collaborateurs/'
      preLoaderRoute: typeof AppRhCollaborateursIndexRouteImport
      parentRoute: typeof AppRhCollaborateursRouteRoute
    }
    '/_app/rh/collaborateurs/create': {
      id: '/_app/rh/collaborateurs/create'
      path: '/create'
      fullPath: '/rh/collaborateurs/create'
      preLoaderRoute: typeof AppRhCollaborateursCreateRouteImport
      parentRoute: typeof AppRhCollaborateursRouteRoute
    }
    '/_app/rh/competences/': {
      id: '/_app/rh/competences/'
      path: '/'
      fullPath: '/rh/competences/'
      preLoaderRoute: typeof AppRhCompetencesIndexRouteImport
      parentRoute: typeof AppRhCompetencesRouteRoute
    }
    '/_app/rh/competences/create': {
      id: '/_app/rh/competences/create'
      path: '/create'
      fullPath: '/rh/competences/create'
      preLoaderRoute: typeof AppRhCompetencesCreateRouteImport
      parentRoute: typeof AppRhCompetencesRouteRoute
    }
    '/_app/rh/conges/': {
      id: '/_app/rh/conges/'
      path: '/'
      fullPath: '/rh/conges/'
      preLoaderRoute: typeof AppRhCongesIndexRouteImport
      parentRoute: typeof AppRhCongesRouteRoute
    }
    '/_app/rh/conges/create': {
      id: '/_app/rh/conges/create'
      path: '/create'
      fullPath: '/rh/conges/create'
      preLoaderRoute: typeof AppRhCongesCreateRouteImport
      parentRoute: typeof AppRhCongesRouteRoute
    }
    '/_app/rh/contrats/': {
      id: '/_app/rh/contrats/'
      path: '/'
      fullPath: '/rh/contrats/'
      preLoaderRoute: typeof AppRhContratsIndexRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
    '/_app/rh/contrats/create': {
      id: '/_app/rh/contrats/create'
      path: '/create'
      fullPath: '/rh/contrats/create'
      preLoaderRoute: typeof AppRhContratsCreateRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
    '/_app/rh/documents/': {
      id: '/_app/rh/documents/'
      path: '/'
      fullPath: '/rh/documents/'
      preLoaderRoute: typeof AppRhDocumentsIndexRouteImport
      parentRoute: typeof AppRhDocumentsRouteRoute
    }
    '/_app/rh/feuilles-de-temps/': {
      id: '/_app/rh/feuilles-de-temps/'
      path: '/'
      fullPath: '/rh/feuilles-de-temps/'
      preLoaderRoute: typeof AppRhFeuillesDeTempsIndexRouteImport
      parentRoute: typeof AppRhFeuillesDeTempsRouteRoute
    }
    '/_app/rh/horaires-de-travail/': {
      id: '/_app/rh/horaires-de-travail/'
      path: '/'
      fullPath: '/rh/horaires-de-travail/'
      preLoaderRoute: typeof AppRhHorairesDeTravailIndexRouteImport
      parentRoute: typeof AppRhHorairesDeTravailRouteRoute
    }
    '/_app/rh/horaires-de-travail/create': {
      id: '/_app/rh/horaires-de-travail/create'
      path: '/create'
      fullPath: '/rh/horaires-de-travail/create'
      preLoaderRoute: typeof AppRhHorairesDeTravailCreateRouteImport
      parentRoute: typeof AppRhHorairesDeTravailRouteRoute
    }
    '/_app/rh/notes-de-frais/': {
      id: '/_app/rh/notes-de-frais/'
      path: '/notes-de-frais'
      fullPath: '/rh/notes-de-frais/'
      preLoaderRoute: typeof AppRhNotesDeFraisIndexRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/notes-de-frais/create': {
      id: '/_app/rh/notes-de-frais/create'
      path: '/notes-de-frais/create'
      fullPath: '/rh/notes-de-frais/create'
      preLoaderRoute: typeof AppRhNotesDeFraisCreateRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/planning/': {
      id: '/_app/rh/planning/'
      path: '/'
      fullPath: '/rh/planning/'
      preLoaderRoute: typeof AppRhPlanningIndexRouteImport
      parentRoute: typeof AppRhPlanningRouteRoute
    }
    '/_app/rh/planning/create': {
      id: '/_app/rh/planning/create'
      path: '/create'
      fullPath: '/rh/planning/create'
      preLoaderRoute: typeof AppRhPlanningCreateRouteImport
      parentRoute: typeof AppRhPlanningRouteRoute
    }
    '/_app/stock/consultation/': {
      id: '/_app/stock/consultation/'
      path: '/'
      fullPath: '/stock/consultation/'
      preLoaderRoute: typeof AppStockConsultationIndexRouteImport
      parentRoute: typeof AppStockConsultationRouteRoute
    }
    '/_app/stock/depots/create': {
      id: '/_app/stock/depots/create'
      path: '/create'
      fullPath: '/stock/depots/create'
      preLoaderRoute: typeof AppStockDepotsCreateRouteImport
      parentRoute: typeof AppStockDepotsRouteRoute
    }
    '/_app/stock/emplacements/': {
      id: '/_app/stock/emplacements/'
      path: '/'
      fullPath: '/stock/emplacements/'
      preLoaderRoute: typeof AppStockEmplacementsIndexRouteImport
      parentRoute: typeof AppStockEmplacementsRouteRoute
    }
    '/_app/stock/emplacements/create': {
      id: '/_app/stock/emplacements/create'
      path: '/create'
      fullPath: '/stock/emplacements/create'
      preLoaderRoute: typeof AppStockEmplacementsCreateRouteImport
      parentRoute: typeof AppStockEmplacementsRouteRoute
    }
    '/_app/stock/inventaires/': {
      id: '/_app/stock/inventaires/'
      path: '/'
      fullPath: '/stock/inventaires/'
      preLoaderRoute: typeof AppStockInventairesIndexRouteImport
      parentRoute: typeof AppStockInventairesRouteRoute
    }
    '/_app/stock/inventaires/create': {
      id: '/_app/stock/inventaires/create'
      path: '/create'
      fullPath: '/stock/inventaires/create'
      preLoaderRoute: typeof AppStockInventairesCreateRouteImport
      parentRoute: typeof AppStockInventairesRouteRoute
    }
    '/_app/stock/mouvements/': {
      id: '/_app/stock/mouvements/'
      path: '/'
      fullPath: '/stock/mouvements/'
      preLoaderRoute: typeof AppStockMouvementsIndexRouteImport
      parentRoute: typeof AppStockMouvementsRouteRoute
    }
    '/_app/stock/mouvements/create': {
      id: '/_app/stock/mouvements/create'
      path: '/create'
      fullPath: '/stock/mouvements/create'
      preLoaderRoute: typeof AppStockMouvementsCreateRouteImport
      parentRoute: typeof AppStockMouvementsRouteRoute
    }
    '/_app/stock/zones/': {
      id: '/_app/stock/zones/'
      path: '/'
      fullPath: '/stock/zones/'
      preLoaderRoute: typeof AppStockZonesIndexRouteImport
      parentRoute: typeof AppStockZonesRouteRoute
    }
    '/_app/stock/zones/create': {
      id: '/_app/stock/zones/create'
      path: '/create'
      fullPath: '/stock/zones/create'
      preLoaderRoute: typeof AppStockZonesCreateRouteImport
      parentRoute: typeof AppStockZonesRouteRoute
    }
    '/_app/tickets/$id/edit': {
      id: '/_app/tickets/$id/edit'
      path: '/$id/edit'
      fullPath: '/tickets/$id/edit'
      preLoaderRoute: typeof AppTicketsIdEditRouteImport
      parentRoute: typeof AppTicketsRouteRoute
    }
    '/_app/tickets/$id/view': {
      id: '/_app/tickets/$id/view'
      path: '/$id/view'
      fullPath: '/tickets/$id/view'
      preLoaderRoute: typeof AppTicketsIdViewRouteImport
      parentRoute: typeof AppTicketsRouteRoute
    }
    '/_app/ventes/categories/': {
      id: '/_app/ventes/categories/'
      path: '/categories'
      fullPath: '/ventes/categories/'
      preLoaderRoute: typeof AppVentesCategoriesIndexRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/categories/create': {
      id: '/_app/ventes/categories/create'
      path: '/categories/create'
      fullPath: '/ventes/categories/create'
      preLoaderRoute: typeof AppVentesCategoriesCreateRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/clients/': {
      id: '/_app/ventes/clients/'
      path: '/clients'
      fullPath: '/ventes/clients/'
      preLoaderRoute: typeof AppVentesClientsIndexRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/clients/create': {
      id: '/_app/ventes/clients/create'
      path: '/clients/create'
      fullPath: '/ventes/clients/create'
      preLoaderRoute: typeof AppVentesClientsCreateRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/commandes/': {
      id: '/_app/ventes/commandes/'
      path: '/commandes'
      fullPath: '/ventes/commandes/'
      preLoaderRoute: typeof AppVentesCommandesIndexRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/commandes/create': {
      id: '/_app/ventes/commandes/create'
      path: '/commandes/create'
      fullPath: '/ventes/commandes/create'
      preLoaderRoute: typeof AppVentesCommandesCreateRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/crm/': {
      id: '/_app/ventes/crm/'
      path: '/crm'
      fullPath: '/ventes/crm/'
      preLoaderRoute: typeof AppVentesCrmIndexRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/crm/create': {
      id: '/_app/ventes/crm/create'
      path: '/crm/create'
      fullPath: '/ventes/crm/create'
      preLoaderRoute: typeof AppVentesCrmCreateRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/expeditions/': {
      id: '/_app/ventes/expeditions/'
      path: '/expeditions'
      fullPath: '/ventes/expeditions/'
      preLoaderRoute: typeof AppVentesExpeditionsIndexRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/expeditions/create': {
      id: '/_app/ventes/expeditions/create'
      path: '/expeditions/create'
      fullPath: '/ventes/expeditions/create'
      preLoaderRoute: typeof AppVentesExpeditionsCreateRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/facturation/': {
      id: '/_app/ventes/facturation/'
      path: '/facturation'
      fullPath: '/ventes/facturation/'
      preLoaderRoute: typeof AppVentesFacturationIndexRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/facturation/create': {
      id: '/_app/ventes/facturation/create'
      path: '/facturation/create'
      fullPath: '/ventes/facturation/create'
      preLoaderRoute: typeof AppVentesFacturationCreateRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/': {
      id: '/_app/ventes/tarifs/'
      path: '/tarifs'
      fullPath: '/ventes/tarifs/'
      preLoaderRoute: typeof AppVentesTarifsIndexRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/create': {
      id: '/_app/ventes/tarifs/create'
      path: '/tarifs/create'
      fullPath: '/ventes/tarifs/create'
      preLoaderRoute: typeof AppVentesTarifsCreateRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/(dashboard)/conges/me/': {
      id: '/_app/(dashboard)/conges/me/'
      path: '/conges/me'
      fullPath: '/conges/me/'
      preLoaderRoute: typeof AppdashboardCongesMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/contrats/me/': {
      id: '/_app/(dashboard)/contrats/me/'
      path: '/contrats/me'
      fullPath: '/contrats/me/'
      preLoaderRoute: typeof AppdashboardContratsMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/documents/me/': {
      id: '/_app/(dashboard)/documents/me/'
      path: '/documents/me'
      fullPath: '/documents/me/'
      preLoaderRoute: typeof AppdashboardDocumentsMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/frais/$id/edit': {
      id: '/_app/(dashboard)/frais/$id/edit'
      path: '/frais/$id/edit'
      fullPath: '/frais/$id/edit'
      preLoaderRoute: typeof AppdashboardFraisIdEditRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/frais/$id/view': {
      id: '/_app/(dashboard)/frais/$id/view'
      path: '/frais/$id/view'
      fullPath: '/frais/$id/view'
      preLoaderRoute: typeof AppdashboardFraisIdViewRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/frais/me/': {
      id: '/_app/(dashboard)/frais/me/'
      path: '/frais/me'
      fullPath: '/frais/me/'
      preLoaderRoute: typeof AppdashboardFraisMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/planning/me/': {
      id: '/_app/(dashboard)/planning/me/'
      path: '/planning/me'
      fullPath: '/planning/me/'
      preLoaderRoute: typeof AppdashboardPlanningMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/pointage/me/': {
      id: '/_app/(dashboard)/pointage/me/'
      path: '/pointage/me'
      fullPath: '/pointage/me/'
      preLoaderRoute: typeof AppdashboardPointageMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/achats/commandes/$id/edit': {
      id: '/_app/achats/commandes/$id/edit'
      path: '/commandes/$id/edit'
      fullPath: '/achats/commandes/$id/edit'
      preLoaderRoute: typeof AppAchatsCommandesIdEditRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/commandes/$id/view': {
      id: '/_app/achats/commandes/$id/view'
      path: '/commandes/$id/view'
      fullPath: '/achats/commandes/$id/view'
      preLoaderRoute: typeof AppAchatsCommandesIdViewRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/factures/$id/edit': {
      id: '/_app/achats/factures/$id/edit'
      path: '/factures/$id/edit'
      fullPath: '/achats/factures/$id/edit'
      preLoaderRoute: typeof AppAchatsFacturesIdEditRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/factures/$id/view': {
      id: '/_app/achats/factures/$id/view'
      path: '/factures/$id/view'
      fullPath: '/achats/factures/$id/view'
      preLoaderRoute: typeof AppAchatsFacturesIdViewRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/fournisseurs/$id/edit': {
      id: '/_app/achats/fournisseurs/$id/edit'
      path: '/fournisseurs/$id/edit'
      fullPath: '/achats/fournisseurs/$id/edit'
      preLoaderRoute: typeof AppAchatsFournisseursIdEditRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/fournisseurs/$id/view': {
      id: '/_app/achats/fournisseurs/$id/view'
      path: '/fournisseurs/$id/view'
      fullPath: '/achats/fournisseurs/$id/view'
      preLoaderRoute: typeof AppAchatsFournisseursIdViewRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/fournitures/$id/edit': {
      id: '/_app/achats/fournitures/$id/edit'
      path: '/fournitures/$id/edit'
      fullPath: '/achats/fournitures/$id/edit'
      preLoaderRoute: typeof AppAchatsFournituresIdEditRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/fournitures/$id/view': {
      id: '/_app/achats/fournitures/$id/view'
      path: '/fournitures/$id/view'
      fullPath: '/achats/fournitures/$id/view'
      preLoaderRoute: typeof AppAchatsFournituresIdViewRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/prestations/$id/edit': {
      id: '/_app/achats/prestations/$id/edit'
      path: '/prestations/$id/edit'
      fullPath: '/achats/prestations/$id/edit'
      preLoaderRoute: typeof AppAchatsPrestationsIdEditRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/prestations/$id/view': {
      id: '/_app/achats/prestations/$id/view'
      path: '/prestations/$id/view'
      fullPath: '/achats/prestations/$id/view'
      preLoaderRoute: typeof AppAchatsPrestationsIdViewRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/receptions/$id/edit': {
      id: '/_app/achats/receptions/$id/edit'
      path: '/receptions/$id/edit'
      fullPath: '/achats/receptions/$id/edit'
      preLoaderRoute: typeof AppAchatsReceptionsIdEditRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/receptions/$id/view': {
      id: '/_app/achats/receptions/$id/view'
      path: '/receptions/$id/view'
      fullPath: '/achats/receptions/$id/view'
      preLoaderRoute: typeof AppAchatsReceptionsIdViewRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/admin/profiles/$id/edit': {
      id: '/_app/admin/profiles/$id/edit'
      path: '/profiles/$id/edit'
      fullPath: '/admin/profiles/$id/edit'
      preLoaderRoute: typeof AppAdminProfilesIdEditRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/comptabilite/factures-fournisseurs/$id/view': {
      id: '/_app/comptabilite/factures-fournisseurs/$id/view'
      path: '/factures-fournisseurs/$id/view'
      fullPath: '/comptabilite/factures-fournisseurs/$id/view'
      preLoaderRoute: typeof AppComptabiliteFacturesFournisseursIdViewRouteImport
      parentRoute: typeof AppComptabiliteRouteRoute
    }
    '/_app/comptabilite/factures-ventes/$id/view': {
      id: '/_app/comptabilite/factures-ventes/$id/view'
      path: '/factures-ventes/$id/view'
      fullPath: '/comptabilite/factures-ventes/$id/view'
      preLoaderRoute: typeof AppComptabiliteFacturesVentesIdViewRouteImport
      parentRoute: typeof AppComptabiliteRouteRoute
    }
    '/_app/comptabilite/relances/$id/view': {
      id: '/_app/comptabilite/relances/$id/view'
      path: '/relances/$id/view'
      fullPath: '/comptabilite/relances/$id/view'
      preLoaderRoute: typeof AppComptabiliteRelancesIdViewRouteImport
      parentRoute: typeof AppComptabiliteRouteRoute
    }
    '/_app/creation/articles/$id/edit': {
      id: '/_app/creation/articles/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/articles/$id/edit'
      preLoaderRoute: typeof AppCreationArticlesIdEditRouteImport
      parentRoute: typeof AppCreationArticlesRouteRoute
    }
    '/_app/creation/articles/$id/view': {
      id: '/_app/creation/articles/$id/view'
      path: '/$id/view'
      fullPath: '/creation/articles/$id/view'
      preLoaderRoute: typeof AppCreationArticlesIdViewRouteImport
      parentRoute: typeof AppCreationArticlesRouteRoute
    }
    '/_app/creation/ateliers/$id/edit': {
      id: '/_app/creation/ateliers/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/ateliers/$id/edit'
      preLoaderRoute: typeof AppCreationAteliersIdEditRouteImport
      parentRoute: typeof AppCreationAteliersRouteRoute
    }
    '/_app/creation/ateliers/$id/view': {
      id: '/_app/creation/ateliers/$id/view'
      path: '/$id/view'
      fullPath: '/creation/ateliers/$id/view'
      preLoaderRoute: typeof AppCreationAteliersIdViewRouteImport
      parentRoute: typeof AppCreationAteliersRouteRoute
    }
    '/_app/creation/dossier-techniques/$id/edit': {
      id: '/_app/creation/dossier-techniques/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/dossier-techniques/$id/edit'
      preLoaderRoute: typeof AppCreationDossierTechniquesIdEditRouteImport
      parentRoute: typeof AppCreationDossierTechniquesRouteRoute
    }
    '/_app/creation/dossier-techniques/$id/view': {
      id: '/_app/creation/dossier-techniques/$id/view'
      path: '/$id/view'
      fullPath: '/creation/dossier-techniques/$id/view'
      preLoaderRoute: typeof AppCreationDossierTechniquesIdViewRouteImport
      parentRoute: typeof AppCreationDossierTechniquesRouteRoute
    }
    '/_app/creation/familleArticles/$id/edit': {
      id: '/_app/creation/familleArticles/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/familleArticles/$id/edit'
      preLoaderRoute: typeof AppCreationFamilleArticlesIdEditRouteImport
      parentRoute: typeof AppCreationFamilleArticlesRouteRoute
    }
    '/_app/creation/familleArticles/$id/view': {
      id: '/_app/creation/familleArticles/$id/view'
      path: '/$id/view'
      fullPath: '/creation/familleArticles/$id/view'
      preLoaderRoute: typeof AppCreationFamilleArticlesIdViewRouteImport
      parentRoute: typeof AppCreationFamilleArticlesRouteRoute
    }
    '/_app/creation/ldf/$id/edit': {
      id: '/_app/creation/ldf/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/ldf/$id/edit'
      preLoaderRoute: typeof AppCreationLdfIdEditRouteImport
      parentRoute: typeof AppCreationLdfRouteRoute
    }
    '/_app/creation/ldf/$id/view': {
      id: '/_app/creation/ldf/$id/view'
      path: '/$id/view'
      fullPath: '/creation/ldf/$id/view'
      preLoaderRoute: typeof AppCreationLdfIdViewRouteImport
      parentRoute: typeof AppCreationLdfRouteRoute
    }
    '/_app/creation/postes/$id/edit': {
      id: '/_app/creation/postes/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/postes/$id/edit'
      preLoaderRoute: typeof AppCreationPostesIdEditRouteImport
      parentRoute: typeof AppCreationPostesRouteRoute
    }
    '/_app/creation/postes/$id/view': {
      id: '/_app/creation/postes/$id/view'
      path: '/$id/view'
      fullPath: '/creation/postes/$id/view'
      preLoaderRoute: typeof AppCreationPostesIdViewRouteImport
      parentRoute: typeof AppCreationPostesRouteRoute
    }
    '/_app/creation/prestations/$id/edit': {
      id: '/_app/creation/prestations/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/prestations/$id/edit'
      preLoaderRoute: typeof AppCreationPrestationsIdEditRouteImport
      parentRoute: typeof AppCreationPrestationsRouteRoute
    }
    '/_app/creation/prestations/$id/view': {
      id: '/_app/creation/prestations/$id/view'
      path: '/$id/view'
      fullPath: '/creation/prestations/$id/view'
      preLoaderRoute: typeof AppCreationPrestationsIdViewRouteImport
      parentRoute: typeof AppCreationPrestationsRouteRoute
    }
    '/_app/creation/univers-commerciaux/$id/edit': {
      id: '/_app/creation/univers-commerciaux/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/univers-commerciaux/$id/edit'
      preLoaderRoute: typeof AppCreationUniversCommerciauxIdEditRouteImport
      parentRoute: typeof AppCreationUniversCommerciauxRouteRoute
    }
    '/_app/creation/univers-commerciaux/$id/view': {
      id: '/_app/creation/univers-commerciaux/$id/view'
      path: '/$id/view'
      fullPath: '/creation/univers-commerciaux/$id/view'
      preLoaderRoute: typeof AppCreationUniversCommerciauxIdViewRouteImport
      parentRoute: typeof AppCreationUniversCommerciauxRouteRoute
    }
    '/_app/production/lancements/$id/': {
      id: '/_app/production/lancements/$id/'
      path: '/$id'
      fullPath: '/production/lancements/$id/'
      preLoaderRoute: typeof AppProductionLancementsIdIndexRouteImport
      parentRoute: typeof AppProductionLancementsRouteRoute
    }
    '/_app/production/lancements/$id/edit': {
      id: '/_app/production/lancements/$id/edit'
      path: '/$id/edit'
      fullPath: '/production/lancements/$id/edit'
      preLoaderRoute: typeof AppProductionLancementsIdEditRouteImport
      parentRoute: typeof AppProductionLancementsRouteRoute
    }
    '/_app/production/ordres-fabrication/$id/': {
      id: '/_app/production/ordres-fabrication/$id/'
      path: '/$id'
      fullPath: '/production/ordres-fabrication/$id/'
      preLoaderRoute: typeof AppProductionOrdresFabricationIdIndexRouteImport
      parentRoute: typeof AppProductionOrdresFabricationRouteRoute
    }
    '/_app/production/ordres-fabrication/$id/edit': {
      id: '/_app/production/ordres-fabrication/$id/edit'
      path: '/$id/edit'
      fullPath: '/production/ordres-fabrication/$id/edit'
      preLoaderRoute: typeof AppProductionOrdresFabricationIdEditRouteImport
      parentRoute: typeof AppProductionOrdresFabricationRouteRoute
    }
    '/_app/rh/collaborateurs/$id/': {
      id: '/_app/rh/collaborateurs/$id/'
      path: '/$id'
      fullPath: '/rh/collaborateurs/$id/'
      preLoaderRoute: typeof AppRhCollaborateursIdIndexRouteImport
      parentRoute: typeof AppRhCollaborateursRouteRoute
    }
    '/_app/rh/collaborateurs/$id/edit': {
      id: '/_app/rh/collaborateurs/$id/edit'
      path: '/$id/edit'
      fullPath: '/rh/collaborateurs/$id/edit'
      preLoaderRoute: typeof AppRhCollaborateursIdEditRouteImport
      parentRoute: typeof AppRhCollaborateursRouteRoute
    }
    '/_app/rh/collaborateurs/$id/view': {
      id: '/_app/rh/collaborateurs/$id/view'
      path: '/$id/view'
      fullPath: '/rh/collaborateurs/$id/view'
      preLoaderRoute: typeof AppRhCollaborateursIdViewRouteRouteImport
      parentRoute: typeof AppRhCollaborateursRouteRoute
    }
    '/_app/rh/competences/$id/edit': {
      id: '/_app/rh/competences/$id/edit'
      path: '/$id/edit'
      fullPath: '/rh/competences/$id/edit'
      preLoaderRoute: typeof AppRhCompetencesIdEditRouteImport
      parentRoute: typeof AppRhCompetencesRouteRoute
    }
    '/_app/rh/competences/$id/view': {
      id: '/_app/rh/competences/$id/view'
      path: '/$id/view'
      fullPath: '/rh/competences/$id/view'
      preLoaderRoute: typeof AppRhCompetencesIdViewRouteImport
      parentRoute: typeof AppRhCompetencesRouteRoute
    }
    '/_app/rh/conges/$id/view': {
      id: '/_app/rh/conges/$id/view'
      path: '/$id/view'
      fullPath: '/rh/conges/$id/view'
      preLoaderRoute: typeof AppRhCongesIdViewRouteImport
      parentRoute: typeof AppRhCongesRouteRoute
    }
    '/_app/rh/conges/demandes/new': {
      id: '/_app/rh/conges/demandes/new'
      path: '/demandes/new'
      fullPath: '/rh/conges/demandes/new'
      preLoaderRoute: typeof AppRhCongesDemandesNewRouteImport
      parentRoute: typeof AppRhCongesRouteRoute
    }
    '/_app/rh/contrats/$id/edit': {
      id: '/_app/rh/contrats/$id/edit'
      path: '/$id/edit'
      fullPath: '/rh/contrats/$id/edit'
      preLoaderRoute: typeof AppRhContratsIdEditRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
    '/_app/rh/contrats/$id/view': {
      id: '/_app/rh/contrats/$id/view'
      path: '/$id/view'
      fullPath: '/rh/contrats/$id/view'
      preLoaderRoute: typeof AppRhContratsIdViewRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
    '/_app/rh/horaires-de-travail/$id/edit': {
      id: '/_app/rh/horaires-de-travail/$id/edit'
      path: '/$id/edit'
      fullPath: '/rh/horaires-de-travail/$id/edit'
      preLoaderRoute: typeof AppRhHorairesDeTravailIdEditRouteImport
      parentRoute: typeof AppRhHorairesDeTravailRouteRoute
    }
    '/_app/rh/horaires-de-travail/$id/view': {
      id: '/_app/rh/horaires-de-travail/$id/view'
      path: '/$id/view'
      fullPath: '/rh/horaires-de-travail/$id/view'
      preLoaderRoute: typeof AppRhHorairesDeTravailIdViewRouteImport
      parentRoute: typeof AppRhHorairesDeTravailRouteRoute
    }
    '/_app/rh/notes-de-frais/$id/edit': {
      id: '/_app/rh/notes-de-frais/$id/edit'
      path: '/notes-de-frais/$id/edit'
      fullPath: '/rh/notes-de-frais/$id/edit'
      preLoaderRoute: typeof AppRhNotesDeFraisIdEditRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/notes-de-frais/$id/view': {
      id: '/_app/rh/notes-de-frais/$id/view'
      path: '/notes-de-frais/$id/view'
      fullPath: '/rh/notes-de-frais/$id/view'
      preLoaderRoute: typeof AppRhNotesDeFraisIdViewRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/planning/$id/edit': {
      id: '/_app/rh/planning/$id/edit'
      path: '/$id/edit'
      fullPath: '/rh/planning/$id/edit'
      preLoaderRoute: typeof AppRhPlanningIdEditRouteImport
      parentRoute: typeof AppRhPlanningRouteRoute
    }
    '/_app/rh/planning/$id/view': {
      id: '/_app/rh/planning/$id/view'
      path: '/$id/view'
      fullPath: '/rh/planning/$id/view'
      preLoaderRoute: typeof AppRhPlanningIdViewRouteImport
      parentRoute: typeof AppRhPlanningRouteRoute
    }
    '/_app/stock/depots/$id/edit': {
      id: '/_app/stock/depots/$id/edit'
      path: '/$id/edit'
      fullPath: '/stock/depots/$id/edit'
      preLoaderRoute: typeof AppStockDepotsIdEditRouteImport
      parentRoute: typeof AppStockDepotsRouteRoute
    }
    '/_app/stock/depots/$id/view': {
      id: '/_app/stock/depots/$id/view'
      path: '/$id/view'
      fullPath: '/stock/depots/$id/view'
      preLoaderRoute: typeof AppStockDepotsIdViewRouteImport
      parentRoute: typeof AppStockDepotsRouteRoute
    }
    '/_app/stock/emplacements/$id/edit': {
      id: '/_app/stock/emplacements/$id/edit'
      path: '/$id/edit'
      fullPath: '/stock/emplacements/$id/edit'
      preLoaderRoute: typeof AppStockEmplacementsIdEditRouteImport
      parentRoute: typeof AppStockEmplacementsRouteRoute
    }
    '/_app/stock/emplacements/$id/view': {
      id: '/_app/stock/emplacements/$id/view'
      path: '/$id/view'
      fullPath: '/stock/emplacements/$id/view'
      preLoaderRoute: typeof AppStockEmplacementsIdViewRouteImport
      parentRoute: typeof AppStockEmplacementsRouteRoute
    }
    '/_app/stock/inventaires/$id/edit': {
      id: '/_app/stock/inventaires/$id/edit'
      path: '/$id/edit'
      fullPath: '/stock/inventaires/$id/edit'
      preLoaderRoute: typeof AppStockInventairesIdEditRouteImport
      parentRoute: typeof AppStockInventairesRouteRoute
    }
    '/_app/stock/inventaires/$id/view': {
      id: '/_app/stock/inventaires/$id/view'
      path: '/$id/view'
      fullPath: '/stock/inventaires/$id/view'
      preLoaderRoute: typeof AppStockInventairesIdViewRouteImport
      parentRoute: typeof AppStockInventairesRouteRoute
    }
    '/_app/stock/mouvements/$id/edit': {
      id: '/_app/stock/mouvements/$id/edit'
      path: '/$id/edit'
      fullPath: '/stock/mouvements/$id/edit'
      preLoaderRoute: typeof AppStockMouvementsIdEditRouteImport
      parentRoute: typeof AppStockMouvementsRouteRoute
    }
    '/_app/stock/mouvements/$id/view': {
      id: '/_app/stock/mouvements/$id/view'
      path: '/$id/view'
      fullPath: '/stock/mouvements/$id/view'
      preLoaderRoute: typeof AppStockMouvementsIdViewRouteImport
      parentRoute: typeof AppStockMouvementsRouteRoute
    }
    '/_app/stock/zones/$id/edit': {
      id: '/_app/stock/zones/$id/edit'
      path: '/$id/edit'
      fullPath: '/stock/zones/$id/edit'
      preLoaderRoute: typeof AppStockZonesIdEditRouteImport
      parentRoute: typeof AppStockZonesRouteRoute
    }
    '/_app/stock/zones/$id/view': {
      id: '/_app/stock/zones/$id/view'
      path: '/$id/view'
      fullPath: '/stock/zones/$id/view'
      preLoaderRoute: typeof AppStockZonesIdViewRouteImport
      parentRoute: typeof AppStockZonesRouteRoute
    }
    '/_app/ventes/categories/$id/edit': {
      id: '/_app/ventes/categories/$id/edit'
      path: '/categories/$id/edit'
      fullPath: '/ventes/categories/$id/edit'
      preLoaderRoute: typeof AppVentesCategoriesIdEditRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/categories/$id/view': {
      id: '/_app/ventes/categories/$id/view'
      path: '/categories/$id/view'
      fullPath: '/ventes/categories/$id/view'
      preLoaderRoute: typeof AppVentesCategoriesIdViewRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/clients/$id/edit': {
      id: '/_app/ventes/clients/$id/edit'
      path: '/clients/$id/edit'
      fullPath: '/ventes/clients/$id/edit'
      preLoaderRoute: typeof AppVentesClientsIdEditRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/clients/$id/view': {
      id: '/_app/ventes/clients/$id/view'
      path: '/clients/$id/view'
      fullPath: '/ventes/clients/$id/view'
      preLoaderRoute: typeof AppVentesClientsIdViewRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/commandes/$id/edit': {
      id: '/_app/ventes/commandes/$id/edit'
      path: '/commandes/$id/edit'
      fullPath: '/ventes/commandes/$id/edit'
      preLoaderRoute: typeof AppVentesCommandesIdEditRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/commandes/$id/view': {
      id: '/_app/ventes/commandes/$id/view'
      path: '/commandes/$id/view'
      fullPath: '/ventes/commandes/$id/view'
      preLoaderRoute: typeof AppVentesCommandesIdViewRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/crm/$id/edit': {
      id: '/_app/ventes/crm/$id/edit'
      path: '/crm/$id/edit'
      fullPath: '/ventes/crm/$id/edit'
      preLoaderRoute: typeof AppVentesCrmIdEditRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/crm/$id/view': {
      id: '/_app/ventes/crm/$id/view'
      path: '/crm/$id/view'
      fullPath: '/ventes/crm/$id/view'
      preLoaderRoute: typeof AppVentesCrmIdViewRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/expeditions/$id/edit': {
      id: '/_app/ventes/expeditions/$id/edit'
      path: '/expeditions/$id/edit'
      fullPath: '/ventes/expeditions/$id/edit'
      preLoaderRoute: typeof AppVentesExpeditionsIdEditRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/expeditions/$id/view': {
      id: '/_app/ventes/expeditions/$id/view'
      path: '/expeditions/$id/view'
      fullPath: '/ventes/expeditions/$id/view'
      preLoaderRoute: typeof AppVentesExpeditionsIdViewRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/facturation/$id/edit': {
      id: '/_app/ventes/facturation/$id/edit'
      path: '/facturation/$id/edit'
      fullPath: '/ventes/facturation/$id/edit'
      preLoaderRoute: typeof AppVentesFacturationIdEditRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/facturation/$id/view': {
      id: '/_app/ventes/facturation/$id/view'
      path: '/facturation/$id/view'
      fullPath: '/ventes/facturation/$id/view'
      preLoaderRoute: typeof AppVentesFacturationIdViewRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/$id/edit': {
      id: '/_app/ventes/tarifs/$id/edit'
      path: '/tarifs/$id/edit'
      fullPath: '/ventes/tarifs/$id/edit'
      preLoaderRoute: typeof AppVentesTarifsIdEditRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/$id/view': {
      id: '/_app/ventes/tarifs/$id/view'
      path: '/tarifs/$id/view'
      fullPath: '/ventes/tarifs/$id/view'
      preLoaderRoute: typeof AppVentesTarifsIdViewRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/promotions/create': {
      id: '/_app/ventes/tarifs/promotions/create'
      path: '/tarifs/promotions/create'
      fullPath: '/ventes/tarifs/promotions/create'
      preLoaderRoute: typeof AppVentesTarifsPromotionsCreateRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/remises/create': {
      id: '/_app/ventes/tarifs/remises/create'
      path: '/tarifs/remises/create'
      fullPath: '/ventes/tarifs/remises/create'
      preLoaderRoute: typeof AppVentesTarifsRemisesCreateRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/taxes/create': {
      id: '/_app/ventes/tarifs/taxes/create'
      path: '/tarifs/taxes/create'
      fullPath: '/ventes/tarifs/taxes/create'
      preLoaderRoute: typeof AppVentesTarifsTaxesCreateRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/rh/contrats/$id/avenants/create': {
      id: '/_app/rh/contrats/$id/avenants/create'
      path: '/$id/avenants/create'
      fullPath: '/rh/contrats/$id/avenants/create'
      preLoaderRoute: typeof AppRhContratsIdAvenantsCreateRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
    '/_app/ventes/tarifs/promotions/$id/edit': {
      id: '/_app/ventes/tarifs/promotions/$id/edit'
      path: '/tarifs/promotions/$id/edit'
      fullPath: '/ventes/tarifs/promotions/$id/edit'
      preLoaderRoute: typeof AppVentesTarifsPromotionsIdEditRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/promotions/$id/view': {
      id: '/_app/ventes/tarifs/promotions/$id/view'
      path: '/tarifs/promotions/$id/view'
      fullPath: '/ventes/tarifs/promotions/$id/view'
      preLoaderRoute: typeof AppVentesTarifsPromotionsIdViewRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/remises/$id/edit': {
      id: '/_app/ventes/tarifs/remises/$id/edit'
      path: '/tarifs/remises/$id/edit'
      fullPath: '/ventes/tarifs/remises/$id/edit'
      preLoaderRoute: typeof AppVentesTarifsRemisesIdEditRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/remises/$id/view': {
      id: '/_app/ventes/tarifs/remises/$id/view'
      path: '/tarifs/remises/$id/view'
      fullPath: '/ventes/tarifs/remises/$id/view'
      preLoaderRoute: typeof AppVentesTarifsRemisesIdViewRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/taxes/$id/edit': {
      id: '/_app/ventes/tarifs/taxes/$id/edit'
      path: '/tarifs/taxes/$id/edit'
      fullPath: '/ventes/tarifs/taxes/$id/edit'
      preLoaderRoute: typeof AppVentesTarifsTaxesIdEditRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/ventes/tarifs/taxes/$id/view': {
      id: '/_app/ventes/tarifs/taxes/$id/view'
      path: '/tarifs/taxes/$id/view'
      fullPath: '/ventes/tarifs/taxes/$id/view'
      preLoaderRoute: typeof AppVentesTarifsTaxesIdViewRouteImport
      parentRoute: typeof AppVentesRouteRoute
    }
    '/_app/rh/contrats/$id/avenants/$avenantId/edit': {
      id: '/_app/rh/contrats/$id/avenants/$avenantId/edit'
      path: '/$id/avenants/$avenantId/edit'
      fullPath: '/rh/contrats/$id/avenants/$avenantId/edit'
      preLoaderRoute: typeof AppRhContratsIdAvenantsAvenantIdEditRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
    '/_app/rh/contrats/$id/avenants/$avenantId/view': {
      id: '/_app/rh/contrats/$id/avenants/$avenantId/view'
      path: '/$id/avenants/$avenantId/view'
      fullPath: '/rh/contrats/$id/avenants/$avenantId/view'
      preLoaderRoute: typeof AppRhContratsIdAvenantsAvenantIdViewRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
  }
}

interface AppdashboardRouteRouteChildren {
  AppdashboardIndexRoute: typeof AppdashboardIndexRoute
  AppdashboardCongesNouvelleDemandeRoute: typeof AppdashboardCongesNouvelleDemandeRoute
  AppdashboardFraisCreateRoute: typeof AppdashboardFraisCreateRoute
  AppdashboardFraisIndexRoute: typeof AppdashboardFraisIndexRoute
  AppdashboardMesCongesIndexRoute: typeof AppdashboardMesCongesIndexRoute
  AppdashboardProfileIndexRoute: typeof AppdashboardProfileIndexRoute
  AppdashboardFraisIdEditRoute: typeof AppdashboardFraisIdEditRoute
  AppdashboardFraisIdViewRoute: typeof AppdashboardFraisIdViewRoute
  AppdashboardCongesMeIndexRoute: typeof AppdashboardCongesMeIndexRoute
  AppdashboardContratsMeIndexRoute: typeof AppdashboardContratsMeIndexRoute
  AppdashboardDocumentsMeIndexRoute: typeof AppdashboardDocumentsMeIndexRoute
  AppdashboardFraisMeIndexRoute: typeof AppdashboardFraisMeIndexRoute
  AppdashboardPlanningMeIndexRoute: typeof AppdashboardPlanningMeIndexRoute
  AppdashboardPointageMeIndexRoute: typeof AppdashboardPointageMeIndexRoute
}

const AppdashboardRouteRouteChildren: AppdashboardRouteRouteChildren = {
  AppdashboardIndexRoute: AppdashboardIndexRoute,
  AppdashboardCongesNouvelleDemandeRoute:
    AppdashboardCongesNouvelleDemandeRoute,
  AppdashboardFraisCreateRoute: AppdashboardFraisCreateRoute,
  AppdashboardFraisIndexRoute: AppdashboardFraisIndexRoute,
  AppdashboardMesCongesIndexRoute: AppdashboardMesCongesIndexRoute,
  AppdashboardProfileIndexRoute: AppdashboardProfileIndexRoute,
  AppdashboardFraisIdEditRoute: AppdashboardFraisIdEditRoute,
  AppdashboardFraisIdViewRoute: AppdashboardFraisIdViewRoute,
  AppdashboardCongesMeIndexRoute: AppdashboardCongesMeIndexRoute,
  AppdashboardContratsMeIndexRoute: AppdashboardContratsMeIndexRoute,
  AppdashboardDocumentsMeIndexRoute: AppdashboardDocumentsMeIndexRoute,
  AppdashboardFraisMeIndexRoute: AppdashboardFraisMeIndexRoute,
  AppdashboardPlanningMeIndexRoute: AppdashboardPlanningMeIndexRoute,
  AppdashboardPointageMeIndexRoute: AppdashboardPointageMeIndexRoute,
}

const AppdashboardRouteRouteWithChildren =
  AppdashboardRouteRoute._addFileChildren(AppdashboardRouteRouteChildren)

interface AppAchatsRouteRouteChildren {
  AppAchatsIndexRoute: typeof AppAchatsIndexRoute
  AppAchatsCommandesCreateRoute: typeof AppAchatsCommandesCreateRoute
  AppAchatsFacturesCreateRoute: typeof AppAchatsFacturesCreateRoute
  AppAchatsFournisseursCreateRoute: typeof AppAchatsFournisseursCreateRoute
  AppAchatsFournituresCreateRoute: typeof AppAchatsFournituresCreateRoute
  AppAchatsPrestationsCreateRoute: typeof AppAchatsPrestationsCreateRoute
  AppAchatsReceptionsCreateRoute: typeof AppAchatsReceptionsCreateRoute
  AppAchatsCommandesIndexRoute: typeof AppAchatsCommandesIndexRoute
  AppAchatsFacturesIndexRoute: typeof AppAchatsFacturesIndexRoute
  AppAchatsFournisseursIndexRoute: typeof AppAchatsFournisseursIndexRoute
  AppAchatsFournituresIndexRoute: typeof AppAchatsFournituresIndexRoute
  AppAchatsPrestationsIndexRoute: typeof AppAchatsPrestationsIndexRoute
  AppAchatsReceptionsIndexRoute: typeof AppAchatsReceptionsIndexRoute
  AppAchatsCommandesIdEditRoute: typeof AppAchatsCommandesIdEditRoute
  AppAchatsCommandesIdViewRoute: typeof AppAchatsCommandesIdViewRoute
  AppAchatsFacturesIdEditRoute: typeof AppAchatsFacturesIdEditRoute
  AppAchatsFacturesIdViewRoute: typeof AppAchatsFacturesIdViewRoute
  AppAchatsFournisseursIdEditRoute: typeof AppAchatsFournisseursIdEditRoute
  AppAchatsFournisseursIdViewRoute: typeof AppAchatsFournisseursIdViewRoute
  AppAchatsFournituresIdEditRoute: typeof AppAchatsFournituresIdEditRoute
  AppAchatsFournituresIdViewRoute: typeof AppAchatsFournituresIdViewRoute
  AppAchatsPrestationsIdEditRoute: typeof AppAchatsPrestationsIdEditRoute
  AppAchatsPrestationsIdViewRoute: typeof AppAchatsPrestationsIdViewRoute
  AppAchatsReceptionsIdEditRoute: typeof AppAchatsReceptionsIdEditRoute
  AppAchatsReceptionsIdViewRoute: typeof AppAchatsReceptionsIdViewRoute
}

const AppAchatsRouteRouteChildren: AppAchatsRouteRouteChildren = {
  AppAchatsIndexRoute: AppAchatsIndexRoute,
  AppAchatsCommandesCreateRoute: AppAchatsCommandesCreateRoute,
  AppAchatsFacturesCreateRoute: AppAchatsFacturesCreateRoute,
  AppAchatsFournisseursCreateRoute: AppAchatsFournisseursCreateRoute,
  AppAchatsFournituresCreateRoute: AppAchatsFournituresCreateRoute,
  AppAchatsPrestationsCreateRoute: AppAchatsPrestationsCreateRoute,
  AppAchatsReceptionsCreateRoute: AppAchatsReceptionsCreateRoute,
  AppAchatsCommandesIndexRoute: AppAchatsCommandesIndexRoute,
  AppAchatsFacturesIndexRoute: AppAchatsFacturesIndexRoute,
  AppAchatsFournisseursIndexRoute: AppAchatsFournisseursIndexRoute,
  AppAchatsFournituresIndexRoute: AppAchatsFournituresIndexRoute,
  AppAchatsPrestationsIndexRoute: AppAchatsPrestationsIndexRoute,
  AppAchatsReceptionsIndexRoute: AppAchatsReceptionsIndexRoute,
  AppAchatsCommandesIdEditRoute: AppAchatsCommandesIdEditRoute,
  AppAchatsCommandesIdViewRoute: AppAchatsCommandesIdViewRoute,
  AppAchatsFacturesIdEditRoute: AppAchatsFacturesIdEditRoute,
  AppAchatsFacturesIdViewRoute: AppAchatsFacturesIdViewRoute,
  AppAchatsFournisseursIdEditRoute: AppAchatsFournisseursIdEditRoute,
  AppAchatsFournisseursIdViewRoute: AppAchatsFournisseursIdViewRoute,
  AppAchatsFournituresIdEditRoute: AppAchatsFournituresIdEditRoute,
  AppAchatsFournituresIdViewRoute: AppAchatsFournituresIdViewRoute,
  AppAchatsPrestationsIdEditRoute: AppAchatsPrestationsIdEditRoute,
  AppAchatsPrestationsIdViewRoute: AppAchatsPrestationsIdViewRoute,
  AppAchatsReceptionsIdEditRoute: AppAchatsReceptionsIdEditRoute,
  AppAchatsReceptionsIdViewRoute: AppAchatsReceptionsIdViewRoute,
}

const AppAchatsRouteRouteWithChildren = AppAchatsRouteRoute._addFileChildren(
  AppAchatsRouteRouteChildren,
)

interface AppAdminRouteRouteChildren {
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminProfilesCreateRoute: typeof AppAdminProfilesCreateRoute
  AppAdminPermissionsIndexRoute: typeof AppAdminPermissionsIndexRoute
  AppAdminProfilesIndexRoute: typeof AppAdminProfilesIndexRoute
  AppAdminReferenceDataIndexRoute: typeof AppAdminReferenceDataIndexRoute
  AppAdminProfilesIdEditRoute: typeof AppAdminProfilesIdEditRoute
}

const AppAdminRouteRouteChildren: AppAdminRouteRouteChildren = {
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminProfilesCreateRoute: AppAdminProfilesCreateRoute,
  AppAdminPermissionsIndexRoute: AppAdminPermissionsIndexRoute,
  AppAdminProfilesIndexRoute: AppAdminProfilesIndexRoute,
  AppAdminReferenceDataIndexRoute: AppAdminReferenceDataIndexRoute,
  AppAdminProfilesIdEditRoute: AppAdminProfilesIdEditRoute,
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(
  AppAdminRouteRouteChildren,
)

interface AppComptabiliteRouteRouteChildren {
  AppComptabiliteIndexRoute: typeof AppComptabiliteIndexRoute
  AppComptabiliteEcheancesIndexRoute: typeof AppComptabiliteEcheancesIndexRoute
  AppComptabiliteEcotaxesIndexRoute: typeof AppComptabiliteEcotaxesIndexRoute
  AppComptabiliteFacturesFournisseursIndexRoute: typeof AppComptabiliteFacturesFournisseursIndexRoute
  AppComptabiliteFacturesVentesIndexRoute: typeof AppComptabiliteFacturesVentesIndexRoute
  AppComptabiliteRelancesIndexRoute: typeof AppComptabiliteRelancesIndexRoute
  AppComptabiliteSimplifieeIndexRoute: typeof AppComptabiliteSimplifieeIndexRoute
  AppComptabiliteFacturesFournisseursIdViewRoute: typeof AppComptabiliteFacturesFournisseursIdViewRoute
  AppComptabiliteFacturesVentesIdViewRoute: typeof AppComptabiliteFacturesVentesIdViewRoute
  AppComptabiliteRelancesIdViewRoute: typeof AppComptabiliteRelancesIdViewRoute
}

const AppComptabiliteRouteRouteChildren: AppComptabiliteRouteRouteChildren = {
  AppComptabiliteIndexRoute: AppComptabiliteIndexRoute,
  AppComptabiliteEcheancesIndexRoute: AppComptabiliteEcheancesIndexRoute,
  AppComptabiliteEcotaxesIndexRoute: AppComptabiliteEcotaxesIndexRoute,
  AppComptabiliteFacturesFournisseursIndexRoute:
    AppComptabiliteFacturesFournisseursIndexRoute,
  AppComptabiliteFacturesVentesIndexRoute:
    AppComptabiliteFacturesVentesIndexRoute,
  AppComptabiliteRelancesIndexRoute: AppComptabiliteRelancesIndexRoute,
  AppComptabiliteSimplifieeIndexRoute: AppComptabiliteSimplifieeIndexRoute,
  AppComptabiliteFacturesFournisseursIdViewRoute:
    AppComptabiliteFacturesFournisseursIdViewRoute,
  AppComptabiliteFacturesVentesIdViewRoute:
    AppComptabiliteFacturesVentesIdViewRoute,
  AppComptabiliteRelancesIdViewRoute: AppComptabiliteRelancesIdViewRoute,
}

const AppComptabiliteRouteRouteWithChildren =
  AppComptabiliteRouteRoute._addFileChildren(AppComptabiliteRouteRouteChildren)

interface AppCreationArticlesRouteRouteChildren {
  AppCreationArticlesCreateRoute: typeof AppCreationArticlesCreateRoute
  AppCreationArticlesIndexRoute: typeof AppCreationArticlesIndexRoute
  AppCreationArticlesIdEditRoute: typeof AppCreationArticlesIdEditRoute
  AppCreationArticlesIdViewRoute: typeof AppCreationArticlesIdViewRoute
}

const AppCreationArticlesRouteRouteChildren: AppCreationArticlesRouteRouteChildren =
  {
    AppCreationArticlesCreateRoute: AppCreationArticlesCreateRoute,
    AppCreationArticlesIndexRoute: AppCreationArticlesIndexRoute,
    AppCreationArticlesIdEditRoute: AppCreationArticlesIdEditRoute,
    AppCreationArticlesIdViewRoute: AppCreationArticlesIdViewRoute,
  }

const AppCreationArticlesRouteRouteWithChildren =
  AppCreationArticlesRouteRoute._addFileChildren(
    AppCreationArticlesRouteRouteChildren,
  )

interface AppCreationAteliersRouteRouteChildren {
  AppCreationAteliersCreateRoute: typeof AppCreationAteliersCreateRoute
  AppCreationAteliersIndexRoute: typeof AppCreationAteliersIndexRoute
  AppCreationAteliersIdEditRoute: typeof AppCreationAteliersIdEditRoute
  AppCreationAteliersIdViewRoute: typeof AppCreationAteliersIdViewRoute
}

const AppCreationAteliersRouteRouteChildren: AppCreationAteliersRouteRouteChildren =
  {
    AppCreationAteliersCreateRoute: AppCreationAteliersCreateRoute,
    AppCreationAteliersIndexRoute: AppCreationAteliersIndexRoute,
    AppCreationAteliersIdEditRoute: AppCreationAteliersIdEditRoute,
    AppCreationAteliersIdViewRoute: AppCreationAteliersIdViewRoute,
  }

const AppCreationAteliersRouteRouteWithChildren =
  AppCreationAteliersRouteRoute._addFileChildren(
    AppCreationAteliersRouteRouteChildren,
  )

interface AppCreationDossierTechniquesRouteRouteChildren {
  AppCreationDossierTechniquesCreateRoute: typeof AppCreationDossierTechniquesCreateRoute
  AppCreationDossierTechniquesIndexRoute: typeof AppCreationDossierTechniquesIndexRoute
  AppCreationDossierTechniquesIdEditRoute: typeof AppCreationDossierTechniquesIdEditRoute
  AppCreationDossierTechniquesIdViewRoute: typeof AppCreationDossierTechniquesIdViewRoute
}

const AppCreationDossierTechniquesRouteRouteChildren: AppCreationDossierTechniquesRouteRouteChildren =
  {
    AppCreationDossierTechniquesCreateRoute:
      AppCreationDossierTechniquesCreateRoute,
    AppCreationDossierTechniquesIndexRoute:
      AppCreationDossierTechniquesIndexRoute,
    AppCreationDossierTechniquesIdEditRoute:
      AppCreationDossierTechniquesIdEditRoute,
    AppCreationDossierTechniquesIdViewRoute:
      AppCreationDossierTechniquesIdViewRoute,
  }

const AppCreationDossierTechniquesRouteRouteWithChildren =
  AppCreationDossierTechniquesRouteRoute._addFileChildren(
    AppCreationDossierTechniquesRouteRouteChildren,
  )

interface AppCreationFamilleArticlesRouteRouteChildren {
  AppCreationFamilleArticlesCreateRoute: typeof AppCreationFamilleArticlesCreateRoute
  AppCreationFamilleArticlesIndexRoute: typeof AppCreationFamilleArticlesIndexRoute
  AppCreationFamilleArticlesIdEditRoute: typeof AppCreationFamilleArticlesIdEditRoute
  AppCreationFamilleArticlesIdViewRoute: typeof AppCreationFamilleArticlesIdViewRoute
}

const AppCreationFamilleArticlesRouteRouteChildren: AppCreationFamilleArticlesRouteRouteChildren =
  {
    AppCreationFamilleArticlesCreateRoute:
      AppCreationFamilleArticlesCreateRoute,
    AppCreationFamilleArticlesIndexRoute: AppCreationFamilleArticlesIndexRoute,
    AppCreationFamilleArticlesIdEditRoute:
      AppCreationFamilleArticlesIdEditRoute,
    AppCreationFamilleArticlesIdViewRoute:
      AppCreationFamilleArticlesIdViewRoute,
  }

const AppCreationFamilleArticlesRouteRouteWithChildren =
  AppCreationFamilleArticlesRouteRoute._addFileChildren(
    AppCreationFamilleArticlesRouteRouteChildren,
  )

interface AppCreationLdfRouteRouteChildren {
  AppCreationLdfCreateRoute: typeof AppCreationLdfCreateRoute
  AppCreationLdfIndexRoute: typeof AppCreationLdfIndexRoute
  AppCreationLdfIdEditRoute: typeof AppCreationLdfIdEditRoute
  AppCreationLdfIdViewRoute: typeof AppCreationLdfIdViewRoute
}

const AppCreationLdfRouteRouteChildren: AppCreationLdfRouteRouteChildren = {
  AppCreationLdfCreateRoute: AppCreationLdfCreateRoute,
  AppCreationLdfIndexRoute: AppCreationLdfIndexRoute,
  AppCreationLdfIdEditRoute: AppCreationLdfIdEditRoute,
  AppCreationLdfIdViewRoute: AppCreationLdfIdViewRoute,
}

const AppCreationLdfRouteRouteWithChildren =
  AppCreationLdfRouteRoute._addFileChildren(AppCreationLdfRouteRouteChildren)

interface AppCreationPostesRouteRouteChildren {
  AppCreationPostesCreateRoute: typeof AppCreationPostesCreateRoute
  AppCreationPostesIndexRoute: typeof AppCreationPostesIndexRoute
  AppCreationPostesIdEditRoute: typeof AppCreationPostesIdEditRoute
  AppCreationPostesIdViewRoute: typeof AppCreationPostesIdViewRoute
}

const AppCreationPostesRouteRouteChildren: AppCreationPostesRouteRouteChildren =
  {
    AppCreationPostesCreateRoute: AppCreationPostesCreateRoute,
    AppCreationPostesIndexRoute: AppCreationPostesIndexRoute,
    AppCreationPostesIdEditRoute: AppCreationPostesIdEditRoute,
    AppCreationPostesIdViewRoute: AppCreationPostesIdViewRoute,
  }

const AppCreationPostesRouteRouteWithChildren =
  AppCreationPostesRouteRoute._addFileChildren(
    AppCreationPostesRouteRouteChildren,
  )

interface AppCreationPrestationsRouteRouteChildren {
  AppCreationPrestationsCreateRoute: typeof AppCreationPrestationsCreateRoute
  AppCreationPrestationsIndexRoute: typeof AppCreationPrestationsIndexRoute
  AppCreationPrestationsIdEditRoute: typeof AppCreationPrestationsIdEditRoute
  AppCreationPrestationsIdViewRoute: typeof AppCreationPrestationsIdViewRoute
}

const AppCreationPrestationsRouteRouteChildren: AppCreationPrestationsRouteRouteChildren =
  {
    AppCreationPrestationsCreateRoute: AppCreationPrestationsCreateRoute,
    AppCreationPrestationsIndexRoute: AppCreationPrestationsIndexRoute,
    AppCreationPrestationsIdEditRoute: AppCreationPrestationsIdEditRoute,
    AppCreationPrestationsIdViewRoute: AppCreationPrestationsIdViewRoute,
  }

const AppCreationPrestationsRouteRouteWithChildren =
  AppCreationPrestationsRouteRoute._addFileChildren(
    AppCreationPrestationsRouteRouteChildren,
  )

interface AppCreationUniversCommerciauxRouteRouteChildren {
  AppCreationUniversCommerciauxCreateRoute: typeof AppCreationUniversCommerciauxCreateRoute
  AppCreationUniversCommerciauxIndexRoute: typeof AppCreationUniversCommerciauxIndexRoute
  AppCreationUniversCommerciauxIdEditRoute: typeof AppCreationUniversCommerciauxIdEditRoute
  AppCreationUniversCommerciauxIdViewRoute: typeof AppCreationUniversCommerciauxIdViewRoute
}

const AppCreationUniversCommerciauxRouteRouteChildren: AppCreationUniversCommerciauxRouteRouteChildren =
  {
    AppCreationUniversCommerciauxCreateRoute:
      AppCreationUniversCommerciauxCreateRoute,
    AppCreationUniversCommerciauxIndexRoute:
      AppCreationUniversCommerciauxIndexRoute,
    AppCreationUniversCommerciauxIdEditRoute:
      AppCreationUniversCommerciauxIdEditRoute,
    AppCreationUniversCommerciauxIdViewRoute:
      AppCreationUniversCommerciauxIdViewRoute,
  }

const AppCreationUniversCommerciauxRouteRouteWithChildren =
  AppCreationUniversCommerciauxRouteRoute._addFileChildren(
    AppCreationUniversCommerciauxRouteRouteChildren,
  )

interface AppCreationRouteRouteChildren {
  AppCreationArticlesRouteRoute: typeof AppCreationArticlesRouteRouteWithChildren
  AppCreationAteliersRouteRoute: typeof AppCreationAteliersRouteRouteWithChildren
  AppCreationDossierTechniquesRouteRoute: typeof AppCreationDossierTechniquesRouteRouteWithChildren
  AppCreationFamilleArticlesRouteRoute: typeof AppCreationFamilleArticlesRouteRouteWithChildren
  AppCreationLdfRouteRoute: typeof AppCreationLdfRouteRouteWithChildren
  AppCreationPostesRouteRoute: typeof AppCreationPostesRouteRouteWithChildren
  AppCreationPrestationsRouteRoute: typeof AppCreationPrestationsRouteRouteWithChildren
  AppCreationUniversCommerciauxRouteRoute: typeof AppCreationUniversCommerciauxRouteRouteWithChildren
  AppCreationIndexRoute: typeof AppCreationIndexRoute
}

const AppCreationRouteRouteChildren: AppCreationRouteRouteChildren = {
  AppCreationArticlesRouteRoute: AppCreationArticlesRouteRouteWithChildren,
  AppCreationAteliersRouteRoute: AppCreationAteliersRouteRouteWithChildren,
  AppCreationDossierTechniquesRouteRoute:
    AppCreationDossierTechniquesRouteRouteWithChildren,
  AppCreationFamilleArticlesRouteRoute:
    AppCreationFamilleArticlesRouteRouteWithChildren,
  AppCreationLdfRouteRoute: AppCreationLdfRouteRouteWithChildren,
  AppCreationPostesRouteRoute: AppCreationPostesRouteRouteWithChildren,
  AppCreationPrestationsRouteRoute:
    AppCreationPrestationsRouteRouteWithChildren,
  AppCreationUniversCommerciauxRouteRoute:
    AppCreationUniversCommerciauxRouteRouteWithChildren,
  AppCreationIndexRoute: AppCreationIndexRoute,
}

const AppCreationRouteRouteWithChildren =
  AppCreationRouteRoute._addFileChildren(AppCreationRouteRouteChildren)

interface AppProductionCalculBesoinsRouteRouteChildren {
  AppProductionCalculBesoinsIndexRoute: typeof AppProductionCalculBesoinsIndexRoute
}

const AppProductionCalculBesoinsRouteRouteChildren: AppProductionCalculBesoinsRouteRouteChildren =
  {
    AppProductionCalculBesoinsIndexRoute: AppProductionCalculBesoinsIndexRoute,
  }

const AppProductionCalculBesoinsRouteRouteWithChildren =
  AppProductionCalculBesoinsRouteRoute._addFileChildren(
    AppProductionCalculBesoinsRouteRouteChildren,
  )

interface AppProductionClotureRouteRouteChildren {
  AppProductionClotureIndexRoute: typeof AppProductionClotureIndexRoute
}

const AppProductionClotureRouteRouteChildren: AppProductionClotureRouteRouteChildren =
  {
    AppProductionClotureIndexRoute: AppProductionClotureIndexRoute,
  }

const AppProductionClotureRouteRouteWithChildren =
  AppProductionClotureRouteRoute._addFileChildren(
    AppProductionClotureRouteRouteChildren,
  )

interface AppProductionDeclarationsRouteRouteChildren {
  AppProductionDeclarationsIndexRoute: typeof AppProductionDeclarationsIndexRoute
}

const AppProductionDeclarationsRouteRouteChildren: AppProductionDeclarationsRouteRouteChildren =
  {
    AppProductionDeclarationsIndexRoute: AppProductionDeclarationsIndexRoute,
  }

const AppProductionDeclarationsRouteRouteWithChildren =
  AppProductionDeclarationsRouteRoute._addFileChildren(
    AppProductionDeclarationsRouteRouteChildren,
  )

interface AppProductionLancementsRouteRouteChildren {
  AppProductionLancementsCreateRoute: typeof AppProductionLancementsCreateRoute
  AppProductionLancementsIndexRoute: typeof AppProductionLancementsIndexRoute
  AppProductionLancementsIdEditRoute: typeof AppProductionLancementsIdEditRoute
  AppProductionLancementsIdIndexRoute: typeof AppProductionLancementsIdIndexRoute
}

const AppProductionLancementsRouteRouteChildren: AppProductionLancementsRouteRouteChildren =
  {
    AppProductionLancementsCreateRoute: AppProductionLancementsCreateRoute,
    AppProductionLancementsIndexRoute: AppProductionLancementsIndexRoute,
    AppProductionLancementsIdEditRoute: AppProductionLancementsIdEditRoute,
    AppProductionLancementsIdIndexRoute: AppProductionLancementsIdIndexRoute,
  }

const AppProductionLancementsRouteRouteWithChildren =
  AppProductionLancementsRouteRoute._addFileChildren(
    AppProductionLancementsRouteRouteChildren,
  )

interface AppProductionOrdresFabricationRouteRouteChildren {
  AppProductionOrdresFabricationCreateRoute: typeof AppProductionOrdresFabricationCreateRoute
  AppProductionOrdresFabricationIndexRoute: typeof AppProductionOrdresFabricationIndexRoute
  AppProductionOrdresFabricationIdEditRoute: typeof AppProductionOrdresFabricationIdEditRoute
  AppProductionOrdresFabricationIdIndexRoute: typeof AppProductionOrdresFabricationIdIndexRoute
}

const AppProductionOrdresFabricationRouteRouteChildren: AppProductionOrdresFabricationRouteRouteChildren =
  {
    AppProductionOrdresFabricationCreateRoute:
      AppProductionOrdresFabricationCreateRoute,
    AppProductionOrdresFabricationIndexRoute:
      AppProductionOrdresFabricationIndexRoute,
    AppProductionOrdresFabricationIdEditRoute:
      AppProductionOrdresFabricationIdEditRoute,
    AppProductionOrdresFabricationIdIndexRoute:
      AppProductionOrdresFabricationIdIndexRoute,
  }

const AppProductionOrdresFabricationRouteRouteWithChildren =
  AppProductionOrdresFabricationRouteRoute._addFileChildren(
    AppProductionOrdresFabricationRouteRouteChildren,
  )

interface AppProductionRouteRouteChildren {
  AppProductionCalculBesoinsRouteRoute: typeof AppProductionCalculBesoinsRouteRouteWithChildren
  AppProductionClotureRouteRoute: typeof AppProductionClotureRouteRouteWithChildren
  AppProductionDeclarationsRouteRoute: typeof AppProductionDeclarationsRouteRouteWithChildren
  AppProductionLancementsRouteRoute: typeof AppProductionLancementsRouteRouteWithChildren
  AppProductionOrdresFabricationRouteRoute: typeof AppProductionOrdresFabricationRouteRouteWithChildren
  AppProductionIndexRoute: typeof AppProductionIndexRoute
}

const AppProductionRouteRouteChildren: AppProductionRouteRouteChildren = {
  AppProductionCalculBesoinsRouteRoute:
    AppProductionCalculBesoinsRouteRouteWithChildren,
  AppProductionClotureRouteRoute: AppProductionClotureRouteRouteWithChildren,
  AppProductionDeclarationsRouteRoute:
    AppProductionDeclarationsRouteRouteWithChildren,
  AppProductionLancementsRouteRoute:
    AppProductionLancementsRouteRouteWithChildren,
  AppProductionOrdresFabricationRouteRoute:
    AppProductionOrdresFabricationRouteRouteWithChildren,
  AppProductionIndexRoute: AppProductionIndexRoute,
}

const AppProductionRouteRouteWithChildren =
  AppProductionRouteRoute._addFileChildren(AppProductionRouteRouteChildren)

interface AppRhCollaborateursRouteRouteChildren {
  AppRhCollaborateursCreateRoute: typeof AppRhCollaborateursCreateRoute
  AppRhCollaborateursIndexRoute: typeof AppRhCollaborateursIndexRoute
  AppRhCollaborateursIdViewRouteRoute: typeof AppRhCollaborateursIdViewRouteRoute
  AppRhCollaborateursIdEditRoute: typeof AppRhCollaborateursIdEditRoute
  AppRhCollaborateursIdIndexRoute: typeof AppRhCollaborateursIdIndexRoute
}

const AppRhCollaborateursRouteRouteChildren: AppRhCollaborateursRouteRouteChildren =
  {
    AppRhCollaborateursCreateRoute: AppRhCollaborateursCreateRoute,
    AppRhCollaborateursIndexRoute: AppRhCollaborateursIndexRoute,
    AppRhCollaborateursIdViewRouteRoute: AppRhCollaborateursIdViewRouteRoute,
    AppRhCollaborateursIdEditRoute: AppRhCollaborateursIdEditRoute,
    AppRhCollaborateursIdIndexRoute: AppRhCollaborateursIdIndexRoute,
  }

const AppRhCollaborateursRouteRouteWithChildren =
  AppRhCollaborateursRouteRoute._addFileChildren(
    AppRhCollaborateursRouteRouteChildren,
  )

interface AppRhCompetencesRouteRouteChildren {
  AppRhCompetencesCreateRoute: typeof AppRhCompetencesCreateRoute
  AppRhCompetencesIndexRoute: typeof AppRhCompetencesIndexRoute
  AppRhCompetencesIdEditRoute: typeof AppRhCompetencesIdEditRoute
  AppRhCompetencesIdViewRoute: typeof AppRhCompetencesIdViewRoute
}

const AppRhCompetencesRouteRouteChildren: AppRhCompetencesRouteRouteChildren = {
  AppRhCompetencesCreateRoute: AppRhCompetencesCreateRoute,
  AppRhCompetencesIndexRoute: AppRhCompetencesIndexRoute,
  AppRhCompetencesIdEditRoute: AppRhCompetencesIdEditRoute,
  AppRhCompetencesIdViewRoute: AppRhCompetencesIdViewRoute,
}

const AppRhCompetencesRouteRouteWithChildren =
  AppRhCompetencesRouteRoute._addFileChildren(
    AppRhCompetencesRouteRouteChildren,
  )

interface AppRhCongesRouteRouteChildren {
  AppRhCongesCreateRoute: typeof AppRhCongesCreateRoute
  AppRhCongesIndexRoute: typeof AppRhCongesIndexRoute
  AppRhCongesIdViewRoute: typeof AppRhCongesIdViewRoute
  AppRhCongesDemandesNewRoute: typeof AppRhCongesDemandesNewRoute
}

const AppRhCongesRouteRouteChildren: AppRhCongesRouteRouteChildren = {
  AppRhCongesCreateRoute: AppRhCongesCreateRoute,
  AppRhCongesIndexRoute: AppRhCongesIndexRoute,
  AppRhCongesIdViewRoute: AppRhCongesIdViewRoute,
  AppRhCongesDemandesNewRoute: AppRhCongesDemandesNewRoute,
}

const AppRhCongesRouteRouteWithChildren =
  AppRhCongesRouteRoute._addFileChildren(AppRhCongesRouteRouteChildren)

interface AppRhContratsRouteRouteChildren {
  AppRhContratsCreateRoute: typeof AppRhContratsCreateRoute
  AppRhContratsIndexRoute: typeof AppRhContratsIndexRoute
  AppRhContratsIdEditRoute: typeof AppRhContratsIdEditRoute
  AppRhContratsIdViewRoute: typeof AppRhContratsIdViewRoute
  AppRhContratsIdAvenantsCreateRoute: typeof AppRhContratsIdAvenantsCreateRoute
  AppRhContratsIdAvenantsAvenantIdEditRoute: typeof AppRhContratsIdAvenantsAvenantIdEditRoute
  AppRhContratsIdAvenantsAvenantIdViewRoute: typeof AppRhContratsIdAvenantsAvenantIdViewRoute
}

const AppRhContratsRouteRouteChildren: AppRhContratsRouteRouteChildren = {
  AppRhContratsCreateRoute: AppRhContratsCreateRoute,
  AppRhContratsIndexRoute: AppRhContratsIndexRoute,
  AppRhContratsIdEditRoute: AppRhContratsIdEditRoute,
  AppRhContratsIdViewRoute: AppRhContratsIdViewRoute,
  AppRhContratsIdAvenantsCreateRoute: AppRhContratsIdAvenantsCreateRoute,
  AppRhContratsIdAvenantsAvenantIdEditRoute:
    AppRhContratsIdAvenantsAvenantIdEditRoute,
  AppRhContratsIdAvenantsAvenantIdViewRoute:
    AppRhContratsIdAvenantsAvenantIdViewRoute,
}

const AppRhContratsRouteRouteWithChildren =
  AppRhContratsRouteRoute._addFileChildren(AppRhContratsRouteRouteChildren)

interface AppRhDocumentsRouteRouteChildren {
  AppRhDocumentsIndexRoute: typeof AppRhDocumentsIndexRoute
}

const AppRhDocumentsRouteRouteChildren: AppRhDocumentsRouteRouteChildren = {
  AppRhDocumentsIndexRoute: AppRhDocumentsIndexRoute,
}

const AppRhDocumentsRouteRouteWithChildren =
  AppRhDocumentsRouteRoute._addFileChildren(AppRhDocumentsRouteRouteChildren)

interface AppRhFeuillesDeTempsRouteRouteChildren {
  AppRhFeuillesDeTempsIndexRoute: typeof AppRhFeuillesDeTempsIndexRoute
}

const AppRhFeuillesDeTempsRouteRouteChildren: AppRhFeuillesDeTempsRouteRouteChildren =
  {
    AppRhFeuillesDeTempsIndexRoute: AppRhFeuillesDeTempsIndexRoute,
  }

const AppRhFeuillesDeTempsRouteRouteWithChildren =
  AppRhFeuillesDeTempsRouteRoute._addFileChildren(
    AppRhFeuillesDeTempsRouteRouteChildren,
  )

interface AppRhHorairesDeTravailRouteRouteChildren {
  AppRhHorairesDeTravailCreateRoute: typeof AppRhHorairesDeTravailCreateRoute
  AppRhHorairesDeTravailIndexRoute: typeof AppRhHorairesDeTravailIndexRoute
  AppRhHorairesDeTravailIdEditRoute: typeof AppRhHorairesDeTravailIdEditRoute
  AppRhHorairesDeTravailIdViewRoute: typeof AppRhHorairesDeTravailIdViewRoute
}

const AppRhHorairesDeTravailRouteRouteChildren: AppRhHorairesDeTravailRouteRouteChildren =
  {
    AppRhHorairesDeTravailCreateRoute: AppRhHorairesDeTravailCreateRoute,
    AppRhHorairesDeTravailIndexRoute: AppRhHorairesDeTravailIndexRoute,
    AppRhHorairesDeTravailIdEditRoute: AppRhHorairesDeTravailIdEditRoute,
    AppRhHorairesDeTravailIdViewRoute: AppRhHorairesDeTravailIdViewRoute,
  }

const AppRhHorairesDeTravailRouteRouteWithChildren =
  AppRhHorairesDeTravailRouteRoute._addFileChildren(
    AppRhHorairesDeTravailRouteRouteChildren,
  )

interface AppRhPlanningRouteRouteChildren {
  AppRhPlanningCreateRoute: typeof AppRhPlanningCreateRoute
  AppRhPlanningIndexRoute: typeof AppRhPlanningIndexRoute
  AppRhPlanningIdEditRoute: typeof AppRhPlanningIdEditRoute
  AppRhPlanningIdViewRoute: typeof AppRhPlanningIdViewRoute
}

const AppRhPlanningRouteRouteChildren: AppRhPlanningRouteRouteChildren = {
  AppRhPlanningCreateRoute: AppRhPlanningCreateRoute,
  AppRhPlanningIndexRoute: AppRhPlanningIndexRoute,
  AppRhPlanningIdEditRoute: AppRhPlanningIdEditRoute,
  AppRhPlanningIdViewRoute: AppRhPlanningIdViewRoute,
}

const AppRhPlanningRouteRouteWithChildren =
  AppRhPlanningRouteRoute._addFileChildren(AppRhPlanningRouteRouteChildren)

interface AppRhRouteRouteChildren {
  AppRhCollaborateursRouteRoute: typeof AppRhCollaborateursRouteRouteWithChildren
  AppRhCompetencesRouteRoute: typeof AppRhCompetencesRouteRouteWithChildren
  AppRhCongesRouteRoute: typeof AppRhCongesRouteRouteWithChildren
  AppRhContratsRouteRoute: typeof AppRhContratsRouteRouteWithChildren
  AppRhDocumentsRouteRoute: typeof AppRhDocumentsRouteRouteWithChildren
  AppRhFeuillesDeTempsRouteRoute: typeof AppRhFeuillesDeTempsRouteRouteWithChildren
  AppRhHorairesDeTravailRouteRoute: typeof AppRhHorairesDeTravailRouteRouteWithChildren
  AppRhPlanningRouteRoute: typeof AppRhPlanningRouteRouteWithChildren
  AppRhIndexRoute: typeof AppRhIndexRoute
  AppRhNotesDeFraisCreateRoute: typeof AppRhNotesDeFraisCreateRoute
  AppRhNotesDeFraisIndexRoute: typeof AppRhNotesDeFraisIndexRoute
  AppRhNotesDeFraisIdEditRoute: typeof AppRhNotesDeFraisIdEditRoute
  AppRhNotesDeFraisIdViewRoute: typeof AppRhNotesDeFraisIdViewRoute
}

const AppRhRouteRouteChildren: AppRhRouteRouteChildren = {
  AppRhCollaborateursRouteRoute: AppRhCollaborateursRouteRouteWithChildren,
  AppRhCompetencesRouteRoute: AppRhCompetencesRouteRouteWithChildren,
  AppRhCongesRouteRoute: AppRhCongesRouteRouteWithChildren,
  AppRhContratsRouteRoute: AppRhContratsRouteRouteWithChildren,
  AppRhDocumentsRouteRoute: AppRhDocumentsRouteRouteWithChildren,
  AppRhFeuillesDeTempsRouteRoute: AppRhFeuillesDeTempsRouteRouteWithChildren,
  AppRhHorairesDeTravailRouteRoute:
    AppRhHorairesDeTravailRouteRouteWithChildren,
  AppRhPlanningRouteRoute: AppRhPlanningRouteRouteWithChildren,
  AppRhIndexRoute: AppRhIndexRoute,
  AppRhNotesDeFraisCreateRoute: AppRhNotesDeFraisCreateRoute,
  AppRhNotesDeFraisIndexRoute: AppRhNotesDeFraisIndexRoute,
  AppRhNotesDeFraisIdEditRoute: AppRhNotesDeFraisIdEditRoute,
  AppRhNotesDeFraisIdViewRoute: AppRhNotesDeFraisIdViewRoute,
}

const AppRhRouteRouteWithChildren = AppRhRouteRoute._addFileChildren(
  AppRhRouteRouteChildren,
)

interface AppStockConsultationRouteRouteChildren {
  AppStockConsultationIndexRoute: typeof AppStockConsultationIndexRoute
}

const AppStockConsultationRouteRouteChildren: AppStockConsultationRouteRouteChildren =
  {
    AppStockConsultationIndexRoute: AppStockConsultationIndexRoute,
  }

const AppStockConsultationRouteRouteWithChildren =
  AppStockConsultationRouteRoute._addFileChildren(
    AppStockConsultationRouteRouteChildren,
  )

interface AppStockDepotsRouteRouteChildren {
  AppStockDepotsCreateRoute: typeof AppStockDepotsCreateRoute
  AppStockDepotsIdEditRoute: typeof AppStockDepotsIdEditRoute
  AppStockDepotsIdViewRoute: typeof AppStockDepotsIdViewRoute
}

const AppStockDepotsRouteRouteChildren: AppStockDepotsRouteRouteChildren = {
  AppStockDepotsCreateRoute: AppStockDepotsCreateRoute,
  AppStockDepotsIdEditRoute: AppStockDepotsIdEditRoute,
  AppStockDepotsIdViewRoute: AppStockDepotsIdViewRoute,
}

const AppStockDepotsRouteRouteWithChildren =
  AppStockDepotsRouteRoute._addFileChildren(AppStockDepotsRouteRouteChildren)

interface AppStockEmplacementsRouteRouteChildren {
  AppStockEmplacementsCreateRoute: typeof AppStockEmplacementsCreateRoute
  AppStockEmplacementsIndexRoute: typeof AppStockEmplacementsIndexRoute
  AppStockEmplacementsIdEditRoute: typeof AppStockEmplacementsIdEditRoute
  AppStockEmplacementsIdViewRoute: typeof AppStockEmplacementsIdViewRoute
}

const AppStockEmplacementsRouteRouteChildren: AppStockEmplacementsRouteRouteChildren =
  {
    AppStockEmplacementsCreateRoute: AppStockEmplacementsCreateRoute,
    AppStockEmplacementsIndexRoute: AppStockEmplacementsIndexRoute,
    AppStockEmplacementsIdEditRoute: AppStockEmplacementsIdEditRoute,
    AppStockEmplacementsIdViewRoute: AppStockEmplacementsIdViewRoute,
  }

const AppStockEmplacementsRouteRouteWithChildren =
  AppStockEmplacementsRouteRoute._addFileChildren(
    AppStockEmplacementsRouteRouteChildren,
  )

interface AppStockInventairesRouteRouteChildren {
  AppStockInventairesCreateRoute: typeof AppStockInventairesCreateRoute
  AppStockInventairesIndexRoute: typeof AppStockInventairesIndexRoute
  AppStockInventairesIdEditRoute: typeof AppStockInventairesIdEditRoute
  AppStockInventairesIdViewRoute: typeof AppStockInventairesIdViewRoute
}

const AppStockInventairesRouteRouteChildren: AppStockInventairesRouteRouteChildren =
  {
    AppStockInventairesCreateRoute: AppStockInventairesCreateRoute,
    AppStockInventairesIndexRoute: AppStockInventairesIndexRoute,
    AppStockInventairesIdEditRoute: AppStockInventairesIdEditRoute,
    AppStockInventairesIdViewRoute: AppStockInventairesIdViewRoute,
  }

const AppStockInventairesRouteRouteWithChildren =
  AppStockInventairesRouteRoute._addFileChildren(
    AppStockInventairesRouteRouteChildren,
  )

interface AppStockMouvementsRouteRouteChildren {
  AppStockMouvementsCreateRoute: typeof AppStockMouvementsCreateRoute
  AppStockMouvementsIndexRoute: typeof AppStockMouvementsIndexRoute
  AppStockMouvementsIdEditRoute: typeof AppStockMouvementsIdEditRoute
  AppStockMouvementsIdViewRoute: typeof AppStockMouvementsIdViewRoute
}

const AppStockMouvementsRouteRouteChildren: AppStockMouvementsRouteRouteChildren =
  {
    AppStockMouvementsCreateRoute: AppStockMouvementsCreateRoute,
    AppStockMouvementsIndexRoute: AppStockMouvementsIndexRoute,
    AppStockMouvementsIdEditRoute: AppStockMouvementsIdEditRoute,
    AppStockMouvementsIdViewRoute: AppStockMouvementsIdViewRoute,
  }

const AppStockMouvementsRouteRouteWithChildren =
  AppStockMouvementsRouteRoute._addFileChildren(
    AppStockMouvementsRouteRouteChildren,
  )

interface AppStockZonesRouteRouteChildren {
  AppStockZonesCreateRoute: typeof AppStockZonesCreateRoute
  AppStockZonesIndexRoute: typeof AppStockZonesIndexRoute
  AppStockZonesIdEditRoute: typeof AppStockZonesIdEditRoute
  AppStockZonesIdViewRoute: typeof AppStockZonesIdViewRoute
}

const AppStockZonesRouteRouteChildren: AppStockZonesRouteRouteChildren = {
  AppStockZonesCreateRoute: AppStockZonesCreateRoute,
  AppStockZonesIndexRoute: AppStockZonesIndexRoute,
  AppStockZonesIdEditRoute: AppStockZonesIdEditRoute,
  AppStockZonesIdViewRoute: AppStockZonesIdViewRoute,
}

const AppStockZonesRouteRouteWithChildren =
  AppStockZonesRouteRoute._addFileChildren(AppStockZonesRouteRouteChildren)

interface AppStockRouteRouteChildren {
  AppStockConsultationRouteRoute: typeof AppStockConsultationRouteRouteWithChildren
  AppStockDepotsRouteRoute: typeof AppStockDepotsRouteRouteWithChildren
  AppStockEmplacementsRouteRoute: typeof AppStockEmplacementsRouteRouteWithChildren
  AppStockInventairesRouteRoute: typeof AppStockInventairesRouteRouteWithChildren
  AppStockMouvementsRouteRoute: typeof AppStockMouvementsRouteRouteWithChildren
  AppStockZonesRouteRoute: typeof AppStockZonesRouteRouteWithChildren
  AppStockIndexRoute: typeof AppStockIndexRoute
}

const AppStockRouteRouteChildren: AppStockRouteRouteChildren = {
  AppStockConsultationRouteRoute: AppStockConsultationRouteRouteWithChildren,
  AppStockDepotsRouteRoute: AppStockDepotsRouteRouteWithChildren,
  AppStockEmplacementsRouteRoute: AppStockEmplacementsRouteRouteWithChildren,
  AppStockInventairesRouteRoute: AppStockInventairesRouteRouteWithChildren,
  AppStockMouvementsRouteRoute: AppStockMouvementsRouteRouteWithChildren,
  AppStockZonesRouteRoute: AppStockZonesRouteRouteWithChildren,
  AppStockIndexRoute: AppStockIndexRoute,
}

const AppStockRouteRouteWithChildren = AppStockRouteRoute._addFileChildren(
  AppStockRouteRouteChildren,
)

interface AppTicketsRouteRouteChildren {
  AppTicketsCreateRoute: typeof AppTicketsCreateRoute
  AppTicketsIndexRoute: typeof AppTicketsIndexRoute
  AppTicketsIdEditRoute: typeof AppTicketsIdEditRoute
  AppTicketsIdViewRoute: typeof AppTicketsIdViewRoute
}

const AppTicketsRouteRouteChildren: AppTicketsRouteRouteChildren = {
  AppTicketsCreateRoute: AppTicketsCreateRoute,
  AppTicketsIndexRoute: AppTicketsIndexRoute,
  AppTicketsIdEditRoute: AppTicketsIdEditRoute,
  AppTicketsIdViewRoute: AppTicketsIdViewRoute,
}

const AppTicketsRouteRouteWithChildren = AppTicketsRouteRoute._addFileChildren(
  AppTicketsRouteRouteChildren,
)

interface AppVentesRouteRouteChildren {
  AppVentesIndexRoute: typeof AppVentesIndexRoute
  AppVentesCategoriesCreateRoute: typeof AppVentesCategoriesCreateRoute
  AppVentesClientsCreateRoute: typeof AppVentesClientsCreateRoute
  AppVentesCommandesCreateRoute: typeof AppVentesCommandesCreateRoute
  AppVentesCrmCreateRoute: typeof AppVentesCrmCreateRoute
  AppVentesExpeditionsCreateRoute: typeof AppVentesExpeditionsCreateRoute
  AppVentesFacturationCreateRoute: typeof AppVentesFacturationCreateRoute
  AppVentesTarifsCreateRoute: typeof AppVentesTarifsCreateRoute
  AppVentesCategoriesIndexRoute: typeof AppVentesCategoriesIndexRoute
  AppVentesClientsIndexRoute: typeof AppVentesClientsIndexRoute
  AppVentesCommandesIndexRoute: typeof AppVentesCommandesIndexRoute
  AppVentesCrmIndexRoute: typeof AppVentesCrmIndexRoute
  AppVentesExpeditionsIndexRoute: typeof AppVentesExpeditionsIndexRoute
  AppVentesFacturationIndexRoute: typeof AppVentesFacturationIndexRoute
  AppVentesTarifsIndexRoute: typeof AppVentesTarifsIndexRoute
  AppVentesCategoriesIdEditRoute: typeof AppVentesCategoriesIdEditRoute
  AppVentesCategoriesIdViewRoute: typeof AppVentesCategoriesIdViewRoute
  AppVentesClientsIdEditRoute: typeof AppVentesClientsIdEditRoute
  AppVentesClientsIdViewRoute: typeof AppVentesClientsIdViewRoute
  AppVentesCommandesIdEditRoute: typeof AppVentesCommandesIdEditRoute
  AppVentesCommandesIdViewRoute: typeof AppVentesCommandesIdViewRoute
  AppVentesCrmIdEditRoute: typeof AppVentesCrmIdEditRoute
  AppVentesCrmIdViewRoute: typeof AppVentesCrmIdViewRoute
  AppVentesExpeditionsIdEditRoute: typeof AppVentesExpeditionsIdEditRoute
  AppVentesExpeditionsIdViewRoute: typeof AppVentesExpeditionsIdViewRoute
  AppVentesFacturationIdEditRoute: typeof AppVentesFacturationIdEditRoute
  AppVentesFacturationIdViewRoute: typeof AppVentesFacturationIdViewRoute
  AppVentesTarifsIdEditRoute: typeof AppVentesTarifsIdEditRoute
  AppVentesTarifsIdViewRoute: typeof AppVentesTarifsIdViewRoute
  AppVentesTarifsPromotionsCreateRoute: typeof AppVentesTarifsPromotionsCreateRoute
  AppVentesTarifsRemisesCreateRoute: typeof AppVentesTarifsRemisesCreateRoute
  AppVentesTarifsTaxesCreateRoute: typeof AppVentesTarifsTaxesCreateRoute
  AppVentesTarifsPromotionsIdEditRoute: typeof AppVentesTarifsPromotionsIdEditRoute
  AppVentesTarifsPromotionsIdViewRoute: typeof AppVentesTarifsPromotionsIdViewRoute
  AppVentesTarifsRemisesIdEditRoute: typeof AppVentesTarifsRemisesIdEditRoute
  AppVentesTarifsRemisesIdViewRoute: typeof AppVentesTarifsRemisesIdViewRoute
  AppVentesTarifsTaxesIdEditRoute: typeof AppVentesTarifsTaxesIdEditRoute
  AppVentesTarifsTaxesIdViewRoute: typeof AppVentesTarifsTaxesIdViewRoute
}

const AppVentesRouteRouteChildren: AppVentesRouteRouteChildren = {
  AppVentesIndexRoute: AppVentesIndexRoute,
  AppVentesCategoriesCreateRoute: AppVentesCategoriesCreateRoute,
  AppVentesClientsCreateRoute: AppVentesClientsCreateRoute,
  AppVentesCommandesCreateRoute: AppVentesCommandesCreateRoute,
  AppVentesCrmCreateRoute: AppVentesCrmCreateRoute,
  AppVentesExpeditionsCreateRoute: AppVentesExpeditionsCreateRoute,
  AppVentesFacturationCreateRoute: AppVentesFacturationCreateRoute,
  AppVentesTarifsCreateRoute: AppVentesTarifsCreateRoute,
  AppVentesCategoriesIndexRoute: AppVentesCategoriesIndexRoute,
  AppVentesClientsIndexRoute: AppVentesClientsIndexRoute,
  AppVentesCommandesIndexRoute: AppVentesCommandesIndexRoute,
  AppVentesCrmIndexRoute: AppVentesCrmIndexRoute,
  AppVentesExpeditionsIndexRoute: AppVentesExpeditionsIndexRoute,
  AppVentesFacturationIndexRoute: AppVentesFacturationIndexRoute,
  AppVentesTarifsIndexRoute: AppVentesTarifsIndexRoute,
  AppVentesCategoriesIdEditRoute: AppVentesCategoriesIdEditRoute,
  AppVentesCategoriesIdViewRoute: AppVentesCategoriesIdViewRoute,
  AppVentesClientsIdEditRoute: AppVentesClientsIdEditRoute,
  AppVentesClientsIdViewRoute: AppVentesClientsIdViewRoute,
  AppVentesCommandesIdEditRoute: AppVentesCommandesIdEditRoute,
  AppVentesCommandesIdViewRoute: AppVentesCommandesIdViewRoute,
  AppVentesCrmIdEditRoute: AppVentesCrmIdEditRoute,
  AppVentesCrmIdViewRoute: AppVentesCrmIdViewRoute,
  AppVentesExpeditionsIdEditRoute: AppVentesExpeditionsIdEditRoute,
  AppVentesExpeditionsIdViewRoute: AppVentesExpeditionsIdViewRoute,
  AppVentesFacturationIdEditRoute: AppVentesFacturationIdEditRoute,
  AppVentesFacturationIdViewRoute: AppVentesFacturationIdViewRoute,
  AppVentesTarifsIdEditRoute: AppVentesTarifsIdEditRoute,
  AppVentesTarifsIdViewRoute: AppVentesTarifsIdViewRoute,
  AppVentesTarifsPromotionsCreateRoute: AppVentesTarifsPromotionsCreateRoute,
  AppVentesTarifsRemisesCreateRoute: AppVentesTarifsRemisesCreateRoute,
  AppVentesTarifsTaxesCreateRoute: AppVentesTarifsTaxesCreateRoute,
  AppVentesTarifsPromotionsIdEditRoute: AppVentesTarifsPromotionsIdEditRoute,
  AppVentesTarifsPromotionsIdViewRoute: AppVentesTarifsPromotionsIdViewRoute,
  AppVentesTarifsRemisesIdEditRoute: AppVentesTarifsRemisesIdEditRoute,
  AppVentesTarifsRemisesIdViewRoute: AppVentesTarifsRemisesIdViewRoute,
  AppVentesTarifsTaxesIdEditRoute: AppVentesTarifsTaxesIdEditRoute,
  AppVentesTarifsTaxesIdViewRoute: AppVentesTarifsTaxesIdViewRoute,
}

const AppVentesRouteRouteWithChildren = AppVentesRouteRoute._addFileChildren(
  AppVentesRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppdashboardRouteRoute: typeof AppdashboardRouteRouteWithChildren
  AppAchatsRouteRoute: typeof AppAchatsRouteRouteWithChildren
  AppAdminRouteRoute: typeof AppAdminRouteRouteWithChildren
  AppComptabiliteRouteRoute: typeof AppComptabiliteRouteRouteWithChildren
  AppCreationRouteRoute: typeof AppCreationRouteRouteWithChildren
  AppParametresRouteRoute: typeof AppParametresRouteRoute
  AppProductionRouteRoute: typeof AppProductionRouteRouteWithChildren
  AppRhRouteRoute: typeof AppRhRouteRouteWithChildren
  AppStockRouteRoute: typeof AppStockRouteRouteWithChildren
  AppTicketsRouteRoute: typeof AppTicketsRouteRouteWithChildren
  AppVentesRouteRoute: typeof AppVentesRouteRouteWithChildren
  AppDesignSystemShowcaseRoute: typeof AppDesignSystemShowcaseRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppdashboardRouteRoute: AppdashboardRouteRouteWithChildren,
  AppAchatsRouteRoute: AppAchatsRouteRouteWithChildren,
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,
  AppComptabiliteRouteRoute: AppComptabiliteRouteRouteWithChildren,
  AppCreationRouteRoute: AppCreationRouteRouteWithChildren,
  AppParametresRouteRoute: AppParametresRouteRoute,
  AppProductionRouteRoute: AppProductionRouteRouteWithChildren,
  AppRhRouteRoute: AppRhRouteRouteWithChildren,
  AppStockRouteRoute: AppStockRouteRouteWithChildren,
  AppTicketsRouteRoute: AppTicketsRouteRouteWithChildren,
  AppVentesRouteRoute: AppVentesRouteRouteWithChildren,
  AppDesignSystemShowcaseRoute: AppDesignSystemShowcaseRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSetupPasswordRoute: typeof AuthSetupPasswordRoute
  AuthPointageHashRoute: typeof AuthPointageHashRoute
  AuthPointageQrCodeRoute: typeof AuthPointageQrCodeRoute
  AuthSignatureContratTokenRoute: typeof AuthSignatureContratTokenRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSetupPasswordRoute: AuthSetupPasswordRoute,
  AuthPointageHashRoute: AuthPointageHashRoute,
  AuthPointageQrCodeRoute: AuthPointageQrCodeRoute,
  AuthSignatureContratTokenRoute: AuthSignatureContratTokenRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  MentionsLegalesRoute: MentionsLegalesRoute,
  PolitiqueConfidentialiteRoute: PolitiqueConfidentialiteRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
